function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*!
   JW Player version 8.26.7
   Copyright (c) 2023, JW Player, All Rights Reserved
   This source code and its use and distribution is subject to the terms
   and conditions of the applicable license agreement.
   https://www.jwplayer.com/tos/
   This product includes portions of other software. For the full text of licenses, see
   https://ssl.p.jwpcdn.com/player/v/8.26.7/notice.txt
*/
(function () {
  var e,
      t,
      n = {
    696: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return r;
        }
      });
      var r = {
        advertising: {
          admessage: "This ad will end in xx",
          cuetext: "Advertisement",
          displayHeading: "Advertisement",
          loadingAd: "Loading ad",
          podmessage: "Ad __AD_POD_CURRENT__ of __AD_POD_LENGTH__.",
          skipmessage: "Skip ad in xx",
          skiptext: "Skip"
        },
        airplay: "AirPlay",
        audioTracks: "Audio Tracks",
        auto: "Auto",
        buffer: "Loading",
        cast: "Chromecast",
        cc: "Closed Captions",
        close: "Close",
        errors: {
          badConnection: "This video cannot be played because of a problem with your internet connection.",
          cantLoadPlayer: "Sorry, the video player failed to load.",
          cantPlayInBrowser: "The video cannot be played in this browser.",
          cantPlayVideo: "This video file cannot be played.",
          errorCode: "Error Code",
          liveStreamDown: "The live stream is either down or has ended.",
          protectedContent: "There was a problem providing access to protected content.",
          technicalError: "This video cannot be played because of a technical error."
        },
        exitFullscreen: "Exit Fullscreen",
        fullscreen: "Fullscreen",
        hd: "Quality",
        liveBroadcast: "Live",
        logo: "Logo",
        mute: "Mute",
        next: "Next",
        nextUp: "Next Up",
        notLive: "Not Live",
        off: "Off",
        pause: "Pause",
        pipIcon: "Picture in Picture (PiP)",
        play: "Play",
        playback: "Play",
        playbackRates: "Playback Rates",
        player: "Video Player",
        poweredBy: "Powered by",
        prev: "Previous",
        related: {
          autoplaymessage: "Next up in xx",
          heading: "More Videos"
        },
        replay: "Replay",
        rewind: "Rewind 10 Seconds",
        settings: "Settings",
        sharing: {
          copied: "Copied",
          email: "Email",
          embed: "Embed",
          heading: "Share",
          link: "Link"
        },
        slider: "Seek",
        stop: "Stop",
        unmute: "Unmute",
        videoInfo: "About This Video",
        volume: "Volume",
        volumeSlider: "Volume",
        shortcuts: {
          playPause: "Play/Pause",
          volumeToggle: "Mute/Unmute",
          fullscreenToggle: "Fullscreen/Exit Fullscreen",
          seekPercent: "Seek %",
          keyboardShortcuts: "Keyboard Shortcuts",
          increaseVolume: "Increase Volume",
          decreaseVolume: "Decrease Volume",
          seekForward: "Seek Forward",
          seekBackward: "Seek Backward",
          spacebar: "SPACE",
          captionsToggle: "Captions On/Off"
        },
        captionsStyles: {
          subtitleSettings: "Subtitle Settings",
          color: "Font Color",
          fontOpacity: "Font Opacity",
          userFontScale: "Font Size",
          fontFamily: "Font Family",
          edgeStyle: "Character Edge",
          backgroundColor: "Background Color",
          backgroundOpacity: "Background Opacity",
          windowColor: "Window Color",
          windowOpacity: "Window Opacity",
          white: "White",
          black: "Black",
          red: "Red",
          green: "Green",
          blue: "Blue",
          yellow: "Yellow",
          magenta: "Magenta",
          cyan: "Cyan",
          none: "None",
          raised: "Raised",
          depressed: "Depressed",
          uniform: "Uniform",
          dropShadow: "Drop Shadow"
        },
        disabled: "Disabled",
        enabled: "Enabled",
        reset: "Reset"
      };
    },
    9128: function _(e, t, n) {
      "use strict";

      function r(e, t, n) {
        var r = [],
            i = {},
            o = function o() {
          for (; r.length > 0;) {
            var _r$shift = r.shift(),
                _t = _r$shift.command,
                _n = _r$shift.args;

            (i[_t] || e[_t]).apply(e, _n);
          }
        };

        t.forEach(function (t) {
          var s = e[t];
          i[t] = s, e[t] = function () {
            for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
              e[_key] = arguments[_key];
            }

            n() ? r.push({
              command: t,
              args: e
            }) : (o(), s && s.apply(this, e));
          };
        }), Object.defineProperty(this, "queue", {
          enumerable: !0,
          get: function get() {
            return r;
          }
        }), this.flush = o, this.empty = function () {
          r.length = 0;
        }, this.off = function () {
          t.forEach(function (t) {
            var n = i[t];
            n && (e[t] = n, delete i[t]);
          });
        }, this.destroy = function () {
          this.off(), this.empty();
        };
      }

      n.d(t, {
        Z: function Z() {
          return r;
        }
      });
    },
    4742: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return r;
        }
      });
      var r = {
        debug: !1
      };
    },
    5191: function _(e, t, n) {
      "use strict";

      n.d(t, {
        R: function R() {
          return i;
        },
        a: function a() {
          return r;
        }
      });

      var r = function r(e) {
        return e.slice && "px" === e.slice(-2) && (e = e.slice(0, -2)), e;
      },
          i = function i(e, t) {
        if (-1 === t.toString().indexOf("%")) return 0;
        if ("string" != typeof e || !e) return 0;
        if (/^\d*\.?\d+%$/.test(e)) return e;
        var n = e.indexOf(":");
        if (-1 === n) return 0;
        var r = parseFloat(e.substr(0, n)),
            i = parseFloat(e.substr(n + 1));
        return r <= 0 || i <= 0 ? 0 : i / r * 100 + "%";
      };
    },
    5083: function _(e, t, n) {
      "use strict";

      n.d(t, {
        G0: function G0() {
          return d;
        },
        ZP: function ZP() {
          return p;
        },
        ke: function ke() {
          return u;
        }
      });
      var r = n(5191),
          i = n(1569),
          o = n(9888),
          s = n(6042),
          a = n(8348),
          l = n(696),
          c = n(8518);

      var u = {
        autoPause: {
          viewability: !1,
          pauseAds: !1
        },
        autostart: !1,
        allowFullscreen: !0,
        bandwidthEstimate: null,
        bitrateSelection: null,
        castAvailable: !1,
        controls: !0,
        cues: [],
        defaultPlaybackRate: 1,
        displaydescription: !0,
        displaytitle: !0,
        displayPlaybackLabel: !1,
        enableShortcuts: !0,
        height: 360,
        intl: {},
        item: 0,
        language: "en",
        liveTimeout: null,
        localization: l.Z,
        mute: !1,
        nextUpDisplay: !0,
        playbackRateControls: !1,
        playbackRates: [.5, 1, 1.25, 1.5, 2],
        renderCaptionsNatively: !1,
        repeat: !1,
        stretching: "uniform",
        volume: 90,
        width: 640
      },
          d = function d(e) {
        return e < 5 ? 5 : e;
      },
          p = function p(e, t) {
        var p, h;
        var f = Object.assign({}, null == (p = window) || null == (h = p.jwplayer) ? void 0 : h.defaults, t, e);
        !function (e) {
          Object.keys(e).forEach(function (t) {
            "id" !== t && (e[t] = (0, o.serialize)(e[t]));
          });
        }(f);
        var g = f.forceLocalizationDefaults ? u.language : (0, c.G3)(),
            m = (0, c.tK)(f.intl);
        f.localization = (0, c.Mh)(l.Z, (0, c.Pm)(f, m, g));
        var y = Object.assign({}, u, f);
        "." === y.base && (y.base = (0, i.getScriptPath)("jwplayer.js")), y.base = (y.base || (0, i.loadFrom)()).replace(/\/?$/, "/"), n.p = y.base, y.width = (0, r.a)(y.width), y.height = (0, r.a)(y.height), y.aspectratio = (0, r.R)(y.aspectratio, y.width), "string" == typeof y.volume && (y.volume = parseFloat(y.volume)), y.volume = (0, s.qh)(y.volume) ? Math.min(Math.max(0, y.volume), 100) : u.volume, y.mute = Boolean(y.mute), y.language = g, y.intl = m;
        var v = y.playlistIndex;
        v && (y.item = v), (0, s.hj)(y.item) || (y.item = 0);
        var b = f.autoPause;
        b && (y.autoPause.viewability = !("viewability" in b) || Boolean(b.viewability));
        var w = y.playbackRateControls;

        if (w) {
          var _e = y.playbackRates;
          Array.isArray(w) && (_e = w), _e = _e.filter(function (e) {
            return (0, s.hj)(e) && e >= .25 && e <= 4;
          }).map(function (e) {
            return Math.round(100 * e) / 100;
          }), _e.indexOf(1) < 0 && _e.push(1), _e.sort(), y.playbackRateControls = !0, y.playbackRates = _e;
        }

        (!y.playbackRateControls || y.playbackRates.indexOf(y.defaultPlaybackRate) < 0) && (y.defaultPlaybackRate = 1), y.playbackRate = y.defaultPlaybackRate, y.aspectratio || delete y.aspectratio;
        var k = y.playlist;
        if (k) Array.isArray(k.playlist) && (y.feedData = k, y.playlist = k.playlist);else {
          var _e2 = (0, s.ei)(y, ["title", "description", "type", "mediaid", "image", "images", "file", "sources", "tracks", "preload", "duration", "chapters"]);

          y.playlist = [_e2];
        }
        y.qualityLabels = y.qualityLabels || y.hlslabels, delete y.duration;
        var j = y.liveTimeout;
        null !== j && ((0, s.qh)(j) ? 0 !== j && (j = Math.max(30, j)) : j = null, y.liveTimeout = j);
        var C = parseFloat(y.bandwidthEstimate),
            P = parseFloat(y.bitrateSelection);
        return y.bandwidthEstimate = (0, s.qh)(C) ? C : function (e) {
          var t = parseFloat(e);
          return (0, s.qh)(t) ? Math.max(t, 1) : u.bandwidthEstimate;
        }(y.defaultBandwidthEstimate), y.bitrateSelection = (0, s.qh)(P) ? P : u.bitrateSelection, y.liveSyncDuration = d(y.liveSyncDuration), y.backgroundLoading = (0, s.jn)(y.backgroundLoading) ? y.backgroundLoading : a.Features.backgroundLoading, y;
      };
    },
    2894: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Ep: function Ep() {
          return o;
        },
        Jt: function Jt() {
          return s;
        },
        Tr: function Tr() {
          return i;
        },
        Zq: function Zq() {
          return a;
        }
      });
      var r = n(4446);

      var i = {},
          o = function o(e, t) {
        return function () {
          throw new r.rG(r.pJ, e, t);
        };
      },
          s = function s(e, t) {
        return function () {
          throw new r.rG(null, e, t);
        };
      },
          a = function a() {
        return n.e(681).then(function (e) {
          return n(9659)["default"];
        }.bind(null, n))["catch"](o(r.fU + 101));
      };
    },
    623: function _(e, t, n) {
      "use strict";

      n.d(t, {
        ZP: function ZP() {
          return ne;
        },
        c2: function c2() {
          return ee;
        }
      });
      var r = n(9128),
          i = n(2445),
          o = n(2894),
          s = n(393),
          a = n(8320),
          l = n(2963),
          c = n(670),
          u = n(4601),
          d = n(4446),
          p = n(8348);
      var h = null;

      var f = function f() {
        var e = window.IntersectionObserverEntry;
        return !e || !("IntersectionObserver" in window) || !("intersectionRatio" in e.prototype);
      },
          g = function g() {
        return (f() ? n.e(943).then(function (e) {
          return n(6337);
        }.bind(null, n))["catch"]((0, o.Ep)(d.fU + 120)) : Promise.resolve()).then(o.Zq);
      },
          m = function m(e) {
        var t = e.get("controls"),
            r = f(),
            i = function (e, t) {
          var n = e.get("playlist");

          if (Array.isArray(n) && n.length) {
            var _r = (0, a.bx)(e.get("item"), n.length),
                _i = (0, a.T5)((0, s.Z)(n[_r]), e);

            for (var _n2 = 0; _n2 < _i.length; _n2++) {
              var _r2 = _i[_n2],
                  _o = e.getProviders();

              for (var _e3 = 0; _e3 < l.B.length; _e3++) {
                var _n3 = l.B[_e3];
                if (_o.providerSupports(_n3, _r2)) return _n3.name === t;
              }
            }
          }

          return !1;
        }(e, "html5");

        return p.OS.tizen ? g() : t && r && i ? function () {
          var e = n.e(605).then(function (e) {
            n(6337);
            var t = n(9659)["default"];
            return u.v.controls = n(4646)["default"], (0, c.Z)(n(9181)["default"]), t;
          }.bind(null, n))["catch"]((0, o.Ep)(d.fU + 105));
          return o.Tr.html5 = e, e;
        }() : t && i ? function () {
          var e = n.e(207).then(function (e) {
            var t = n(9659)["default"];
            return u.v.controls = n(4646)["default"], (0, c.Z)(n(9181)["default"]), t;
          }.bind(null, n))["catch"]((0, o.Ep)(d.fU + 104));
          return o.Tr.html5 = e, e;
        }() : t && r ? n.e(493).then(function (e) {
          n(6337);
          var t = n(9659)["default"];
          return u.v.controls = n(4646)["default"], t;
        }.bind(null, n))["catch"]((0, o.Ep)(d.fU + 103)) : t ? n.e(581).then(function (e) {
          var t = n(9659)["default"];
          return u.v.controls = n(4646)["default"], t;
        }.bind(null, n))["catch"]((0, o.Ep)(d.fU + 102)) : g();
      };

      var y = n(1643),
          v = n(7263),
          b = n(676),
          w = n(8518),
          k = n(1241),
          j = n(8381);

      var C = function C(e, t, n) {
        var r = e.attributes;
        r.playlist = (0, a.ZP)(t), r.feedData = n;
      },
          P = function P(e) {
        var t = e.get("playlist");
        return new Promise(function (n, r) {
          if ("string" != typeof t) {
            var _r3 = e.get("feedData") || {};

            return C(e, t, _r3), n();
          }

          var i = new v.Z();
          i.on(y.Ow, function (t) {
            var r = t.playlist;
            delete t.playlist, C(e, r, t), n();
          }), i.on(y.pn, function (t) {
            C(e, [], {}), r((0, d.l9)(t, d.xk));
          }), i.load(t);
        });
      },
          x = function x(e) {
        return e.attributes._destroyed;
      };

      var O = n(1918),
          S = n(6599),
          E = n(7010);

      var T = function T(e) {
        var t = e.get("skin") ? e.get("skin").url : void 0;

        if ("string" == typeof t && !function (e) {
          var t = document.styleSheets;

          for (var _n4 = 0, _r4 = t.length; _n4 < _r4; _n4++) {
            if (t[_n4].href === e) return !0;
          }

          return !1;
        }(t)) {
          var _e4 = !0;

          return new b.ZP(t, _e4).load()["catch"](function (e) {
            return e;
          });
        }

        return Promise.resolve();
      },
          A = function A(e) {
        var t = e.get("advertising");
        return Boolean(null == t ? void 0 : t.outstream);
      },
          Z = function Z(e) {
        return A(e) ? Promise.resolve() : P(e).then(function () {
          if (e.get("drm") || (0, O.w0)(e.get("playlist"))) return (0, O.lD)(e.get("edition"));
        }).then(function () {
          return P(t = e).then(function () {
            if (x(t)) return;
            var e = (0, a.s7)(t.get("playlist"), t);
            t.attributes.playlist = e;

            try {
              (0, a._)(e);
            } catch (e) {
              throw e.code += d.xk, e;
            }

            var n = t.getProviders(),
                r = (0, a.bx)(t.get("item"), e.length),
                _n$choose = n.choose(e[r].sources[0]),
                i = _n$choose.provider,
                s = _n$choose.name;

            return "function" == typeof i ? i : o.Tr.html5 && "html5" === s ? o.Tr.html5 : n.load(s)["catch"](function (e) {
              throw (0, d.l9)(e, d.y4);
            });
          });
          var t;
        });
      },
          _ = function _(e) {
        var t = e.attributes,
            n = t.error;

        if (n && n.code === S.u5) {
          var _e5 = t.pid,
              _n5 = t.ph,
              _r5 = new S.ZP(t.key),
              _i2 = 7776e6;

          if (_n5 > 0 && _n5 < 4 && _e5 && _r5.duration() > -_i2) {
            return new b.ZP("//content.jwplatform.com/libraries/".concat(_e5, ".js")).load().then(function () {
              var e = window.jwplayer.defaults.key,
                  n = new S.ZP(e);
              n.error() || n.token() !== _r5.token() || (t.key = e, t.edition = n.edition(), t.error = n.error());
            })["catch"](function () {});
          }
        }

        return Promise.resolve();
      },
          M = function M(e, t) {
        var n = [_(e)];
        return A(e) || n.push(Promise.resolve()), Promise.all(n);
      },
          F = function F(e, t) {
        return function (e, t) {
          return n.e(168).then(function (r) {
            return new (0, n(5545)["default"])(t).setup(e);
          }.bind(null, n))["catch"]((0, o.Ep)(d.fU + 130));
        }(e, t).then(function () {
          return T(e);
        });
      },
          I = function I(e, t) {
        var n = function n() {
          return function (e, t) {
            return (0, k.Z)(e, t);
          }(e, t);
        };

        return (0, E.Z)() ? F(e, t).then(n)["catch"](n) : n();
      },
          B = function B(e) {
        var t = e.attributes,
            n = t.language,
            r = t.base,
            i = t.setupConfig,
            o = t.intl,
            s = (0, w.Pm)(i, o, n);
        return !(0, w.q2)(n) || (0, w.dl)(s) ? Promise.resolve() : new Promise(function (i) {
          return (0, w.Dq)(r, n).then(function (_ref) {
            var n = _ref.response;

            if (!x(e)) {
              if (!n) throw new d.rG(null, d.wH);
              t.localization = (0, w.Mh)(n, s), i();
            }
          })["catch"](function (e) {
            i(e.code === d.wH ? e : (0, d.l9)(e, d.A6));
          });
        });
      },
          L = function L(e) {
        return new Promise(function (t) {
          if (e.attributes.liveSyncDuration > 45) return t((0, d.l9)(new Error(), d.wM));
          var n = Array.isArray(e.attributes.playlist) && e.attributes.playlist.map(function (e) {
            return e.chapters;
          });
          return null != n && n.length ? (0, j.T2)(n, t) : t();
        });
      },
          N = function N(e) {
        var t;
        this.start = function (n) {
          var r = I(e, n),
              i = Promise.all([(o = e, h || (h = m(o)), h), L(e), r, Z(e), M(e), T(e), B(e)]);
          var o;
          var s = new Promise(function (e, n) {
            t = setTimeout(function () {
              n(new d.rG(d.pJ, d.T6));
            }, 6e4);

            var r = function r() {
              clearTimeout(t), setTimeout(e, 6e4);
            };

            i.then(r)["catch"](r);
          });
          return Promise.race([i, s])["catch"](function (e) {
            var t = function t() {
              throw e;
            };

            return r.then(t)["catch"](t);
          }).then(function (e) {
            return function (e) {
              if (!e || !e.length) return {
                core: null,
                warnings: []
              };
              var t = e.reduce(function (e, t) {
                return e.concat(t);
              }, []).filter(function (e) {
                return null == e ? void 0 : e.code;
              });
              return {
                core: e[0],
                warnings: t
              };
            }(e);
          });
        }, this.destroy = function () {
          clearTimeout(t), e.set("_destroyed", !0), e = null;
        };
      };

      var D = n(2303),
          $ = n(7411),
          R = n(9888),
          q = n(4742);
      var z = {
        removeItem: function removeItem(e) {}
      };

      try {
        z = window.localStorage || z;
      } catch (e) {}

      var U = /*#__PURE__*/function () {
        function U(e, t) {
          _classCallCheck(this, U);

          this.namespace = e, this.items = t;
        }

        _createClass(U, [{
          key: "getAllItems",
          value: function getAllItems() {
            var _this = this;

            return this.items.reduce(function (e, t) {
              var n = z["".concat(_this.namespace, ".").concat(t)];
              return n && (e[t] = "captions" !== t ? (0, R.serialize)(n) : JSON.parse(n)), e;
            }, {});
          }
        }, {
          key: "track",
          value: function track(e) {
            var _this2 = this;

            this.items.forEach(function (t) {
              e.on("change:".concat(t), function (e, n) {
                try {
                  "captions" === t && (n = JSON.stringify(n)), z["".concat(_this2.namespace, ".").concat(t)] = n;
                } catch (e) {
                  q.Z.debug && console.error(e);
                }
              });
            });
          }
        }, {
          key: "clear",
          value: function clear() {
            var _this3 = this;

            this.items.forEach(function (e) {
              z.removeItem("".concat(_this3.namespace, ".").concat(e));
            });
          }
        }]);

        return U;
      }();

      var H = n(7753),
          V = n(9918),
          G = n(328),
          W = n(4225),
          K = n(7683),
          Q = n(4609),
          X = n(5882);
      n(4671), n(9926);

      var J = function J(e, t) {
        t && t.code && (t.sourceError && console.error(t.sourceError), console.error(d.rG.logMessage(t.code)));
      },
          Y = function Y(e) {
        e && e.code && console.warn(d.rG.logMessage(e.code));
      },
          ee = function ee(e, t) {
        if (!document.body.contains(e.currentContainer)) {
          var _t2 = document.getElementById(e.get("id"));

          _t2 && (e.currentContainer = _t2);
        }

        e.currentContainer.parentElement && e.currentContainer.parentElement.replaceChild(t, e.currentContainer), e.currentContainer = t;
      },
          te = function te(e) {
        this._events = {}, this.modelShim = new H.Z(), this.modelShim._qoeItem = new $.Z(), this.mediaShim = {}, this.setup = new N(this.modelShim), this.currentContainer = this.originalContainer = e, this.apiQueue = new r.Z(this, ["load", "play", "pause", "seek", "stop", "playlistItem", "playlistNext", "playlistPrev", "next", "preload", "setAllowFullscreen", "setConfig", "setCurrentAudioTrack", "setCurrentCaptions", "setCurrentQuality", "setFullscreen", "setPip", "requestPip", "addButton", "removeButton", "castToggle", "setMute", "setVolume", "setPlaybackRate", "addCues", "setCues", "getCues", "setPlaylistItem", "stopCasting", "getChapters", "getCurrentChapter", "setChapter", "resize", "setCaptions", "setControls"], function () {
          return !0;
        });
      };

      Object.assign(te.prototype, {
        on: G.ZP.on,
        once: G.ZP.once,
        off: G.ZP.off,
        trigger: G.ZP.trigger,
        init: function init(e, t) {
          var _this4 = this;

          var n = this.modelShim,
              r = new U("jwplayer", ["volume", "mute", "captionLabel", "captions", "bandwidthEstimate", "bitrateSelection", "qualityLabel", "enableShortcuts"]),
              o = null == r ? void 0 : r.getAllItems();
          n.attributes = n.attributes || {}, Object.assign(this.mediaShim, V.L4);
          var s = e,
              a = (0, i.ZP)(Object.assign({}, e), o);
          a.id = t.id, a.setupConfig = s, Object.assign(n.attributes, a, V.bv), n.getProviders = function () {
            return new D.Z(a);
          }, n.setProvider = function () {};
          var l = (0, K.Z)();
          {
            n.get("backgroundLoading") || (l = (0, Q.Z)(l.getPrimedElement(), l));

            var _e6 = this.primeUi = new X.ZP((0, X.GU)(this.originalContainer)).once("gesture", function () {
              l.prime(), _this4.preload(), _e6.destroy();
            });
          }
          return n.on("change:errorEvent", J), this.setup.start(t).then(function (e) {
            var i = e.core;
            if (!i) throw (0, d.l9)(null, d.y7);
            if (!_this4.setup) return;
            _this4.on(y.cM, Y), e.warnings.forEach(function (e) {
              _this4.trigger(y.cM, e);
            });

            var o = _this4.modelShim.clone();

            if (o.error) throw o.error;

            var s = _this4.apiQueue.queue.slice(0);

            _this4.apiQueue.destroy(), Object.assign(_this4, i.prototype), _this4.playerSetup(o, t, _this4.originalContainer, _this4._events, s, l);
            var a = _this4._model;
            return n.off("change:errorEvent", J), a.on("change:errorEvent", J), r.track(a), _this4.updatePlaylist(a.get("playlist"), a.get("feedData"))["catch"](function (e) {
              var t = e.code === d._M ? d.IB : d.xk;
              throw (0, d.l9)(e, t);
            });
          }).then(function () {
            _this4.setup && _this4.playerReady();
          })["catch"](function (e) {
            _this4.setup && function (e, t, n) {
              Promise.resolve().then(function () {
                var r = (0, d.Mm)(d.ud, d.nk, n),
                    i = e._model || e.modelShim;
                r.message = r.message || i.get("localization").errors[r.key], delete r.key;
                var o = i.get("contextual");

                if (!o) {
                  var _t3 = (0, W.Z)(e, r);

                  W.Z.cloneIcon && _t3.querySelector(".jw-icon").appendChild(W.Z.cloneIcon("error")), ee(e, _t3);
                }

                i.set("errorEvent", r), i.set("state", y.Vy), e.trigger(y.HH, r), o && t.remove();
              });
            }(_this4, t, e);
          });
        },
        playerDestroy: function playerDestroy() {
          this.destroy && this.destroy(), this.apiQueue && this.apiQueue.destroy(), this.setup && this.setup.destroy(), this.primeUi && this.primeUi.destroy(), this.currentContainer !== this.originalContainer && ee(this, this.originalContainer), this.off(), this._events = this._model = this.modelShim = this.apiQueue = this.primeUi = this.setup = null;
        },
        getContainer: function getContainer() {
          return this.currentContainer;
        },
        get: function get(e) {
          if (this.modelShim) return e in this.mediaShim ? this.mediaShim[e] : this.modelShim.get(e);
        },
        getItemQoe: function getItemQoe() {
          return this.modelShim._qoeItem;
        },
        getItemPromise: function getItemPromise() {
          return null;
        },
        setItemCallback: function setItemCallback(e) {
          this.modelShim && (this.modelShim.attributes.playlistItemCallback = e);
        },
        getConfig: function getConfig() {
          return Object.assign({}, this.modelShim.attributes, this.mediaShim);
        },
        getCurrentCaptions: function getCurrentCaptions() {
          return this.get("captionsIndex");
        },
        getWidth: function getWidth() {
          return this.get("containerWidth");
        },
        getHeight: function getHeight() {
          return this.get("containerHeight");
        },
        getMute: function getMute() {
          return this.get("mute");
        },
        getProvider: function getProvider() {
          return this.get("provider");
        },
        getState: function getState() {
          return this.get("state");
        },
        getAudioTracks: function getAudioTracks() {
          return null;
        },
        getCaptionsList: function getCaptionsList() {
          return null;
        },
        getQualityLevels: function getQualityLevels() {
          return null;
        },
        getVisualQuality: function getVisualQuality() {
          return null;
        },
        getCurrentQuality: function getCurrentQuality() {
          return -1;
        },
        getCurrentAudioTrack: function getCurrentAudioTrack() {
          return -1;
        },
        getSafeRegion: function getSafeRegion() {
          return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        },
        isBeforeComplete: function isBeforeComplete() {
          return !1;
        },
        isBeforePlay: function isBeforePlay() {
          return !1;
        },
        createInstream: function createInstream() {
          return null;
        },
        skipAd: function skipAd() {},
        getMediaElement: function getMediaElement() {},
        attachMedia: function attachMedia() {},
        detachMedia: function detachMedia() {}
      });
      var ne = te;
    },
    4446: function _(e, t, n) {
      "use strict";

      n.d(t, {
        A6: function A6() {
          return w;
        },
        DD: function DD() {
          return d;
        },
        EY: function EY() {
          return m;
        },
        H4: function H4() {
          return S;
        },
        IB: function IB() {
          return c;
        },
        MD: function MD() {
          return C;
        },
        Mm: function Mm() {
          return A;
        },
        Sp: function Sp() {
          return O;
        },
        T6: function T6() {
          return o;
        },
        Y7: function Y7() {
          return b;
        },
        YQ: function YQ() {
          return u;
        },
        _M: function _M() {
          return g;
        },
        aD: function aD() {
          return v;
        },
        fU: function fU() {
          return a;
        },
        l9: function l9() {
          return Z;
        },
        nk: function nk() {
          return i;
        },
        nm: function nm() {
          return _;
        },
        o2: function o2() {
          return f;
        },
        pJ: function pJ() {
          return P;
        },
        rG: function rG() {
          return T;
        },
        tJ: function tJ() {
          return h;
        },
        ud: function ud() {
          return E;
        },
        ul: function ul() {
          return j;
        },
        wH: function wH() {
          return k;
        },
        wM: function wM() {
          return y;
        },
        xk: function xk() {
          return l;
        },
        y4: function y4() {
          return p;
        },
        y7: function y7() {
          return s;
        },
        zO: function zO() {
          return x;
        }
      });
      var r = n(6042);
      var i = 1e5,
          o = 100001,
          s = 100002,
          a = 101e3,
          l = 102e3,
          c = 102700,
          u = 200001,
          d = 202e3,
          p = 104e3,
          h = 203e3,
          f = 203640,
          g = 203700,
          m = 204e3,
          y = 300100,
          v = 300200,
          b = 306e3,
          w = 308e3,
          k = 308640,
          j = "cantPlayVideo",
          C = "badConnection",
          P = "cantLoadPlayer",
          x = "cantPlayInBrowser",
          O = "liveStreamDown",
          S = "protectedContent",
          E = "technicalError";

      var T = /*#__PURE__*/function () {
        function T(e, t, n) {
          _classCallCheck(this, T);

          this.code = (0, r.qh)(t) ? t : 0, this.sourceError = n || null, e ? this.key = e : delete this.key;
        }

        _createClass(T, null, [{
          key: "logMessage",
          value: function logMessage(e) {
            var t = e % 1e3,
                n = Math.floor((e - t) / 1e3);
            var r = e.toString();
            t >= 400 && t < 600 && (r = "".concat(n, "400-").concat(n, "599"));
            return "JW Player ".concat(e > 299999 && e < 4e5 ? "Warning" : "Error", " ").concat(e, ". For more information see https://developer.jwplayer.com/jw-player/docs/developer-guide/api/errors-reference#").concat(r);
          }
        }]);

        return T;
      }();

      var A = function A(e, t, n) {
        return n instanceof T && n.code ? n : new T(e, t, n);
      },
          Z = function Z(e, t) {
        var n = A(E, t, e);
        return n.code = (e && e instanceof T && e.code || 0) + t, n;
      },
          _ = function _(e) {
        var t = e.name,
            n = e.message;

        switch (t) {
          case "AbortError":
            return /pause/.test(n) ? 303213 : /load/.test(n) ? 303212 : 303210;

          case "NotAllowedError":
            return 303220;

          case "NotSupportedError":
            return 303230;

          default:
            return 303200;
        }
      };
    },
    6391: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return r;
        }
      });
      var r = [];
    },
    7411: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return l;
        }
      });
      var r = n(5004);
      var i = window.performance || {
        timing: {}
      },
          o = i.timing.navigationStart || (0, r.z)();
      "now" in i || (i.now = function () {
        return (0, r.z)() - o;
      });

      var s = function s() {
        return o + i.now();
      };

      var a = function a(e, t) {
        if (null == e) throw new TypeError("Cannot convert undefined or null to object");
        return Object.prototype.hasOwnProperty.call(Object(e), t);
      };

      var l = /*#__PURE__*/function () {
        function l() {
          _classCallCheck(this, l);

          this.startTimes = {}, this.sum = {}, this.counts = {}, this.ticks = {};
        }

        _createClass(l, [{
          key: "start",
          value: function start(e) {
            this.startTimes[e] = s(), this.counts[e] = this.counts[e] + 1 || 1;
          }
        }, {
          key: "end",
          value: function end(e) {
            if (!this.startTimes[e]) return;
            var t = s() - this.startTimes[e];
            delete this.startTimes[e], this.sum[e] = this.sum[e] + t || t;
          }
        }, {
          key: "dump",
          value: function dump() {
            var e = Object.assign({}, this.sum);

            for (var _t4 in this.startTimes) {
              if (a(this.startTimes, _t4)) {
                var _n6 = s() - this.startTimes[_t4];

                e[_t4] = e[_t4] + _n6 || _n6;
              }
            }

            return {
              counts: Object.assign({}, this.counts),
              sums: e,
              events: Object.assign({}, this.ticks)
            };
          }
        }, {
          key: "tick",
          value: function tick(e) {
            this.ticks[e] = s();
          }
        }, {
          key: "clear",
          value: function clear(e) {
            delete this.ticks[e];
          }
        }, {
          key: "between",
          value: function between(e, t) {
            return this.ticks[t] && this.ticks[e] ? this.ticks[t] - this.ticks[e] : null;
          }
        }]);

        return l;
      }();
    },
    4601: function _(e, t, n) {
      "use strict";

      n.d(t, {
        v: function v() {
          return s;
        },
        z: function z() {
          return a;
        }
      });
      var r = n(2894),
          i = n(8348);
      var o = null;

      var s = {},
          a = function a() {
        return o || (o = i.OS.tizenApp ? n.e(74).then(function (e) {
          var t = n(3112)["default"];
          return s.controls = t, t;
        }.bind(null, n))["catch"](function () {
          o = null, (0, r.Jt)(301133)();
        }) : n.e(716).then(function (e) {
          var t = n(4646)["default"];
          return s.controls = t, t;
        }.bind(null, n))["catch"](function () {
          o = null, (0, r.Jt)(301130)();
        })), o;
      };
    },
    8348: function _(e, t, n) {
      "use strict";

      n.r(t), n.d(t, {
        Browser: function Browser() {
          return a;
        },
        Features: function Features() {
          return c;
        },
        OS: function OS() {
          return l;
        }
      });
      var r = n(2268);

      var i = function i(e, t) {
        var n = e.exec(t);
        if (n && n.length > 1) return n[1];
      },
          o = navigator.userAgent,
          s = function s() {},
          a = {
        get androidNative() {
          return (0, r.O7)();
        },

        get chrome() {
          return (0, r.i7)();
        },

        get edge() {
          return (0, r.un)();
        },

        get facebook() {
          return (0, r.DF)();
        },

        get firefox() {
          return (0, r.pZ)();
        },

        get ie() {
          return (0, r.w1)();
        },

        get msie() {
          return (0, r.A)();
        },

        get safari() {
          return (0, r.G6)();
        },

        get version() {
          return function (e, t) {
            var n, r, i, o;
            if (e.chrome) n = -1 !== t.indexOf("Chrome") ? t.substring(t.indexOf("Chrome") + 7) : t.substring(t.indexOf("CriOS") + 6);else if (e.safari) n = t.substring(t.indexOf("Version") + 8);else if (e.firefox) n = t.substring(t.indexOf("Firefox") + 8);else if (e.edge) {
              var _e7 = t.indexOf("Edge");

              -1 === _e7 ? _e7 = t.indexOf("Edg") + 4 : _e7 += 5, n = t.substring(_e7);
            } else e.ie && (-1 !== t.indexOf("rv:") ? n = t.substring(t.indexOf("rv:") + 3) : -1 !== t.indexOf("MSIE") && (n = t.substring(t.indexOf("MSIE") + 5)));
            return n && (-1 !== (o = n.indexOf(";")) && (n = n.substring(0, o)), -1 !== (o = n.indexOf(" ")) && (n = n.substring(0, o)), -1 !== (o = n.indexOf(")")) && (n = n.substring(0, o)), r = parseInt(n, 10), i = parseInt(n.split(".")[1], 10)), {
              version: n,
              major: r,
              minor: i
            };
          }(this, o);
        }

      },
          l = {
        get android() {
          return (0, r.Dt)();
        },

        get iOS() {
          return (0, r.gn)();
        },

        get mobile() {
          return (0, r.tq)();
        },

        get mac() {
          return (0, r.id)();
        },

        get iPad() {
          return (0, r.zc)();
        },

        get iPhone() {
          return (0, r.xb)();
        },

        get windows() {
          return o.indexOf("Windows") > -1;
        },

        get tizen() {
          return (0, r.yS)();
        },

        get tizenApp() {
          return (0, r.Q6)();
        },

        get version() {
          return function (e, t) {
            var n, r, o;
            if (e.windows) switch (n = i(/Windows(?: NT|)? ([._\d]+)/, t), n) {
              case "6.1":
                n = "7.0";
                break;

              case "6.2":
                n = "8.0";
                break;

              case "6.3":
                n = "8.1";
            } else e.android ? n = i(/Android ([._\d]+)/, t) : e.iOS ? n = i(/OS ([._\d]+)/, t) : e.mac ? n = i(/Mac OS X ([._\d]+)/, t) : e.tizen && (n = i(/Tizen ([._\d]+)/, t));

            if (n) {
              r = parseInt(n, 10);

              var _e8 = n.split(/[._]/);

              _e8 && (o = parseInt(_e8[1], 10));
            }

            return {
              version: n,
              major: r,
              minor: o
            };
          }(this, o);
        }

      },
          c = {
        get flash() {
          return (0, r.NO)();
        },

        get flashVersion() {
          return (0, r.dI)();
        },

        get iframe() {
          return (0, r.cL)();
        },

        get passiveEvents() {
          return function () {
            var e = !1;

            try {
              var _t5 = Object.defineProperty({}, "passive", {
                get: function get() {
                  return e = !0;
                }
              });

              window.addEventListener("testPassive", s, _t5), window.removeEventListener("testPassive", s, _t5);
            } catch (e) {}

            return e;
          }();
        },

        get backgroundLoading() {
          return !(l.iOS || a.safari || l.tizen);
        }

      };
    },
    1643: function _(e, t, n) {
      "use strict";

      n.d(t, {
        $_: function $_() {
          return C;
        },
        $j: function $j() {
          return _;
        },
        Ax: function Ax() {
          return P;
        },
        B1: function B1() {
          return m;
        },
        Bs: function Bs() {
          return ve;
        },
        Ew: function Ew() {
          return N;
        },
        FU: function FU() {
          return D;
        },
        Gj: function Gj() {
          return ge;
        },
        HH: function HH() {
          return z;
        },
        Hy: function Hy() {
          return ne;
        },
        Ib: function Ib() {
          return pe;
        },
        Je: function Je() {
          return R;
        },
        Jl: function Jl() {
          return F;
        },
        K5: function K5() {
          return v;
        },
        Kb: function Kb() {
          return r;
        },
        Ms: function Ms() {
          return T;
        },
        NZ: function NZ() {
          return Z;
        },
        O1: function O1() {
          return X;
        },
        Ow: function Ow() {
          return se;
        },
        P: function P() {
          return g;
        },
        QF: function QF() {
          return de;
        },
        R2: function R2() {
          return V;
        },
        RF: function RF() {
          return ke;
        },
        Rc: function Rc() {
          return A;
        },
        Rt: function Rt() {
          return j;
        },
        SL: function SL() {
          return he;
        },
        Sv: function Sv() {
          return h;
        },
        TJ: function TJ() {
          return G;
        },
        U3: function U3() {
          return b;
        },
        UF: function UF() {
          return ue;
        },
        UW: function UW() {
          return re;
        },
        UZ: function UZ() {
          return Y;
        },
        V$: function V$() {
          return B;
        },
        Vy: function Vy() {
          return l;
        },
        WE: function WE() {
          return x;
        },
        Wp: function Wp() {
          return d;
        },
        Z_: function Z_() {
          return fe;
        },
        _5: function _5() {
          return s;
        },
        _B: function _B() {
          return le;
        },
        aM: function aM() {
          return ee;
        },
        aQ: function aQ() {
          return q;
        },
        bc: function bc() {
          return i;
        },
        cM: function cM() {
          return k;
        },
        cq: function cq() {
          return $;
        },
        cy: function cy() {
          return I;
        },
        gO: function gO() {
          return oe;
        },
        gy: function gy() {
          return Q;
        },
        h7: function h7() {
          return be;
        },
        ik: function ik() {
          return c;
        },
        j0: function j0() {
          return ae;
        },
        jt: function jt() {
          return ce;
        },
        k3: function k3() {
          return O;
        },
        l5: function l5() {
          return ye;
        },
        nQ: function nQ() {
          return u;
        },
        nv: function nv() {
          return p;
        },
        oZ: function oZ() {
          return W;
        },
        ot: function ot() {
          return f;
        },
        pi: function pi() {
          return L;
        },
        pn: function pn() {
          return w;
        },
        qG: function qG() {
          return we;
        },
        r0: function r0() {
          return a;
        },
        rx: function rx() {
          return J;
        },
        s$: function s$() {
          return M;
        },
        sF: function sF() {
          return ie;
        },
        t6: function t6() {
          return je;
        },
        tP: function tP() {
          return y;
        },
        uL: function uL() {
          return S;
        },
        uT: function uT() {
          return H;
        },
        uc: function uc() {
          return U;
        },
        ug: function ug() {
          return te;
        },
        wh: function wh() {
          return E;
        },
        xQ: function xQ() {
          return o;
        },
        xf: function xf() {
          return me;
        },
        yH: function yH() {
          return K;
        }
      });
      var r = "buffering",
          i = "idle",
          o = "complete",
          s = "paused",
          a = "playing",
          l = "error",
          c = "loading",
          u = "stalled",
          d = "drag",
          p = "dragStart",
          h = "dragEnd",
          f = "click",
          g = "doubleClick",
          m = "over",
          y = "move",
          v = "enter",
          b = "out",
          w = l,
          k = "warning",
          j = "adClick",
          C = "mediaLoaded",
          P = "adPause",
          x = "adPlay",
          O = "adSkipped",
          S = "adTime",
          E = "autostartNotAllowed",
          T = o,
          A = "ready",
          Z = "seek",
          _ = "beforePlay",
          M = "beforeComplete",
          F = "bufferFull",
          I = "displayClick",
          B = "playlistComplete",
          L = "cast",
          N = "mediaError",
          D = "firstFrame",
          $ = "playAttempt",
          R = "playAttemptFailed",
          q = "seeked",
          z = "setupError",
          U = "state",
          H = "bufferChange",
          V = "time",
          G = "ratechange",
          W = "mediaType",
          K = "volume",
          Q = "mute",
          X = "metadataCueParsed",
          J = "meta",
          Y = "levels",
          ee = "levelsChanged",
          te = "visualQuality",
          ne = "controls",
          re = "fullscreen",
          ie = "resize",
          oe = "playlistItem",
          se = "playlist",
          ae = "audioTracks",
          le = "audioTrackChanged",
          ce = "subtitlesTracks",
          ue = "subtitlesTrackChanged",
          de = "playbackRateChanged",
          pe = "logoClick",
          he = "captionsList",
          fe = "captionsChanged",
          ge = "providerFirstFrame",
          me = "userAction",
          ye = "instreamClick",
          ve = "breakpoint",
          be = "fullscreenchange",
          we = "bandwidthEstimate",
          ke = "float",
          je = "chapter";
    },
    9918: function _(e, t, n) {
      "use strict";

      n.d(t, {
        L4: function L4() {
          return i;
        },
        OG: function OG() {
          return s;
        },
        bv: function bv() {
          return r;
        },
        ni: function ni() {
          return o;
        }
      });
      var r = {
        audioMode: !1,
        itemMeta: {},
        playbackRate: 1,
        playRejected: !1,
        state: n(1643).bc,
        itemReady: !1,
        controlsEnabled: !1
      },
          i = {
        position: 0,
        duration: 0,
        buffer: 0,
        currentTime: 0
      },
          o = 120,
          s = 25;
    },
    7753: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return i;
        }
      });
      var r = n(328);

      var i = /*#__PURE__*/function (_r$ZP) {
        _inherits(i, _r$ZP);

        var _super = _createSuper(i);

        function i() {
          var _this5;

          _classCallCheck(this, i);

          _this5 = _super.call(this), _this5.attributes = Object.create(null);
          return _this5;
        }

        _createClass(i, [{
          key: "addAttributes",
          value: function addAttributes(e) {
            var _this6 = this;

            Object.keys(e).forEach(function (t) {
              _this6.add(t, e[t]);
            });
          }
        }, {
          key: "add",
          value: function add(e, t) {
            var _this7 = this;

            Object.defineProperty(this, e, {
              get: function get() {
                return _this7.attributes[e];
              },
              set: function set(t) {
                _this7.set(e, t);
              },
              enumerable: !1
            }), this.attributes[e] = t;
          }
        }, {
          key: "get",
          value: function get(e) {
            return this.attributes[e];
          }
        }, {
          key: "set",
          value: function set(e, t) {
            if (this.attributes[e] === t) return;
            var n = this.attributes[e];
            this.attributes[e] = t, this.trigger("change:".concat(e), this, t, n);
          }
        }, {
          key: "clone",
          value: function clone() {
            var e = {},
                t = this.attributes;
            if (t) for (var _n7 in t) {
              e[_n7] = t[_n7];
            }
            return e;
          }
        }, {
          key: "change",
          value: function change(e, t, n) {
            this.on("change:".concat(e), t, n);
            var r = this.get(e);
            return t.call(n, this, r, r), this;
          }
        }]);

        return i;
      }(r.ZP);
    },
    7941: function _(e, t, n) {
      "use strict";

      n.d(t, {
        dZ: function dZ() {
          return o;
        },
        my: function my() {
          return a;
        },
        qk: function qk() {
          return s;
        },
        r1: function r1() {
          return i;
        }
      });
      var r = n(2957);

      var i = function i(e) {
        var t = "";
        return e && (e.localName ? t = e.localName : e.baseName && (t = e.baseName)), t;
      },
          o = function o(e) {
        var t = "";
        return e && (e.textContent ? t = (0, r.fy)(e.textContent) : e.text && (t = (0, r.fy)(e.text))), t;
      },
          s = function s(e, t) {
        return e.childNodes[t];
      },
          a = function a(e) {
        return e.childNodes ? e.childNodes.length : 0;
      };
    },
    6769: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return h;
        }
      });
      var r = n(7941),
          i = n(2957);

      var o = function o(e) {
        var t = [];

        for (var _n8 = 0; _n8 < (0, r.my)(e); _n8++) {
          var _i3 = e.childNodes[_n8];
          "jwplayer" === _i3.prefix && "mediatypes" === (0, r.r1)(_i3).toLowerCase() && t.push((0, r.dZ)(_i3));
        }

        return t;
      },
          s = function s(e) {
        var t = {
          zh: "Chinese",
          nl: "Dutch",
          en: "English",
          fr: "French",
          de: "German",
          it: "Italian",
          ja: "Japanese",
          pt: "Portuguese",
          ru: "Russian",
          es: "Spanish"
        };
        return t[e] ? t[e] : e;
      },
          a = function a(e, t) {
        var n = [];

        for (var _l = 0; _l < (0, r.my)(e); _l++) {
          var _c = e.childNodes[_l];

          if ("media" === _c.prefix) {
            if (!(0, r.r1)(_c)) continue;

            switch ((0, r.r1)(_c).toLowerCase()) {
              case "content":
                if ((0, i.Dc)(_c, "duration") && (t.duration = (0, i.m9)((0, i.Dc)(_c, "duration"))), (0, i.Dc)(_c, "url")) {
                  t.sources || (t.sources = []);

                  var _e9 = {
                    file: (0, i.Dc)(_c, "url"),
                    type: (0, i.Dc)(_c, "type"),
                    width: (0, i.Dc)(_c, "width"),
                    label: (0, i.Dc)(_c, "label")
                  },
                      _n9 = o(_c);

                  _n9.length && (_e9.mediaTypes = _n9), t.sources.push(_e9);
                }

                (0, r.my)(_c) > 0 && (t = a(_c, t));
                break;

              case "title":
                t.title = (0, r.dZ)(_c);
                break;

              case "description":
                t.description = (0, r.dZ)(_c);
                break;

              case "guid":
                t.mediaid = (0, r.dZ)(_c);
                break;

              case "thumbnail":
                t.image || (t.image = (0, i.Dc)(_c, "url"));
                break;

              case "group":
                a(_c, t);
                break;

              case "subtitle":
                {
                  var _e10 = {
                    file: (0, i.Dc)(_c, "url"),
                    kind: "captions"
                  };
                  (0, i.Dc)(_c, "lang").length > 0 && (_e10.label = s((0, i.Dc)(_c, "lang"))), n.push(_e10);
                  break;
                }
            }
          }
        }

        t.tracks || (t.tracks = []);

        for (var _e11 = 0; _e11 < n.length; _e11++) {
          t.tracks.push(n[_e11]);
        }

        return t;
      },
          l = a;

      var c = n(9888);

      var u = function u(e, t) {
        var n = "default",
            o = "label",
            s = "file",
            a = [],
            l = [],
            u = t;

        for (var _u = 0; _u < e.childNodes.length; _u++) {
          var _d = e.childNodes[_u];

          if ("jwplayer" === _d.prefix) {
            var _e12 = (0, r.r1)(_d);

            "source" === _e12 ? (delete t.sources, a.push({
              file: (0, i.Dc)(_d, s),
              "default": (0, i.Dc)(_d, n),
              label: (0, i.Dc)(_d, o),
              type: (0, i.Dc)(_d, "type")
            })) : "track" === _e12 ? (delete t.tracks, l.push({
              file: (0, i.Dc)(_d, s),
              "default": (0, i.Dc)(_d, n),
              kind: (0, i.Dc)(_d, "kind"),
              label: (0, i.Dc)(_d, o)
            })) : (t[_e12] = (0, c.serialize)((0, r.dZ)(_d)), "file" === _e12 && t.sources && delete t.sources);
          }

          t.file || (t.file = t.link);
        }

        if (a.length) {
          t.sources = [];

          for (var _e13 = 0; _e13 < a.length; _e13++) {
            var _t6 = a[_e13];
            _t6.file.length > 0 && (_t6[n] = "true" === a[_e13][n], _t6.label || delete _t6.label, u.sources.push(_t6));
          }
        }

        if (l.length) {
          t.tracks = [];

          for (var _e14 = 0; _e14 < l.length; _e14++) {
            var _t7 = l[_e14];
            _t7.file && _t7.file.length > 0 && (_t7[n] = "true" === l[_e14][n], _t7.kind = l[_e14].kind.length ? l[_e14].kind : "captions", _t7.label || delete _t7.label, u.tracks.push(_t7));
          }
        }

        return u;
      };

      var d = n(393);

      var p = function p(e) {
        var t = {};

        for (var _n10 = 0; _n10 < e.childNodes.length; _n10++) {
          var _o2 = e.childNodes[_n10],
              _s = (0, r.r1)(_o2);

          if (_s) switch (_s.toLowerCase()) {
            case "enclosure":
              t.file = (0, i.Dc)(_o2, "url");
              break;

            case "title":
              t.title = (0, r.dZ)(_o2);
              break;

            case "guid":
              t.mediaid = (0, r.dZ)(_o2);
              break;

            case "pubdate":
              t.date = (0, r.dZ)(_o2);
              break;

            case "description":
              t.description = (0, r.dZ)(_o2);
              break;

            case "link":
              t.link = (0, r.dZ)(_o2);
              break;

            case "category":
              t.tags ? t.tags += (0, r.dZ)(_o2) : t.tags = (0, r.dZ)(_o2);
          }
        }

        return new d.Z(u(e, l(e, t)));
      };

      function h(e) {
        var t = [];
        t.feedData = {};

        for (var _n11 = 0; _n11 < (0, r.my)(e); _n11++) {
          var _i4 = (0, r.qk)(e, _n11);

          if ("channel" === (0, r.r1)(_i4).toLowerCase()) for (var _e15 = 0; _e15 < (0, r.my)(_i4); _e15++) {
            var _n12 = (0, r.qk)(_i4, _e15),
                _o3 = (0, r.r1)(_n12).toLowerCase();

            "item" === _o3 ? t.push(p(_n12)) : _o3 && (t.feedData[_o3] = (0, r.dZ)(_n12));
          }
        }

        return t;
      }
    },
    2557: function _(e, t, n) {
      "use strict";

      n.d(t, {
        t: function t() {
          return r;
        },
        u: function u() {
          return i;
        }
      });

      var r = function r(e, t) {
        _classCallCheck(this, r);

        this.defaultLanguage = e, this.timestamps = t;
      };

      var i = /*#__PURE__*/function () {
        function i(_ref2) {
          var _this8 = this;

          var _ref2$title = _ref2.title,
              e = _ref2$title === void 0 ? {} : _ref2$title,
              t = _ref2.group,
              n = _ref2.time,
              r = _ref2.image;

          _classCallCheck(this, i);

          this.title = {}, this.time = n, this.group = t, this.image = r, Object.keys(e).forEach(function (t) {
            var n = e[t];

            _this8.addTitle(t, n);
          });
        }

        _createClass(i, [{
          key: "addTitle",
          value: function addTitle(e, t) {
            this.title[e] = t;
          }
        }]);

        return i;
      }();
    },
    393: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return l;
        }
      });
      var r = n(6053);

      var i = ["captions", "metadata", "thumbnails", "chapters"],
          o = function o(e) {
        if (!e || !e.file) return;
        var t = Object.assign({}, {
          kind: "captions",
          "default": !1
        }, e);
        var n;
        return t.kind = (n = t.kind, -1 !== i.indexOf(n) ? t.kind : "captions"), t["default"] = Boolean(t["default"]), t;
      };

      var s = n(9918);

      var a = Array.isArray,
          l = function l(e) {
        a((e = e || {}).tracks) || delete e.tracks;
        var t = Object.assign({}, {
          sources: [],
          tracks: [],
          minDvrWindow: s.ni
        }, e);
        t.sources !== Object(t.sources) || a(t.sources) || (t.sources = [(0, r.Z)(t.sources)]), a(t.sources) && 0 !== t.sources.length || (e.levels ? t.sources = e.levels : t.sources = [(0, r.Z)(e)]);

        for (var _e16 = 0; _e16 < t.sources.length; _e16++) {
          var _n13 = t.sources[_e16];
          if (!_n13) continue;
          var _i5 = _n13["default"];
          _n13["default"] = !!_i5 && "true" === _i5.toString(), t.sources[_e16].label || (t.sources[_e16].label = _e16.toString()), t.sources[_e16] = (0, r.Z)(t.sources[_e16]);
        }

        return t.sources = t.sources.filter(Boolean), a(t.tracks) || (t.tracks = []), a(t.captions) && (t.tracks = t.tracks.concat(t.captions), delete t.captions), t.tracks = t.tracks.map(o).filter(Boolean), t;
      };
    },
    7263: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return c;
        }
      });
      var r = n(1643),
          i = n(7941),
          o = n(6769),
          s = n(6886),
          a = n(328),
          l = n(4446);

      var c = function c() {
        var e = Object.assign(this, a.ZP),
            t = function t(_t8) {
          _t8 instanceof l.rG && !_t8.code && (_t8 = new l.rG(l.ul, 0)), e.trigger(r.pn, _t8);
        },
            n = function n(_n14) {
          try {
            var _t9 = _n14.responseXML ? _n14.responseXML.childNodes : null;

            var _s2,
                _a = null;

            if (_t9) {
              for (var _e17 = 0; _e17 < _t9.length && (_a = _t9[_e17], 8 === _a.nodeType); _e17++) {
                ;
              }

              if (_a && "xml" === (0, i.r1)(_a) && (_a = _a.nextSibling), _a && "rss" === (0, i.r1)(_a)) {
                var _e18 = (0, o.Z)(_a);

                _s2 = Object.assign({
                  playlist: _e18
                }, _e18.feedData);
              }
            }

            if (!_s2) try {
              var _e19 = JSON.parse(_n14.responseText);

              if (Array.isArray(_e19)) _s2 = {
                playlist: _e19
              };else {
                if (!Array.isArray(_e19.playlist)) throw Error("Playlist is not an array");
                _s2 = _e19;
              }
            } catch (e) {
              throw new l.rG(l.ul, 621, e);
            }
            e.trigger(r.Ow, _s2);
          } catch (e) {
            t(e);
          }
        };

        this.load = function (e) {
          (0, s.h)(e, n, function (e, n, r, i) {
            t(i);
          });
        }, this.destroy = function () {
          this.off();
        };
      };
    },
    8320: function _(e, t, n) {
      "use strict";

      n.d(t, {
        ZP: function ZP() {
          return v;
        },
        s7: function s7() {
          return f;
        },
        T5: function T5() {
          return y;
        },
        YF: function YF() {
          return h;
        },
        _: function _() {
          return g;
        },
        bx: function bx() {
          return m;
        }
      });

      var r = {
        none: !0,
        metadata: !0,
        auto: !0
      },
          i = function i(e, t) {
        return r[e] ? e : r[t] ? t : "metadata";
      };

      var o = n(393),
          s = n(6053),
          a = n(2303),
          l = n(4446);

      var c = function c(e, t) {
        return void 0 === e ? t : e;
      },
          u = function u(e, t, n) {
        n in t && (e[n] = t[n]);
      },
          d = function d(e, t) {
        var n = t.attributes,
            r = e.sources,
            o = e.allSources,
            a = e.preload,
            l = e.drm,
            d = c(e.withCredentials, n.withCredentials);
        return (o || r).map(function (t) {
          if (t !== Object(t)) return null;
          u(t, n, "androidhls"), u(t, n, "hlsjsdefault"), u(t, n, "safarihlsjs"), function (e, t, n) {
            if (e.liveSyncDuration) return;
            var r = t.liveSyncDuration ? t : n;
            u(e, r, "liveSyncDuration");
          }(t, e, n), u(t, n, "_hlsjsProgressive"), t.preload = i(t.preload, a);
          var r = t.drm || l || n.drm;
          r && (t.drm = r);
          var o = c(t.withCredentials, d);
          return void 0 !== o && (t.withCredentials = o), (0, s.Z)(t);
        }).filter(Boolean);
      },
          p = function p(e, t) {
        t && t.choose || (t = new a.Z());

        var n = function (e, t) {
          for (var _n15 = 0; _n15 < e.length; _n15++) {
            var _r6 = e[_n15],
                _t$choose = t.choose(_r6),
                _i6 = _t$choose.providerToCheck;

            if (_i6) return {
              type: _r6.type,
              provider: _i6
            };
          }

          return null;
        }(e, t);

        if (!n) return [];
        var r = n.provider,
            i = n.type;
        return e.filter(function (e) {
          return e.type === i && t.providerSupports(r, e);
        });
      },
          h = function h(e, t, n) {
        var r = e.getProviders(),
            o = e.get("preload"),
            s = e.get("jwStart"),
            a = Object.assign({}, t);
        if (a.preload = i(t.preload, o), a.allSources = d(a, e), a.sources = p(a.allSources, r), a.sources.length) return a.file = a.sources[0].file, a.feedData = n, a.starttime = -1 !== s && e.get("generateSEOMetadata") ? s : a.starttime, function (e) {
          var t = e.sources[0].liveSyncDuration;
          return t && (e.liveSyncDuration = e.dvrSeekLimit = t), e;
        }(a);
      },
          f = function f(e, t, n) {
        var r = Object.assign({}, n);
        return delete r.playlist, e.map(function (e) {
          return h(t, e, r);
        }).filter(Boolean);
      },
          g = function g(e) {
        if (!Array.isArray(e) || 0 === e.length) throw new l.rG(l.ul, 630);
      },
          m = function m(e, t) {
        var n = (parseInt(e, 10) || 0) % t;
        return n < 0 && (n += t), n;
      },
          y = function y(e, t) {
        return p(d(e, t), t.getProviders());
      },
          v = function v(e) {
        return (Array.isArray(e) ? e : [e]).map(o.Z);
      };
    },
    6053: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return o;
        }
      });
      var r = n(7034),
          i = n(2957);

      var o = function o(e) {
        if (!e || !e.file) return;
        var t = Object.assign({}, {
          "default": !1,
          type: ""
        }, e);
        t.file = (0, i.fy)("".concat(t.file));
        var n = /^[^/]+\/(?:x-)?([^/]+)$/,
            o = t.type;

        if (n.test(o) && (t.mimeType = o, t.type = o.replace(n, "$1")), (0, r.isYouTube)(t.file) ? t.type = "youtube" : (0, r.isRtmp)(t.file) ? t.type = "rtmp" : t.type || (t.type = (0, i.AO)(t.file)), t.type) {
          switch (t.type) {
            case "m3u8":
            case "vnd.apple.mpegurl":
              t.type = "hls";
              break;

            case "dash+xml":
              t.type = "dash";
              break;

            case "m4a":
              t.type = "aac";
              break;

            case "smil":
              t.type = "rtmp";
          }

          return Object.keys(t).forEach(function (e) {
            "" === t[e] && delete t[e];
          }), t;
        }
      };
    },
    4101: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return u;
        }
      });
      var r = n(676),
          i = n(9888),
          o = n(2957),
          s = n(4446),
          a = n(3487);

      var l = function l(e) {
        if ("string" != typeof e) return;
        var t = (e = e.split("?")[0]).indexOf("://");
        if (t > 0) return 0;
        var n = e.indexOf("/"),
            r = (0, o.AO)(e);
        return !(t < 0 && n < 0) || r && isNaN(r) ? 1 : 2;
      },
          c = function c(e) {
        this.url = e, this.promise_ = null;
      };

      Object.defineProperties(c.prototype, {
        promise: {
          get: function get() {
            return this.load();
          },
          set: function set() {}
        }
      }), Object.assign(c.prototype, {
        load: function load() {
          var _this9 = this;

          var e = this.promise_;

          if (!e) {
            if (2 === l(this.url)) return Promise.resolve(this);

            var _t10 = new r.ZP(function (e) {
              switch (l(e)) {
                case 0:
                  return e;

                case 1:
                  return (0, i.getAbsolutePath)(e, window.location.href);
              }
            }(this.url));

            this.loader = _t10, e = _t10.load().then(function () {
              return _this9;
            }), this.promise_ = e;
          }

          return e;
        },
        registerPlugin: function registerPlugin(e, t, n) {
          this.name = e, this.target = t, this.js = n;
        },
        getNewInstance: function getNewInstance(e, t, n) {
          var r = this.js;
          if ("function" != typeof r) throw new s.rG(null, (0, a.bX)(this.url) + 100);
          var i = new r(e, t, n);
          return i.addToPlayer = function () {
            var e = this.getContainer().querySelector(".jw-overlays");
            e && (n.left = e.style.left, n.top = e.style.top, e.appendChild(n));
          }, i.resizeHandler = function () {
            var e = this.getContainer().querySelector(".jw-overlays");
            e && i.resize(e.clientWidth, e.clientHeight);
          }, i;
        }
      });
      var u = c;
    },
    1241: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return d;
        },
        f: function f() {
          return u;
        }
      });
      var r = n(4446),
          i = n(3487);

      var o = function o() {
        this.load = function (e, t, n, o) {
          return n && "object" == _typeof(n) ? Promise.all(Object.keys(n).filter(function (e) {
            return e;
          }).map(function (s) {
            var a = n[s];
            return t.setupPlugin(s).then(function (t) {
              if (!o.attributes._destroyed) return (0, i.MK)(t, a, e);
            })["catch"](function (e) {
              return t.removePlugin(s), e.code ? e : new r.rG(null, (0, i.bX)(s), e);
            });
          })) : Promise.resolve();
        };
      };

      var s = n(4101),
          a = n(5499);
      var l = {};

      var c = new ( /*#__PURE__*/function () {
        function _class() {
          _classCallCheck(this, _class);
        }

        _createClass(_class, [{
          key: "setupPlugin",
          value: function setupPlugin(e) {
            var t = this.getPlugin(e);
            if (t) return t.url !== e && (0, a.c)("JW Plugin \"".concat((0, i.Nq)(e), "\" already loaded from \"").concat(t.url, "\". Ignoring \"").concat(e, ".\"")), t.promise;
            return this.addPlugin(e).load();
          }
        }, {
          key: "addPlugin",
          value: function addPlugin(e) {
            var t = (0, i.Nq)(e);
            var n = l[t];
            return n || (n = new s.Z(e), l[t] = n), n;
          }
        }, {
          key: "getPlugin",
          value: function getPlugin(e) {
            return l[(0, i.Nq)(e)];
          }
        }, {
          key: "removePlugin",
          value: function removePlugin(e) {
            delete l[(0, i.Nq)(e)];
          }
        }, {
          key: "getPlugins",
          value: function getPlugins() {
            return l;
          }
        }]);

        return _class;
      }())(),
          u = function u(e, t, n) {
        var r = c.addPlugin(e);
        r.js || r.registerPlugin(e, t, n);
      };

      function d(e, t) {
        var n = e.get("plugins");
        window.jwplayerPluginJsonp = u;
        return (e.pluginLoader = e.pluginLoader || new o()).load(t, c, n, e).then(function (t) {
          if (!e.attributes._destroyed) return delete window.jwplayerPluginJsonp, t;
        });
      }
    },
    7164: function _(e, t, n) {
      "use strict";

      n.d(t, {
        MK: function MK() {
          return s;
        },
        Nq: function Nq() {
          return r;
        },
        bX: function bX() {
          return o;
        }
      });

      var r = function r(e) {
        var t = /\/((.(?!\/))+?)\.js/i.exec(e),
            n = (null == t ? void 0 : t[1]) || e;
        return n && "jwpsrv-dnt" === n ? "jwpsrv" : n;
      },
          i = function i(e) {
        var t = null == e || null == e.match ? void 0 : e.match(/\?(.*)/);
        if (!e || !t || !t[1]) return {};
        var n = {};
        return (t[1].includes("#") ? t[1].split("#")[0] : t[1]).split("&").forEach(function (e) {
          var _e$split = e.split("="),
              _e$split2 = _slicedToArray(_e$split, 2),
              t = _e$split2[0],
              _e$split2$ = _e$split2[1],
              r = _e$split2$ === void 0 ? "" : _e$split2$,
              i = decodeURIComponent(r);

          !function (e, t) {
            if (null == e) throw new TypeError("Cannot convert undefined or null to object");
            return Object.prototype.hasOwnProperty.call(Object(e), t);
          }(n, t) ? n[t] = i : (Array.isArray(n[t]) || (n[t] = [n[t]]), n[t].push(i));
        }), n;
      },
          o = function o(e) {
        return 305e3;
      },
          s = function s(e, t, n) {
        var r = e.name,
            o = Object.assign({}, t, i(e.url));
        var s = document.createElement("div");
        s.id = "".concat(n.id, "_").concat(r), s.className = "jw-plugin jw-reset";
        var a = e.getNewInstance(n, o, s);
        return n.addPlugin(r, a), a;
      };
    },
    7683: function _(e, t, n) {
      "use strict";

      n.d(t, {
        V: function V() {
          return o;
        },
        Z: function Z() {
          return s;
        }
      });
      var r = n(658);

      var i = function i(e) {
        e.src || e.load();
      },
          o = function o(e) {
        var t = document.createElement("video");
        return t.className = "jw-video jw-reset", t.setAttribute("tabindex", "-1"), t.setAttribute("disableRemotePlayback", ""), t.setAttribute("webkit-playsinline", ""), t.setAttribute("playsinline", ""), e && Object.keys(e).forEach(function (n) {
          t.setAttribute(n, e[n]);
        }), t;
      };

      function s() {
        var e = r.Jx,
            t = [],
            n = [];

        for (var _r7 = 0; _r7 < e; _r7++) {
          var _e20 = o();

          t.push(_e20), n.push(_e20), i(_e20);
        }

        var s = n.shift(),
            a = n.shift();
        var l = !1;
        return {
          primed: function primed() {
            return l;
          },
          prime: function prime() {
            t.forEach(i), l = !0;
          },
          played: function played() {
            l = !0;
          },
          getPrimedElement: function getPrimedElement() {
            return n.shift() || null;
          },
          getAdElement: function getAdElement() {
            return s;
          },
          getTestElement: function getTestElement() {
            return a;
          },
          clean: function clean(e) {
            if (e.src) {
              e.removeAttribute("src");

              try {
                e.load();
              } catch (e) {}
            }
          },
          recycle: function recycle(e) {
            e && !n.some(function (t) {
              return t === e;
            }) && (this.clean(e), n.push(e));
          },
          syncVolume: function syncVolume(e) {
            var n = Math.min(Math.max(0, e / 100), 1);
            t.forEach(function (e) {
              e.volume = n;
            });
          },
          syncMute: function syncMute(e) {
            t.forEach(function (t) {
              t.muted = e;
            });
          }
        };
      }
    },
    658: function _(e, t, n) {
      "use strict";

      n.d(t, {
        HB: function HB() {
          return o;
        },
        Jx: function Jx() {
          return r;
        },
        l_: function l_() {
          return i;
        }
      });
      var r = 4,
          i = 5,
          o = 1;
    },
    4609: function _(e, t, n) {
      "use strict";

      function r(e, t) {
        return Object.assign({}, t, {
          prime: function prime() {
            e.src || e.load();
          },
          getPrimedElement: function getPrimedElement() {
            return e;
          },
          clean: function clean() {
            t.clean(e);
          },
          recycle: function recycle() {
            t.clean(e);
          }
        });
      }

      n.d(t, {
        Z: function Z() {
          return r;
        }
      });
    },
    6528: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return l;
        }
      });
      var r = n(1643),
          i = n(1384);

      var o = function o() {},
          s = function s() {
        return !1;
      },
          a = {
        name: "default"
      },
          l = {
        supports: s,
        play: o,
        pause: o,
        preload: o,
        load: o,
        stop: o,
        volume: o,
        mute: o,
        seek: o,
        resize: o,
        remove: o,
        destroy: o,
        setVisibility: o,
        setFullscreen: function setFullscreen(e) {
          return (0, i.CX)(this, e);
        },
        getFullscreen: s,
        supportsFullscreen: s,
        getContainer: o,
        setContainer: o,
        getName: function getName() {
          return a;
        },
        getQualityLevels: o,
        getCurrentQuality: o,
        setCurrentQuality: o,
        getAudioTracks: o,
        getCurrentAudioTrack: o,
        setCurrentAudioTrack: o,
        getSeekRange: function getSeekRange() {
          return {
            start: 0,
            end: this.getDuration()
          };
        },
        setPlaybackRate: o,
        getPlaybackRate: function getPlaybackRate() {
          return 1;
        },
        getBandwidthEstimate: function getBandwidthEstimate() {
          return null;
        },
        getLiveLatency: function getLiveLatency() {
          return null;
        },
        attachMedia: o,
        detachMedia: o,
        init: o,
        setState: function setState(e) {
          this.state = e, this.trigger(r.uc, {
            newstate: e
          });
        },
        sendMediaType: function sendMediaType(e) {
          var _e$ = e[0],
              t = _e$.type,
              n = _e$.mimeType,
              i = "aac" === t || "mp3" === t || "mpeg" === t || n && 0 === n.indexOf("audio/");
          this.trigger(r.oZ, {
            mediaType: i ? "audio" : "video"
          });
        },
        getDuration: function getDuration() {
          return 0;
        },
        trigger: o
      };
    },
    1628: function _(e, t, n) {
      "use strict";

      n.d(t, {
        V: function V() {
          return i;
        }
      });
      var r = n(8348);

      var i = function i(e) {
        return "hls" === e.type && r.OS.android ? !1 !== e.androidhls && !r.Browser.firefox && parseFloat(r.OS.version.version || "0") >= 4.4 : null;
      };
    },
    12: function _(e, t, n) {
      "use strict";

      n.d(t, {
        U: function U() {
          return r;
        }
      });
      var r = {};
    },
    670: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return a;
        }
      });
      var r = n(12),
          i = n(2963),
          o = n(6528),
          s = n(6042);
      n(328);

      function a(e) {
        var t = e.getName().name;

        if (!r.U[t]) {
          if (!(0, s.sE)(i.B, (0, s.wB)({
            name: t
          }))) {
            if (!(0, s.mf)(e.supports)) throw new Error("Tried to register a provider with an invalid object");
            i.B.unshift({
              name: t,
              supports: e.supports
            });
          }

          0, (0, s.ce)(e.prototype, o.Z), r.U[t] = e;
        }
      }
    },
    6593: function _(e, t, n) {
      "use strict";

      n.d(t, {
        B: function B() {
          return l;
        },
        H: function H() {
          return a;
        }
      });
      var r = n(1628),
          i = n(7034),
          o = n(9025);

      var s = {
        aac: "audio/mp4",
        mp4: "video/mp4",
        f4v: "video/mp4",
        m4v: "video/mp4",
        mov: "video/mp4",
        mp3: "audio/mpeg",
        mpeg: "audio/mpeg",
        ogv: "video/ogg",
        ogg: "video/ogg",
        oga: "video/ogg",
        vorbis: "video/ogg",
        webm: "video/webm",
        f4a: "video/aac",
        m3u8: "application/vnd.apple.mpegurl",
        m3u: "application/vnd.apple.mpegurl",
        hls: "application/vnd.apple.mpegurl"
      },
          a = function a(e) {
        if (!o.Z || !o.Z.canPlayType) return !1;
        if (!1 === (0, r.V)(e)) return !1;
        var t = e.file,
            n = e.type;
        if ((0, i.isRtmp)(t, n)) return !1;
        var a = e.mimeType || s[n];
        if (!a) return !1;
        var l = e.mediaTypes;
        return null != l && l.length && (a = [a].concat(l.slice()).join("; ")), Boolean(o.Z.canPlayType(a));
      },
          l = [{
        name: "html5",
        supports: a
      }];
    },
    1384: function _(e, t, n) {
      "use strict";

      n.d(t, {
        CX: function CX() {
          return l;
        },
        IP: function IP() {
          return d;
        },
        If: function If() {
          return a;
        },
        Nm: function Nm() {
          return u;
        }
      });
      var r = n(1643);
      var i,
          o,
          s = !1;

      var a = function a() {
        return s;
      },
          l = function l(e, t) {
        if (t = Boolean(t)) {
          try {
            var _t11 = e.video.webkitEnterFullscreen || e.video.webkitEnterFullScreen;

            _t11 && _t11.apply(e.video);
          } catch (e) {
            return !1;
          }

          return e.getFullscreen();
        }

        var n = e.video.webkitExitFullscreen || e.video.webkitExitFullScreen;
        return n && n.apply(e.video), t;
      },
          c = function c(e, t, n) {
        s = n, e.trigger(r.h7, {
          target: t.target,
          jwstate: n
        });
      },
          u = function u(e, t) {
        i = function i(t) {
          return c(e, t, !0);
        }, o = function o(t) {
          return c(e, t, !1);
        }, t.addEventListener("webkitbeginfullscreen", i), t.addEventListener("webkitendfullscreen", o);
      },
          d = function d(e) {
        e.removeEventListener("webkitbeginfullscreen", i), e.removeEventListener("webkitendfullscreen", o);
      };
    },
    6875: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return r;
        }
      });
      var r = "hidden" in document ? function () {
        return !document.hidden;
      } : "webkitHidden" in document ? function () {
        return !document.webkitHidden;
      } : function () {
        return !0;
      };
    },
    6886: function _(e, t, n) {
      "use strict";

      n.d(t, {
        E: function E() {
          return a;
        },
        h: function h() {
          return p;
        }
      });
      var r = n(9888),
          i = n(7034),
          o = n(4446);

      var s = function s() {},
          a = function a(e) {
        e.onload = null, e.onprogress = null, e.onreadystatechange = null, e.onerror = null, "abort" in e && e.abort();
      },
          l = function l(e, t, n, r) {
        e.onerror(t, e.url, e.xhr, new o.rG(t, n, r));
      },
          c = function c(e, t, n) {
        var r = t.documentElement;
        if (!n.requireValidXML || "parsererror" !== r.nodeName && !r.getElementsByTagName("parsererror").length) return e.responseXML || (e = Object.assign({}, e, {
          responseXML: t
        })), n.oncomplete(e);
        l(n, o.ul, 601);
      },
          u = function u(e) {
        return function (t) {
          var n = t.currentTarget || e.xhr;

          if (clearTimeout(e.timeoutId), e.responseType) {
            if ("json" === e.responseType) return function (e, t) {
              if (!e.response || "string" == typeof e.response && '"' !== e.responseText.substr(1)) try {
                e = Object.assign({}, e, {
                  response: JSON.parse(e.responseText)
                });
              } catch (e) {
                return void l(t, o.ul, 611, e);
              }
              return t.oncomplete(e);
            }(n, e);
          } else {
            var _t12,
                _s3 = n.responseXML;

            if (_s3) try {
              _t12 = _s3.firstChild;
            } catch (e) {}
            if (_s3 && _t12) return c(n, _s3, e);
            var i;
            if (e.useDomParser && n.responseText && !_s3) if (_s3 = (0, r.parseXML)(n.responseText), null != (i = _s3) && i.firstChild) return c(n, _s3, e);
            if (e.requireValidXML) return void l(e, o.ul, 602);
          }

          e.oncomplete(n);
        };
      };

      var d;

      var p = function p(e, t, n, r) {
        var c;
        var p;
        e === Object(e) && (e = (r = e).url);
        var h = Object.assign({
          xhr: null,
          url: e,
          withCredentials: !1,
          retryWithoutCredentials: !1,
          timeout: 6e4,
          timeoutId: -1,
          oncomplete: t || s,
          onerror: n || s,
          mimeType: r && !r.responseType ? "text/xml" : "",
          requireValidXML: !1,
          responseType: null != (c = r) && c.plainText ? "text" : "",
          useDomParser: !1,
          requestFilter: null
        }, r),
            f = d("Error loading file", h);

        if ("XMLHttpRequest" in window) {
          if (p = h.xhr = h.xhr || new window.XMLHttpRequest(), "function" == typeof h.requestFilter) {
            var _t13;

            try {
              _t13 = h.requestFilter({
                url: e,
                xhr: p
              });
            } catch (e) {
              return f(e, 5), p;
            }

            _t13 && "open" in _t13 && "send" in _t13 && (p = h.xhr = _t13);
          }

          p.onreadystatechange = function (e) {
            return function (t) {
              var n = t.currentTarget || e.xhr;

              if (4 === n.readyState) {
                clearTimeout(e.timeoutId);
                var _r8 = n.status;
                if (_r8 >= 400) return void l(e, o.ul, _r8 < 600 ? _r8 : 6);
                if (200 === _r8) return u(e)(t);
                0 === _r8 && (0, i.isFileProtocol)() && !/^[a-z][a-z0-9+.-]*:/.test(e.url) && l(e, o.ul, 7);
              }
            };
          }(h), p.onerror = f, "overrideMimeType" in p ? h.mimeType && p.overrideMimeType(h.mimeType) : h.useDomParser = !0;

          try {
            e = e.replace(/#.*$/, ""), p.open("GET", e, !0);
          } catch (e) {
            return f(e, 3), p;
          }

          if (h.responseType) try {
            p.responseType = h.responseType;
          } catch (e) {}
          h.timeout && (h.timeoutId = setTimeout(function () {
            a(p), l(h, o.ud, 1);
          }, h.timeout), p.onabort = function () {
            clearTimeout(h.timeoutId);
          });

          try {
            h.withCredentials && "withCredentials" in p && (p.withCredentials = !0), p.send();
          } catch (e) {
            f(e, 4);
          }

          return p;
        }

        l(h, o.ud, 2);
      };

      d = function d(e, t) {
        return function (e, n) {
          var r = e.currentTarget || t.xhr;

          if (clearTimeout(t.timeoutId), t.retryWithoutCredentials && t.xhr.withCredentials) {
            a(r);

            var _e21 = Object.assign({}, t, {
              xhr: null,
              withCredentials: !1,
              retryWithoutCredentials: !1
            });

            p(_e21);
          } else !n && r.status >= 400 && r.status < 600 && (n = r.status), l(t, n ? o.ul : o.ud, n || 6, e);
        };
      };
    },
    328: function _(e, t, n) {
      "use strict";

      n.d(t, {
        IH: function IH() {
          return c;
        },
        S1: function S1() {
          return u;
        },
        X$: function X$() {
          return d;
        },
        ZP: function ZP() {
          return a;
        },
        on: function on() {
          return l;
        },
        wj: function wj() {
          return p;
        }
      });

      var r = function r(e, t) {
        if (null == e) throw new TypeError("Cannot convert undefined or null to object");
        return Object.prototype.hasOwnProperty.call(Object(e), t);
      };

      var i = function i(e, t, n, r) {
        var i = -1;
        var o = e.length;

        for (; ++i < o;) {
          var _o4 = e[i];
          if (r) try {
            _o4.callback.apply(_o4.context || n, t);
          } catch (e) {
            console.log("Error in \"".concat(r, "\" event handler:"), e);
          } else _o4.callback.apply(_o4.context || n, t);
        }
      },
          o = /\s+/,
          s = function s(e, t, n, i) {
        if (!n) return !0;

        if ("object" == _typeof(n)) {
          for (var _o5 in n) {
            r(n, _o5) && e[t].apply(e, [_o5, n[_o5]].concat(i));
          }

          return !1;
        }

        if (o.test(n)) {
          var _r9 = n.split(o);

          for (var _n16 = 0, _o6 = _r9.length; _n16 < _o6; _n16++) {
            e[t].apply(e, [_r9[_n16]].concat(i));
          }

          return !1;
        }

        return !0;
      };

      var a = /*#__PURE__*/function () {
        function a() {
          _classCallCheck(this, a);
        }

        _createClass(a, [{
          key: "on",
          value: function on(e, t, n) {
            if (!s(this, "on", e, [t, n]) || !t) return this;
            var r = this._events || (this._events = {});
            return (r[e] || (r[e] = [])).push({
              callback: t,
              context: n
            }), this;
          }
        }, {
          key: "once",
          value: function once(e, t, n) {
            if (!s(this, "once", e, [t, n]) || !t) return this;
            var r = 0;

            var i = this,
                o = function o() {
              r++ || (i.off(e, o), t.apply(this, arguments));
            };

            return o._callback = t, this.on(e, o, n);
          }
        }, {
          key: "off",
          value: function off(e, t, n) {
            if (!this._events || !s(this, "off", e, [t, n])) return this;
            if (!e && !t && !n) return delete this._events, this;
            var r = e ? [e] : Object.keys(this._events);

            for (var _i7 = 0, _o7 = r.length; _i7 < _o7; _i7++) {
              e = r[_i7];
              var _o8 = this._events[e];

              if (_o8) {
                var _r10 = this._events[e] = [];

                if (t || n) for (var _e22 = 0, _i8 = _o8.length; _e22 < _i8; _e22++) {
                  var _i9 = _o8[_e22];
                  (t && t !== _i9.callback && t !== _i9.callback._callback || n && n !== _i9.context) && _r10.push(_i9);
                }
                _r10.length || delete this._events[e];
              }
            }

            return this;
          }
        }, {
          key: "trigger",
          value: function trigger(e) {
            for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              t[_key2 - 1] = arguments[_key2];
            }

            if (!this._events) return this;
            if (!s(this, "trigger", e, t)) return this;
            var n = this._events[e],
                r = this._events.all;
            return n && i(n, t, this), r && i(r, arguments, this), this;
          }
        }, {
          key: "triggerSafe",
          value: function triggerSafe(e) {
            for (var _len3 = arguments.length, t = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
              t[_key3 - 1] = arguments[_key3];
            }

            if (!this._events) return this;
            if (!s(this, "trigger", e, t)) return this;
            var n = this._events[e],
                r = this._events.all;
            return n && i(n, t, this, e), r && i(r, arguments, this, e), this;
          }
        }]);

        return a;
      }();

      var l = a.prototype.on,
          c = a.prototype.once,
          u = a.prototype.off,
          d = a.prototype.trigger,
          p = a.prototype.triggerSafe;
      a.on = l, a.once = c, a.off = u, a.trigger = d;
    },
    2268: function _(e, t, n) {
      "use strict";

      n.d(t, {
        A: function A() {
          return d;
        },
        DF: function DF() {
          return c;
        },
        Dt: function Dt() {
          return v;
        },
        G6: function G6() {
          return m;
        },
        NO: function NO() {
          return j;
        },
        O7: function O7() {
          return b;
        },
        Q6: function Q6() {
          return h;
        },
        cL: function cL() {
          return k;
        },
        dI: function dI() {
          return C;
        },
        gn: function gn() {
          return y;
        },
        i7: function i7() {
          return f;
        },
        id: function id() {
          return l;
        },
        pZ: function pZ() {
          return o;
        },
        tq: function tq() {
          return w;
        },
        un: function un() {
          return u;
        },
        w1: function w1() {
          return g;
        },
        xb: function xb() {
          return s;
        },
        yS: function yS() {
          return p;
        },
        zc: function zc() {
          return a;
        }
      });

      var r = function r(e) {
        return null !== navigator.userAgent.match(e);
      },
          i = function i() {
        return "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1;
      },
          o = function o() {
        return r(/firefox\//i);
      },
          s = function s() {
        return r(/iP(hone|od)/i);
      },
          a = function a() {
        return r(/iPad/i) || i();
      },
          l = function l() {
        return r(/Macintosh/i) && !i();
      },
          c = function c() {
        return r(/FBAV/i);
      },
          u = function u() {
        return r(/\sEdge?\/\d+/i);
      },
          d = function d() {
        return r(/msie/i);
      },
          p = function p() {
        return r(/SMART-TV/);
      },
          h = function h() {
        return p() && !r(/SamsungBrowser/);
      },
          f = function f() {
        return r(/\s(?:(?:Headless)?Chrome|CriOS)\//i) && !u() && !r(/UCBrowser/i);
      },
          g = function g() {
        return !r(/\sEdg\/\d+/i) && (u() || r(/trident\/.+rv:\s*11/i) || d());
      },
          m = function m() {
        return r(/safari/i) && !r(/(?:Chrome|CriOS|chromium|android|phantom)/i) && !p();
      },
          y = function y() {
        return r(/iP(hone|ad|od)/i) || i();
      },
          v = function v() {
        return "boolean" == typeof v.mock_ ? v.mock_ : r(/Android/i) && !r(/Windows Phone/i);
      },
          b = function b() {
        return !(r(/chrome\/[123456789]/i) && !r(/chrome\/18/i) && !o()) && v();
      };

      v.mock_ = null;

      var w = function w() {
        return y() || v() || r(/Windows Phone/i);
      },
          k = function k() {
        if ("boolean" == typeof k.mock_) return k.mock_;

        try {
          return window.self !== window.top;
        } catch (e) {
          return !0;
        }
      };

      k.mock_ = null;

      var j = function j() {
        return !1;
      },
          C = function C() {
        return 0;
      };
    },
    8381: function _(e, t, n) {
      "use strict";

      n.d(t, {
        $W: function $W() {
          return a;
        },
        Mf: function Mf() {
          return c;
        },
        T2: function T2() {
          return u;
        },
        _b: function _b() {
          return l;
        }
      });
      var r = n(8518),
          i = n(2557),
          o = n(4446);

      var s = function s(e) {
        return function (t) {
          return 0 === t.indexOf(e);
        };
      },
          a = function a(e, t) {
        var n = [];
        if (!e || !e.timestamps || !e.timestamps.length) return n;
        var i = e.timestamps.sort(function (e, t) {
          return e.begin - t.begin;
        });
        return i.forEach(function (o, a) {
          var l = function (e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
            var n = (0, r.G3)();
            var i = Object.keys(e.title),
                o = i[0];

            for (; !e.title[n];) {
              var _e23 = i.find(s(n));

              if (_e23) {
                n = _e23;
                break;
              }

              var _t14 = n.lastIndexOf("-");

              if (_t14 <= 0) {
                n = null;
                break;
              }

              n = n.slice(0, _t14);
            }

            return n || (i.indexOf(t) >= 0 ? t : o);
          }(o, e.defaultLanguage),
              c = o.title[l],
              u = o.time,
              d = o.image;

          var p = t;
          a + 1 < i.length && (p = i[a + 1].time);
          var h = {
            begin: u,
            end: p,
            text: c,
            cueType: "chapters"
          };
          d && (h.image = d), n.push(h);
        }), n;
      },
          l = function l(e, t) {
        var n = (0, r.G3)(),
            o = e.reduce(function (e, t) {
          if (!t || !t.cueType || "chapters" === t.cueType) {
            var _r11 = new i.u({
              time: t.begin,
              image: t.image
            });

            _r11.addTitle(n, t.text), e.push(_r11);
          }

          return e;
        }, []);
        return t ? (t.timestamps = o, t) : new i.t(n, o);
      },
          c = function c(e, t) {
        if ("number" != typeof e || e < 0 || !t || !t.length) return null;
        var n = null;

        for (var _r12 = 0; _r12 < t.length; _r12++) {
          var _i10 = t[_r12];
          _i10.time > e || (!n || _i10.time > n.time) && (n = _i10);
        }

        return n;
      },
          u = function u(e, t) {
        var n = !0;
        return e.forEach(function (e) {
          if (!e) return;
          if (!e.defaultLanguage || !e.timestamps) return void (n = !1);
          e.timestamps.some(function (e) {
            return !e.title || null === e.time || void 0 === e.time;
          }) && (n = !1);
        }), t(n ? null : (0, o.l9)(new Error(), o.aD));
      };
    },
    974: function _(e, t, n) {
      "use strict";

      n.d(t, {
        HY: function HY() {
          return f;
        },
        iv: function iv() {
          return d;
        },
        oB: function oB() {
          return u;
        },
        oI: function oI() {
          return a;
        },
        vs: function vs() {
          return p;
        }
      });

      var r = n(2957),
          i = n(9563),
          o = n.n(i),
          s = function s(e, t) {
        if (null == e) throw new TypeError("Cannot convert undefined or null to object");
        return Object.prototype.hasOwnProperty.call(Object(e), t);
      };

      var a = o().clear,
          l = function l(e) {
        e = e.split("-");

        for (var _t15 = 1; _t15 < e.length; _t15++) {
          e[_t15] = e[_t15].charAt(0).toUpperCase() + e[_t15].slice(1);
        }

        return e.join("");
      },
          c = function c(e, t) {
        return "" === t || null == t ? "" : "string" == typeof t && isNaN(t) ? /png|gif|jpe?g/i.test(t) && t.indexOf("url") < 0 ? "url(".concat(t, ")") : t : 0 === t || "z-index" === e || "opacity" === e ? "".concat(t) : /color/i.test(e) ? "#".concat((0, r.vk)(t.toString(16).replace(/^0x/i, ""), 6)) : "".concat(Math.ceil(t), "px");
      },
          u = function u(e, t) {
        if (null == e) return;
        var n;
        void 0 === e.length && (e = [e]);
        var r = {};

        for (n in t) {
          s(t, n) && (r[n] = c(n, t[n]));
        }

        for (var _t16 = 0; _t16 < e.length; _t16++) {
          var _i11 = e[_t16];

          var _o9 = void 0;

          if (null != _i11) for (n in r) {
            s(r, n) && (_o9 = l(n), _i11.style[_o9] !== r[n] && (_i11.style[_o9] = r[n]));
          }
        }
      },
          d = function d(e, t, n, r) {
        n = n || "all-players";
        var i = "";

        if ("object" == _typeof(t)) {
          var _e24 = document.createElement("div");

          u(_e24, t);
          var _n17 = _e24.style.cssText;
          s(t, "content") && _n17 && (_n17 = "".concat(_n17, " content: \"").concat(t.content, "\";")), r && _n17 && (_n17 = _n17.replace(/;/g, " !important;")), i = "{".concat(_n17, "}");
        } else "string" == typeof t && (i = t);

        "" !== i && "{}" !== i ? o().style([[e, e + i]], n) : o().clear(n, e);
      },
          p = function p(e, t) {
        u(e, {
          transform: t
        });
      };

      var h;

      var f = function f(e, t) {
        var n = "rgb";
        var r = void 0 !== t && 100 !== t;

        if (r && (n += "a"), !h) {
          var _e25 = document.createElement("canvas");

          _e25.height = 1, _e25.width = 1, h = _e25.getContext("2d");
        }

        e ? isNaN(parseInt(e, 16)) || (e = "#".concat(e)) : e = "#000000", h.clearRect(0, 0, 1, 1), h.fillStyle = e, h.fillRect(0, 0, 1, 1);
        var i = h.getImageData(0, 0, 1, 1).data;
        return n += "(".concat(i[0], ", ").concat(i[1], ", ").concat(i[2]), r && (n += ", " + t / 100), "".concat(n, ")");
      };
    },
    5004: function _(e, t, n) {
      "use strict";

      n.d(t, {
        z: function z() {
          return r;
        }
      });

      var r = Date.now || function () {
        return new Date().getTime();
      };
    },
    2799: function _(e, t, n) {
      "use strict";

      n.d(t, {
        A8: function A8() {
          return T;
        },
        AH: function AH() {
          return Z;
        },
        EU: function EU() {
          return m;
        },
        FK: function FK() {
          return v;
        },
        IV: function IV() {
          return C;
        },
        L_: function L_() {
          return P;
        },
        P$: function P$() {
          return O;
        },
        SH: function SH() {
          return A;
        },
        UM: function UM() {
          return F;
        },
        Ww: function Ww() {
          return I;
        },
        az: function az() {
          return g;
        },
        bJ: function bJ() {
          return f;
        },
        cS: function cS() {
          return E;
        },
        cn: function cn() {
          return j;
        },
        gB: function gB() {
          return h;
        },
        i3: function i3() {
          return _;
        },
        kq: function kq() {
          return S;
        },
        nG: function nG() {
          return M;
        },
        nh: function nh() {
          return y;
        },
        oH: function oH() {
          return d;
        },
        og: function og() {
          return x;
        },
        pv: function pv() {
          return c;
        },
        s1: function s1() {
          return k;
        }
      });
      var r = n(2957),
          i = n(6042),
          o = n(8348);
      var s = window.DOMParser;
      var a,
          l = !0;

      var c = function c(e, t) {
        return e.classList.contains(t);
      },
          u = function u(e) {
        if (a || (a = new s(), l = function () {
          try {
            if (a.parseFromString("", "text/html")) return !0;
          } catch (e) {}

          return !1;
        }()), l) return a.parseFromString(e, "text/html").body;
        var t = document.implementation.createHTMLDocument("");
        return e.toLowerCase().indexOf("<!doctype") > -1 ? t.documentElement.innerHTML = e : t.body.innerHTML = e, t.body;
      },
          d = function d(e) {
        var t = e.querySelectorAll("script,object,iframe,meta");

        for (var _e26 = t.length; _e26--;) {
          var _n18 = t[_e26];

          _n18.parentNode.removeChild(_n18);
        }

        return e;
      },
          p = /^((((https?):\/\/)|(mailto:))(%[0-9A-Fa-f]{2}|[-()_.!~*';/?:@&=+$,A-Za-z0-9])+)([).!';/?:,][[:blank:|:blank:]])?$/,
          h = function h(e) {
        var t = e.attributes;

        for (var _n19 = t.length; _n19--;) {
          var _r13 = t[_n19].name;

          if (/^on/.test(_r13) && e.removeAttribute(_r13), /href/.test(_r13)) {
            var _i12 = t[_n19].value;
            !/javascript:|javascript&colon;/.test(_i12) && p.test(_i12) || (e.removeAttribute(_r13), console.warn("Invalid or unsafe URL"));
          }
        }

        return e;
      },
          f = function f(e) {
        var t = u(e);
        d(t);
        var n = t.querySelectorAll("*");

        for (var _e27 = n.length; _e27--;) {
          var _t17 = n[_e27];
          h(_t17);
        }

        return t;
      },
          g = function g(e) {
        return f(e).firstChild;
      },
          m = function m(e) {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }
      },
          y = function y(e, t) {
        m(e), function (e, t) {
          if (!t) return;
          var n = document.createDocumentFragment(),
              r = f(t).childNodes;

          for (var _e28 = 0; _e28 < r.length; _e28++) {
            n.appendChild(r[_e28].cloneNode(!0));
          }

          e.appendChild(n);
        }(e, t);
      },
          v = function v(e) {
        return e + (e.toString().indexOf("%") > 0 ? "" : "px");
      },
          b = function b(e) {
        return (0, i.HD)(e.className) ? e.className.split(" ") : [];
      },
          w = function w(e, t) {
        t = (0, r.fy)(t), e.className !== t && (e.className = t);
      },
          k = function k(e) {
        return e.classList ? e.classList : b(e);
      },
          j = function j(e, t) {
        var n = b(e);
        (Array.isArray(t) ? t : t.split(" ")).forEach(function (e) {
          (0, i.r3)(n, e) || n.push(e);
        }), w(e, n.join(" "));
      },
          C = function C(e, t) {
        var n = b(e),
            r = Array.isArray(t) ? t : t.split(" ");
        w(e, (0, i.e5)(n, r).join(" "));
      },
          P = function P(e, t, n) {
        var r = e.className || "";
        t.test(r) ? r = r.replace(t, n) : n && (r += " ".concat(n)), w(e, r);
      },
          x = function x(e, t, n) {
        var r = c(e, t);
        (n = (0, i.jn)(n) ? n : !r) !== r && (n ? j(e, t) : C(e, t));
      },
          O = function O(e, t, n) {
        e.setAttribute(t, n);
      },
          S = function S(e) {
        var t = document.createElement("link");
        t.rel = "stylesheet", t.href = e, document.getElementsByTagName("head")[0].appendChild(t);
      },
          E = function E(e) {
        e && m(e);
      },
          T = function T(e) {
        var t = {
          left: 0,
          right: 0,
          width: 0,
          height: 0,
          top: 0,
          bottom: 0
        };
        if (!e || !document.body.contains(e)) return t;
        var n = e.getBoundingClientRect(),
            r = window.pageYOffset,
            i = window.pageXOffset;
        return n.width || n.height || n.left || n.top ? (t.left = n.left + i, t.right = n.right + i, t.top = n.top + r, t.bottom = n.bottom + r, t.width = n.right - n.left, t.height = n.bottom - n.top, t) : t;
      },
          A = function A(e, t) {
        e.insertBefore(t, e.firstChild);
      },
          Z = function Z(e) {
        return e.nextElementSibling;
      },
          _ = function _(e) {
        return e.previousElementSibling;
      },
          M = function M(e, t) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : document;
        if (!p.test(e)) return;
        var i = r.createElement("a");
        i.href = e, i.target = t, i = h(Object.assign(i, n)), o.Browser.firefox ? i.dispatchEvent(new MouseEvent("click", {
          bubbles: !0,
          cancelable: !0,
          view: window
        })) : i.click();
      },
          F = function F() {
        var e = window.screen.orientation;
        return !!e && ("landscape-primary" === e.type || "landscape-secondary" === e.type) || 90 === window.orientation || -90 === window.orientation;
      },
          I = function I(e) {
        return function (e) {
          var t = document.createElement("textarea");
          return t.innerHTML = e, t.value;
        }(e).replace(/&|<|>|"|''/gm, function (e) {
          return "&#".concat(e.charCodeAt(0), ";");
        }).replace(/&#60;(\/?)(b|strong|i|em|p|br|ul|ol|li|h.)&#62;/gim, "<$1$2>");
      };
    },
    4429: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return b;
        }
      });
      var r = n(1569),
          i = n(7034),
          o = n(9888),
          s = n(2957),
          a = n(7411),
          l = n(4742);

      var c = function c(e, t) {
        this.name = e, this.message = t.message || t.toString(), this.error = t;
      };

      var u = n(6042),
          d = n(2268),
          p = n(2799),
          h = n(974),
          f = n(6886),
          g = n(1261),
          m = n(5499),
          y = n(6234),
          v = function v(e, t) {
        if (null == e) throw new TypeError("Cannot convert undefined or null to object");
        return Object.prototype.hasOwnProperty.call(Object(e), t);
      };

      var b = Object.assign({}, o, i, r, {
        addClass: p.cn,
        hasClass: p.pv,
        removeClass: p.IV,
        replaceClass: p.L_,
        toggleClass: p.og,
        classList: p.s1,
        styleDimension: p.FK,
        createElement: p.az,
        emptyElement: p.EU,
        addStyleSheet: p.kq,
        bounds: p.A8,
        openLink: p.nG,
        replaceInnerHtml: p.nh,
        css: h.iv,
        clearCss: h.oI,
        style: h.oB,
        transform: h.vs,
        getRgba: h.HY,
        ajax: f.h,
        crossdomain: function crossdomain(e) {
          var t = window.URL;

          try {
            var _n20 = new t(e, location.origin);

            return "".concat(location.protocol, "//").concat(location.host) != "".concat(_n20.protocol, "//").concat(_n20.host);
          } catch (e) {}

          return !0;
        },
        tryCatch: function tryCatch(e, t) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
          if (l.Z.debug) return e.apply(t || this, n);

          try {
            return e.apply(t || this, n);
          } catch (t) {
            return new c(e.name, t);
          }
        },
        Error: c,
        Timer: a.Z,
        log: m.c,
        genId: y.B,
        between: g.v,
        foreach: function foreach(e, t) {
          for (var _n21 in e) {
            v(e, _n21) && t(_n21, e[_n21]);
          }
        },
        flashVersion: d.dI,
        isIframe: d.cL,
        indexOf: u.cq,
        trim: s.fy,
        pad: s.vk,
        extension: s.AO,
        hms: s.WZ,
        seconds: s.m9,
        prefix: s.O4,
        suffix: s.uA,
        noop: function noop() {}
      });
    },
    7543: function _(e, t, n) {
      "use strict";

      n.d(t, {
        C: function C() {
          return r;
        }
      });

      var r = function r(e) {
        return !!(e = e || window.event) && Boolean(e) && /^(?:mouse|pointer|touch|gesture|click|key)/.test(e.type);
      };
    },
    8518: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Cq: function Cq() {
          return g;
        },
        Dq: function Dq() {
          return P;
        },
        G3: function G3() {
          return y;
        },
        Mh: function Mh() {
          return O;
        },
        Pm: function Pm() {
          return j;
        },
        dl: function dl() {
          return C;
        },
        id: function id() {
          return f;
        },
        q2: function q2() {
          return w;
        },
        t6: function t6() {
          return b;
        },
        tK: function tK() {
          return h;
        }
      });
      var r = n(6042),
          i = n(2268),
          o = n(6886),
          s = n(7034),
          a = n(696);

      var l = {},
          c = {
        aa: "Afar",
        ab: "Abkhazian",
        ae: "Avestan",
        af: "Afrikaans",
        ak: "Akan",
        am: "Amharic",
        ar: "Arabic",
        an: "Aragonese",
        as: "Assamese",
        av: "Avaric",
        ay: "Aymara",
        az: "Azerbaijani",
        ba: "Bashkir",
        be: "Belarusian",
        bg: "Bulgarian",
        bh: "Bihari languages",
        bi: "Bislama",
        bm: "Bambara",
        bn: "Bengali",
        bo: "Tibetan",
        br: "Breton",
        bs: "Bosnian",
        ca: "Catalan",
        ce: "Chechen",
        ch: "Chamorro",
        co: "Corsican",
        cr: "Cree",
        cs: "Czech",
        cu: "Church Slavic",
        cv: "Chuvash",
        cy: "Welsh",
        da: "Danish",
        de: "German",
        dv: "Divehi",
        dz: "Dzongkha",
        ee: "Ewe",
        el: "Greek",
        en: "English",
        eo: "Esperanto",
        es: "Spanish",
        et: "Estonian",
        eu: "Basque",
        fa: "Persian",
        ff: "Fulah",
        fi: "Finnish",
        fj: "Fijian",
        fo: "Faroese",
        fr: "French",
        fy: "Western Frisian",
        ga: "Irish",
        gd: "Gaelic",
        gl: "Galician",
        gn: "Guarani",
        gu: "Gujarati",
        gv: "Manx",
        ha: "Hausa",
        he: "Hebrew",
        hi: "Hindi",
        ho: "Hiri Motu",
        hr: "Croatian",
        ht: "Haitian",
        hu: "Hungarian",
        hy: "Armenian",
        hz: "Herero",
        ia: "Interlingua",
        id: "Indonesian",
        ie: "Interlingue",
        ig: "Igbo",
        ii: "Sichuan Yi",
        ik: "Inupiaq",
        io: "Ido",
        is: "Icelandic",
        it: "Italian",
        iu: "Inuktitut",
        ja: "Japanese",
        jv: "Javanese",
        ka: "Georgian",
        kg: "Kongo",
        ki: "Kikuyu",
        kj: "Kuanyama",
        kk: "Kazakh",
        kl: "Kalaallisut",
        km: "Central Khmer",
        kn: "Kannada",
        ko: "Korean",
        kr: "Kanuri",
        ks: "Kashmiri",
        ku: "Kurdish",
        kv: "Komi",
        kw: "Cornish",
        ky: "Kirghiz",
        la: "Latin",
        lb: "Luxembourgish",
        lg: "Ganda",
        li: "Limburgan",
        lo: "Lao",
        ln: "Lingala",
        lt: "Lithuanian",
        lu: "Luba-Katanga",
        lv: "Latvian",
        mg: "Malagasy",
        mh: "Marshallese",
        mi: "Maori",
        mk: "Macedonian",
        ml: "Malayalam",
        mn: "Mongolian",
        mr: "Marathi",
        ms: "Malay",
        mt: "Maltese",
        my: "Burmese",
        na: "Nauru",
        nb: "Bokmål",
        nd: "Ndebele",
        ne: "Nepali",
        ng: "Ndonga",
        nl: "Dutch",
        nn: "Norwegian Nynorsk",
        no: "Norwegian",
        nr: "Ndebele",
        nv: "Navajo",
        ny: "Chichewa",
        oc: "Occitan",
        oj: "Ojibwa",
        om: "Oromo",
        or: "Oriya",
        os: "Ossetian",
        pa: "Panjabi",
        pi: "Pali",
        pl: "Polish",
        pt: "Portuguese",
        ps: "Pushto",
        qu: "Quechua",
        rm: "Romansh",
        rn: "Rundi",
        ro: "Romanian",
        ru: "Russian",
        rw: "Kinyarwanda",
        sa: "Sanskrit",
        sc: "Sardinian",
        sd: "Sindhi",
        se: "Northern Sami",
        sg: "Sango",
        si: "Sinhala",
        sk: "Slovak",
        sl: "Slovenian",
        sm: "Samoan",
        sn: "Shona",
        so: "Somali",
        sq: "Albanian",
        sr: "Serbian",
        ss: "Swati",
        st: "Sotho",
        su: "Sundanese",
        sw: "Swahili",
        sv: "Swedish",
        ta: "Tamil",
        te: "Telugu",
        tg: "Tajik",
        th: "Thai",
        ti: "Tigrinya",
        tk: "Turkmen",
        tl: "Tagalog",
        tn: "Tswana",
        to: "Tonga",
        tr: "Turkish",
        ts: "Tsonga",
        tt: "Tatar",
        tw: "Twi",
        ty: "Tahitian",
        ug: "Uighur",
        uk: "Ukrainian",
        ur: "Urdu",
        uz: "Uzbek",
        ve: "Venda",
        vi: "Vietnamese",
        vo: "Volapük",
        wa: "Walloon",
        wo: "Wolof",
        xh: "Xhosa",
        yi: "Yiddish",
        yo: "Yoruba",
        za: "Zhuang",
        zh: "Chinese",
        zu: "Zulu"
      },
          u = (0, r.U_)(c),
          d = function d(e) {
        return e.toLowerCase().replace("-", "_");
      },
          p = function p(e) {
        var t = d(e),
            n = t.indexOf("_");
        return -1 === n ? t : t.substring(0, n);
      },
          h = function h(e) {
        return e ? Object.keys(e).reduce(function (t, n) {
          return t[d(n)] = e[n], t;
        }, {}) : {};
      },
          f = function f(e) {
        if (e) return 3 === e.length ? e : c[p(e)] || e;
      },
          g = function g(e) {
        return u[e] || "";
      },
          m = function m(e) {
        var t = e.querySelector("html");
        return t ? t.getAttribute("lang") : null;
      },
          y = function y() {
        if ("string" == typeof y.mock_) return y.mock_;
        var e = m(document);
        if (!e && (0, i.cL)()) try {
          e = m(window.top.document);
        } catch (e) {}
        return e || navigator.language || "en";
      };

      y.mock_ = null;

      var v = ["ar", "da", "de", "el", "es", "fi", "fr", "he", "id", "it", "ja", "ko", "nb", "nl", "nn", "no", "oc", "pt", "ro", "ru", "sl", "sv", "th", "tr", "vi", "zh"],
          b = function b(e) {
        return 8207 === e.charCodeAt(0) || /^[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/.test(e);
      },
          w = function w(e) {
        return "boolean" == typeof w.mock_ ? w.mock_ : v.indexOf(p(e)) >= 0;
      };

      w.mock_ = null;

      var k = function k(e, t, n) {
        var r = e[n] || t[n];
        r && (e[n] = r);
      },
          j = function j(e, t, n) {
        return Object.assign({}, function (e) {
          var t = e.advertising,
              n = e.related,
              r = e.sharing,
              i = e.abouttext,
              o = Object.assign({}, e.localization);
          t && (o.advertising = o.advertising || {}, k(o.advertising, t, "admessage"), k(o.advertising, t, "cuetext"), k(o.advertising, t, "loadingAd"), k(o.advertising, t, "podmessage"), k(o.advertising, t, "skipmessage"), k(o.advertising, t, "skiptext")), "string" == typeof o.related ? o.related = {
            heading: o.related
          } : o.related = o.related || {}, n && k(o.related, n, "autoplaymessage"), r && (o.sharing = o.sharing || {}, k(o.sharing, r, "heading"), k(o.sharing, r, "copied")), i && k(o, e, "abouttext");
          var s = o.close || o.nextUpClose;
          return s && (o.close = s), o;
        }(e), t[p(n)], t[d(n)]);
      },
          C = function C(e) {
        return "boolean" == typeof C.mock_ ? C.mock_ : (0, s.isDeepKeyCompliant)(a.Z, e, function (e, t) {
          return "string" == typeof t[e];
        });
      };

      C.mock_ = null;

      var P = function P(e, t) {
        if ("function" == typeof P.mock_) return P.mock_;
        var n = l[t];

        if (!n) {
          var _i13 = "".concat(e, "translations/").concat((r = p(t), /^n[bn]$/.test(r) ? "no" : r), ".json");

          l[t] = n = new Promise(function (e, n) {
            (0, o.h)({
              url: _i13,
              oncomplete: e,
              onerror: function onerror(e, r, i, o) {
                l[t] = null, n(o);
              },
              responseType: "json"
            });
          });
        }

        var r;
        return n;
      };

      P.mock_ = null;

      var x = function x(e, t, n, r) {
        e[t] = Object.assign({}, n[t], r[t]);
      },
          O = function O(e, t) {
        var n = Object.assign({}, e, t);
        return x(n, "errors", e, t), x(n, "related", e, t), x(n, "sharing", e, t), x(n, "advertising", e, t), x(n, "shortcuts", e, t), x(n, "captionsStyles", e, t), n;
      };
    },
    5499: function _(e, t, n) {
      "use strict";

      n.d(t, {
        c: function c() {
          return r;
        }
      });
      var r = "function" == typeof console.log ? console.log.bind(console) : function () {};
    },
    1261: function _(e, t, n) {
      "use strict";

      n.d(t, {
        v: function v() {
          return r;
        }
      });

      var r = function r(e, t, n) {
        return Math.max(Math.min(e, n), t);
      };
    },
    9888: function _(e, t, n) {
      "use strict";

      n.r(t), n.d(t, {
        getAbsolutePath: function getAbsolutePath() {
          return s;
        },
        isAbsolutePath: function isAbsolutePath() {
          return o;
        },
        parseDimension: function parseDimension() {
          return c;
        },
        parseXML: function parseXML() {
          return a;
        },
        serialize: function serialize() {
          return l;
        },
        timeFormat: function timeFormat() {
          return u;
        },
        timeFormatAria: function timeFormatAria() {
          return d;
        }
      });
      var r = n(7034),
          i = n(6042);

      var o = function o(e) {
        return /^(?:(?:https?|file):)?\/\//.test(e);
      },
          s = function s(e, t) {
        if (t && (0, r.exists)(t) || (t = document.location.href), !(0, r.exists)(e)) return "";
        if (o(e)) return e;
        var n = t.substring(0, t.indexOf("://") + 3),
            i = t.substring(n.length, t.indexOf("/", n.length + 1));
        var s;
        if (0 === e.indexOf("/")) s = e.split("/");else {
          var _r14 = t.split("?")[0];
          _r14 = _r14.substring(n.length + i.length + 1, _r14.lastIndexOf("/")), s = _r14.split("/").concat(e.split("/"));
        }
        var a = [];

        for (var _e29 = 0; _e29 < s.length; _e29++) {
          s[_e29] && (0, r.exists)(s[_e29]) && "." !== s[_e29] && (".." === s[_e29] ? a.pop() : a.push(s[_e29]));
        }

        return "".concat(n).concat(i, "/").concat(a.join("/"));
      },
          a = function a(e) {
        var t = null;

        try {
          t = new window.DOMParser().parseFromString(e, "text/xml"), t.querySelector("parsererror") && (t = null);
        } catch (e) {}

        return t;
      },
          l = function l(e) {
        if (void 0 === e) return null;

        if ("string" == typeof e && e.length < 6) {
          var _t18 = e.toLowerCase();

          if ("true" === _t18) return !0;
          if ("false" === _t18) return !1;
          if (!(0, i.i2)(Number(e)) && !(0, i.i2)(parseFloat(e))) return Number(e);
        }

        return e;
      },
          c = function c(e) {
        return (0, i.qh)(e) ? e : "" === e ? 0 : e.lastIndexOf("%") > -1 ? e : parseInt(e.replace("px", ""), 10);
      },
          u = function u(e, t) {
        if ((0, i.i2)(e) && (e = parseInt(e.toString(), 10)), (0, i.i2)(e) || !isFinite(e) || e <= 0 && !t) return "00:00";
        var n = e < 0 ? "-" : "";
        e = Math.abs(e);
        var r = Math.floor(e / 3600),
            o = Math.floor((e - 3600 * r) / 60),
            s = Math.floor(e % 60);
        return "".concat(n + (r ? "".concat(r, ":") : "") + (o < 10 ? "0" : "") + o, ":").concat(s < 10 ? "0" : "").concat(s);
      },
          d = function d(e) {
        if ((0, i.i2)(e) && (e = parseInt(e.toString(), 10)), (0, i.i2)(e) || !isFinite(e) || e <= 0) return "0 seconds";
        var t = Math.floor(e / 3600),
            n = Math.floor((e - 3600 * t) / 60),
            r = Math.floor(e % 60);
        return (t ? t + (t >= 1 ? " hour".concat(t > 1 ? "s" : "", ", ") : "") : "") + (n ? n + (n >= 1 ? " minute".concat(n > 1 ? "s" : "", ", ") : "") : "") + r + (r >= 1 ? " second" + (r > 1 ? "s" : "") : "");
      };
    },
    1569: function _(e, t, n) {
      "use strict";

      n.r(t), n.d(t, {
        getScriptPath: function getScriptPath() {
          return o;
        },
        loadFrom: function loadFrom() {
          return l;
        },
        repo: function repo() {
          return s;
        },
        versionCheck: function versionCheck() {
          return a;
        }
      });
      var r = n(6601),
          i = n(7034);

      var o = function o(e) {
        {
          var _t19 = document.getElementsByTagName("script");

          for (var _n22 = 0; _n22 < _t19.length; _n22++) {
            var _r15 = _t19[_n22].src;

            if (_r15) {
              var _t20 = _r15.lastIndexOf("/".concat(e));

              if (_t20 >= 0) return _r15.substr(0, _t20 + 1);
            }
          }
        }
        return "";
      },
          s = function s() {
        var e = "//ssl.p.jwpcdn.com/player/v/8.26.7";
        return "".concat((0, i.isFileProtocol)() ? "https:" : "").concat(e);
      },
          a = function a(e) {
        var t = "0".concat(e).split(/\W/),
            n = r.i.split(/\W/),
            i = parseFloat(t[0]),
            o = parseFloat(n[0]);
        return !(i > o) && !(i === o && parseFloat("0".concat(t[1])) > parseFloat(n[1]));
      },
          l = function l() {
        return s();
      };
    },
    6234: function _(e, t, n) {
      "use strict";

      n.d(t, {
        B: function B() {
          return o;
        },
        F: function F() {
          return r;
        }
      });

      var r = 12,
          i = function i() {
        try {
          var _e30 = window.crypto || window.msCrypto;

          if (null != _e30 && _e30.getRandomValues) return _e30.getRandomValues(new Uint32Array(1))[0].toString(36);
        } catch (e) {}

        return Math.random().toString(36).slice(2, 9);
      },
          o = function o(e) {
        var t = "";

        for (; t.length < e;) {
          t += i();
        }

        return t.slice(0, e);
      };
    },
    1776: function _(e, t, n) {
      "use strict";

      n.d(t, {
        U: function U() {
          return r;
        },
        W: function W() {
          return i;
        }
      });

      var r = window.requestAnimationFrame || function (e) {
        return setTimeout(e, 17);
      },
          i = window.cancelAnimationFrame || clearTimeout;
    },
    676: function _(e, t, n) {
      "use strict";

      n.d(t, {
        ZP: function ZP() {
          return c;
        }
      });
      var r = n(328),
          i = n(1643);

      var o = {},
          s = function s(e) {
        var t = document.createElement("link");
        return t.type = "text/css", t.rel = "stylesheet", t.href = e, t;
      },
          a = function a(e, t) {
        var n = document.createElement("script");
        return n.type = "text/javascript", n.charset = "utf-8", n.async = !0, n.timeout = t || 45e3, n.src = e, n;
      },
          l = function l(e, t, n) {
        var r = this;
        var l = 0;

        var c = function c(e) {
          l = 2, r.trigger(i.pn, e).off();
        },
            u = function u(e) {
          l = 3, r.trigger(i.xQ, e).off();
        };

        this.getStatus = function () {
          return l;
        }, this.load = function () {
          var r = o[e];
          return 0 !== l || (r && r.then(u)["catch"](c), l = 1, r = new Promise(function (r, i) {
            var o = (t ? s : a)(e, n);
            var l;

            var d = function d() {
              o.onerror = o.onload = null, clearTimeout(l);
            },
                p = function p(e) {
              d(), c(e), i(e);
            };

            l = setTimeout(function () {
              p(new Error("Network timeout ".concat(e)));
            }, 45e3), o.onerror = function () {
              p(new Error("Failed to load ".concat(e)));
            }, o.onload = function (e) {
              d(), u(e), r(e);
            };
            var h = document.getElementsByTagName("head")[0] || document.documentElement;
            h.insertBefore(o, h.firstChild);
          }), o[e] = r), r;
        };
      };

      Object.assign(l.prototype, r.ZP);
      var c = l;
    },
    2957: function _(e, t, n) {
      "use strict";

      n.d(t, {
        AO: function AO() {
          return l;
        },
        Dc: function Dc() {
          return a;
        },
        O4: function O4() {
          return p;
        },
        U5: function U5() {
          return d;
        },
        WZ: function WZ() {
          return c;
        },
        fy: function fy() {
          return o;
        },
        m9: function m9() {
          return u;
        },
        uA: function uA() {
          return h;
        },
        vk: function vk() {
          return s;
        },
        zz: function zz() {
          return f;
        }
      });
      var r = n(6042);

      var i = window.parseFloat,
          o = function o(e) {
        return e.replace(/^\s+|\s+$/g, "");
      },
          s = function s(e, t, n) {
        for (e = "".concat(e), n = n || "0"; e.length < t;) {
          e = n + e;
        }

        return e;
      },
          a = function a(e, t) {
        var n = e.attributes;

        for (var _e31 = 0; _e31 < n.length; _e31++) {
          if (n[_e31].name && n[_e31].name.toLowerCase() === t.toLowerCase()) return n[_e31].value.toString();
        }

        return "";
      },
          l = function l(e) {
        if (!e || "rtmp" === e.substr(0, 4)) return "";
        var t = /[(,]format=(m3u8|mpd)-/i.exec(e);
        if (t) return t[1];
        var n = e.replace(/^.+?\.(\w+)(?:[;].*)?(?:[?#].*)?$/, "$1");
        return n !== e ? n.toLowerCase() : (e = e.split("?")[0].split("#")[0]).lastIndexOf(".") > -1 ? e.substr(e.lastIndexOf(".") + 1, e.length).toLowerCase() : "";
      },
          c = function c(e) {
        var t = (e / 60 | 0) % 60,
            n = e % 60;
        return "".concat(s((e / 3600 | 0).toString(), 2), ":").concat(s(t.toString(), 2), ":").concat(s(n.toFixed(3), 6));
      },
          u = function u(e, t) {
        if (!e) return 0;
        if ((0, r.qh)(e)) return e;
        var n = e.replace(",", "."),
            o = n.slice(-1),
            s = n.split(":"),
            a = s.length;
        var l = 0;
        if ("s" === o) l = i(n);else if ("m" === o) l = 60 * i(n);else if ("h" === o) l = 3600 * i(n);else if (a > 1) {
          var _e32 = a - 1;

          4 === a && (t && (l = i(s[_e32]) / t), _e32 -= 1), l += i(s[_e32]), l += 60 * i(s[_e32 - 1]), a >= 3 && (l += 3600 * i(s[_e32 - 2]));
        } else l = i(n);
        return (0, r.qh)(l) ? l : 0;
      },
          d = function d(e, t, n) {
        if ((0, r.HD)(e) && "%" === e.slice(-1)) {
          var _n23 = i(e);

          return t && (0, r.qh)(t) && (0, r.qh)(_n23) ? t * _n23 / 100 : null;
        }

        return u(e, n);
      },
          p = function p(e, t) {
        return e.map(function (e) {
          return t + e;
        });
      },
          h = function h(e, t) {
        return e.map(function (e) {
          return e + t;
        });
      },
          f = function f(e) {
        return Boolean(e) && (0, r.HD)(e) && "%" === e.slice(-1);
      };
    },
    5882: function _(e, t, n) {
      "use strict";

      n.d(t, {
        GU: function GU() {
          return k;
        },
        ZP: function ZP() {
          return F;
        },
        dO: function dO() {
          return x;
        }
      });
      var r = n(8348),
          i = n(1643),
          o = n(328),
          s = n(5004),
          a = n(2799);
      var l = ("ontouchstart" in window),
          c = "PointerEvent" in window && !r.OS.android,
          u = !(c || l && r.OS.mobile),
          d = "window",
          p = "init",
          h = "select",
          f = "keydown",
          g = r.Features.passiveEvents,
          m = !!g && {
        passive: !0
      };
      var y, v;

      var b = function b(e, t, n) {
        var r = e.el,
            i = function (e, t, n) {
          var r = t.target,
              i = t.touches,
              o = t.changedTouches;
          var s,
              a = t.pointerType;
          i || o ? (s = null != i && i.length ? i[0] : o[0], a = a || "touch") : (s = t, a = a || "mouse");
          var _s4 = s,
              l = _s4.pageX,
              c = _s4.pageY;
          return {
            type: e,
            pointerType: a,
            pageX: l,
            pageY: c,
            sourceEvent: t,
            currentTarget: n,
            target: r
          };
        }(t, n, r);

        e.trigger(t, i);
      },
          w = function w(e, t, n) {
        var r = e.el,
            i = n.target;
        e.trigger(t, {
          type: t,
          sourceEvent: n,
          currentTarget: r,
          target: i
        });
      },
          k = function k(e) {
        var t = e.ownerDocument || e;
        return t.defaultView || t.parentWindow || window;
      },
          j = function j(e, t, n, r) {
        var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : m;
        var o = e.handlers[t],
            s = e.options[t];
        if (o || (o = e.handlers[t] = {}, s = e.options[t] = {}), o[n]) throw new Error("".concat(t, " ").concat(n, " already registered"));
        o[n] = r, s[n] = i;
        var a = e.el,
            l = t === d ? k(a) : a;
        l && l.addEventListener(n, r, i);
      },
          C = function C(e) {
        var t = e.el;
        null !== e.pointerId && (t.releasePointerCapture(e.pointerId), e.pointerId = null);
      },
          P = function P(e, t) {
        var n = e.el,
            r = e.handlers,
            i = e.options,
            o = t === d ? k(n) : n,
            s = r[t],
            a = i[t];
        s && (Object.keys(s).forEach(function (e) {
          var t = a[e];
          "boolean" == typeof t ? o.removeEventListener(e, s[e], t) : o.removeEventListener(e, s[e]);
        }), r[t] = null, i[t] = null);
      },
          x = function x(e) {
        return !(!Boolean(e.ctrlKey) || "click" !== e.type) || ("which" in e ? 3 === e.which : "button" in e && 2 === e.button);
      },
          O = function O(e, t) {
        if (v || (v = new F(document).on("interaction")), e.handlers.init || e.handlers.select) return;
        var n = e.el;
        j(e, t, "blur", function () {
          (0, a.IV)(n, "jw-tab-focus"), e.clicking = !1;
        }), j(e, t, "focus", function () {
          v.event && v.event.type === f && (0, a.cn)(n, "jw-tab-focus");
        });
      },
          S = function S(e, t, n, r) {
        c ? j(e, t, "pointerdown", n, r) : (u && j(e, t, "mousedown", n, r), j(e, t, "touchstart", n, r));
      },
          E = function E(e) {
        if (e.handlers.select) return;
        var t = e.el;
        O(e, h), S(e, h, function (n) {
          var r = n.target;
          x(n) || Boolean(e.directSelect) && r !== t || (n.isPrimary && "BUTTON" === r.tagName && r.focus(), e.lastStart = (0, s.z)(), e.clicking = !0);
        }), j(e, h, "click", function (n) {
          x(n) || Boolean(e.directSelect) && n.target !== t || ((0, s.z)() - e.lastStart > 500 && !0 === e.clicking || (function (e, t) {
            e.enableDoubleClick && ((0, s.z)() - e.lastClick < 300 ? (b(e, i.P, t), e.lastClick = 0) : e.lastClick = (0, s.z)());
          }(e, n), b(e, i.ot, n)), e.clicking = !1);
        });
      },
          T = function T(e) {
        return 0 === e.type.indexOf("touch") ? (e.originalEvent || e).changedTouches[0] : e;
      },
          A = function A(e) {
        if (e.handlers.init) return;

        var t = e.el,
            n = e.passive,
            r = !!g && {
          passive: n
        },
            o = function o(t) {
          if (e.dragged) b(e, i.Wp, t);else {
            var _T = T(t),
                _n24 = _T.pageX,
                _r16 = _T.pageY,
                _o10 = _n24 - e.startX,
                _s5 = _r16 - e.startY;

            _o10 * _o10 + _s5 * _s5 > 36 && (b(e, i.nv, t), e.dragged = !0, b(e, i.Wp, t));
          }
          var r;
          n || "touchmove" !== t.type || (r = t).preventDefault && r.preventDefault();
        },
            s = function s(t) {
          clearTimeout(y), e.el && (C(e), P(e, d), e.dragged && (e.dragged = !1, b(e, i.Sv, t)));
        };

        O(e, p), S(e, p, function (i) {
          if ((0, a.IV)(t, "jw-tab-focus"), x(i)) return;
          var l = i.target,
              c = i.type;
          if (e.directSelect && l !== t) return;

          var _T2 = T(i),
              u = _T2.pageX,
              p = _T2.pageY;

          if (e.dragged = !1, e.startX = u, e.startY = p, P(e, d), "pointerdown" === c && i.isPrimary) {
            if (!n) {
              var _n25 = i.pointerId;
              e.pointerId = _n25, t.setPointerCapture(_n25);
            }

            j(e, d, "pointermove", o, r), j(e, d, "pointercancel", s), j(e, d, "pointerup", s);
          } else "mousedown" === c ? (j(e, d, "mousemove", o, r), j(e, d, "mouseup", s)) : "touchstart" === c && (j(e, d, "touchmove", o, r), j(e, d, "touchcancel", s), j(e, d, "touchend", s));
        }, r);
      },
          Z = {
        drag: function drag(e) {
          A(e);
        },
        dragStart: function dragStart(e) {
          A(e);
        },
        dragEnd: function dragEnd(e) {
          A(e);
        },
        click: function click(e) {
          E(e);
        },
        doubleClick: function doubleClick(e) {
          e.enableDoubleClick = !0, E(e);
        },
        longPress: function longPress(e) {
          var t = "longPress";

          if (r.OS.iOS) {
            var _n26 = function _n26() {
              clearTimeout(y);
            };

            j(e, t, "touchstart", function (r) {
              _n26(), y = setTimeout(function () {
                b(e, t, r);
              }, 500);
            }), j(e, t, "touchmove", _n26), j(e, t, "touchcancel", _n26), j(e, t, "touchend", _n26);
          } else e.el.oncontextmenu = function (n) {
            return b(e, t, n), !1;
          };
        },
        focus: function focus(e) {
          var t = "focus";
          j(e, t, t, function (n) {
            w(e, t, n);
          });
        },
        blur: function blur(e) {
          var t = "blur";
          j(e, t, t, function (n) {
            w(e, t, n);
          });
        },
        over: function over(e) {
          (c || u) && j(e, i.B1, c ? "pointerover" : "mouseover", function (t) {
            "touch" !== t.pointerType && b(e, i.B1, t);
          });
        },
        out: function out(e) {
          if (c) {
            var _t21 = e.el;
            j(e, i.U3, "pointerout", function (n) {
              if ("touch" !== n.pointerType && "clientX" in n) {
                var _r17 = document.elementFromPoint(n.clientX, n.clientY);

                _t21.contains(_r17) || b(e, i.U3, n);
              }
            });
          } else u && j(e, i.U3, "mouseout", function (t) {
            b(e, i.U3, t);
          });
        },
        move: function move(e) {
          (c || u) && j(e, i.tP, c ? "pointermove" : "mousemove", function (t) {
            "touch" !== t.pointerType && b(e, i.tP, t);
          });
        },
        enter: function enter(e) {
          j(e, i.K5, f, function (t) {
            "Enter" !== t.key && 13 !== t.keyCode || (t.stopPropagation(), w(e, i.K5, t));
          });
        },
        keydown: function keydown(e) {
          j(e, f, f, function (t) {
            w(e, f, t);
          }, !1);
        },
        gesture: function gesture(e) {
          var t = "gesture",
              n = function n(_n27) {
            return b(e, t, _n27);
          };

          j(e, t, "click", n), j(e, t, f, n);
        },
        interaction: function interaction(e) {
          var t = "interaction",
              n = function n(t) {
            e.event = t;
          };

          j(e, t, "mousedown", n, !0), j(e, t, f, n, !0);
        },
        tap: function tap() {},
        doubleTap: function doubleTap() {}
      },
          _ = /\s+/,
          M = function M(e) {
        return e && !(_.test(e) || "object" == _typeof(e));
      };

      var F = /*#__PURE__*/function (_o$ZP) {
        _inherits(F, _o$ZP);

        var _super2 = _createSuper(F);

        function F(e, t) {
          var _this10;

          _classCallCheck(this, F);

          _this10 = _super2.call(this);
          var n = !(t = t || {}).preventScrolling;
          _this10.directSelect = Boolean(t.directSelect), _this10.dragged = !1, _this10.enableDoubleClick = !1, _this10.el = e, _this10.handlers = {}, _this10.options = {}, _this10.lastClick = 0, _this10.lastStart = 0, _this10.passive = n, _this10.pointerId = null, _this10.startX = 0, _this10.startY = 0, _this10.event = null, _this10.clicking = !1;
          return _this10;
        }

        _createClass(F, [{
          key: "on",
          value: function on(e, t, n) {
            return M(e) && (this.handlers[e] || Z[e](this)), _get(_getPrototypeOf(F.prototype), "on", this).call(this, e, t, n);
          }
        }, {
          key: "off",
          value: function off(e, t, n) {
            var _this11 = this;

            if (M(e)) P(this, e);else if (!e) {
              var _e33 = this.handlers;
              Object.keys(_e33).forEach(function (e) {
                P(_this11, e);
              });
            }
            return _get(_getPrototypeOf(F.prototype), "off", this).call(this, e, t, n);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.el && (this.off(), c && C(this), this.el = null);
          }
        }]);

        return F;
      }(o.ZP);
    },
    6042: function _(e, t, n) {
      "use strict";

      n.d(t, {
        $6: function $6() {
          return J;
        },
        Cb: function Cb() {
          return oe;
        },
        HD: function HD() {
          return F;
        },
        Kn: function Kn() {
          return x;
        },
        P2: function P2() {
          return Ce;
        },
        S6: function S6() {
          return S;
        },
        UI: function UI() {
          return L;
        },
        U_: function U_() {
          return Pe;
        },
        Yj: function Yj() {
          return V;
        },
        ZP: function ZP() {
          return Ae;
        },
        _e: function _e() {
          return me;
        },
        a9: function a9() {
          return Ee;
        },
        ar: function ar() {
          return ge;
        },
        ce: function ce() {
          return xe;
        },
        cq: function cq() {
          return de;
        },
        dp: function dp() {
          return ee;
        },
        e1: function e1() {
          return ue;
        },
        e5: function e5() {
          return ye;
        },
        ei: function ei() {
          return Se;
        },
        hX: function hX() {
          return Q;
        },
        hj: function hj() {
          return M;
        },
        i2: function i2() {
          return B;
        },
        jn: function jn() {
          return re;
        },
        l7: function l7() {
          return Oe;
        },
        mf: function mf() {
          return _;
        },
        o8: function o8() {
          return ie;
        },
        qh: function qh() {
          return Te;
        },
        r3: function r3() {
          return pe;
        },
        sE: function sE() {
          return W;
        },
        u4: function u4() {
          return q;
        },
        vM: function vM() {
          return le;
        },
        wB: function wB() {
          return fe;
        },
        xV: function xV() {
          return ne;
        },
        yR: function yR() {
          return H;
        }
      });

      var r = n(5004),
          i = function i(e, t) {
        if (null == e) throw new TypeError("Cannot convert undefined or null to object");
        return Object.prototype.hasOwnProperty.call(Object(e), t);
      };

      var o = {},
          s = Array.prototype,
          a = Object.prototype,
          l = Function.prototype,
          c = s.slice,
          u = s.concat,
          d = a.toString,
          p = a.hasOwnProperty,
          h = s.map,
          f = s.reduce,
          g = s.forEach,
          m = s.filter,
          y = s.every,
          v = s.some,
          b = s.indexOf,
          w = Array.isArray,
          k = Object.keys,
          j = l.bind,
          C = window.isFinite,
          P = function P(e, t) {
        return p.call(e, t);
      },
          x = function x(e) {
        return e === Object(e);
      },
          O = function O(e) {
        if (!x(e)) return [];
        if (k) return k(e);
        var t = [];

        for (var _n28 in e) {
          P(e, _n28) && t.push(_n28);
        }

        return t;
      },
          S = function S(e, t, n) {
        var r, i;
        if (null == e) return e;
        if (g && e.forEach === g) e.forEach(t, n);else if (e.length === Number(e.length)) {
          for (r = 0, i = e.length; r < i; r++) {
            if (t.call(n, e[r], r, e) === o) return;
          }
        } else {
          var _s6 = O(e);

          for (r = 0, i = _s6.length; r < i; r++) {
            if (t.call(n, e[_s6[r]], _s6[r], e) === o) return;
          }
        }
        return e;
      },
          E = S,
          T = [];

      S(["Function", "String", "Number", "Date", "RegExp"], function (e) {
        T[e] = function (t) {
          return d.call(t) == "[object ".concat(e, "]");
        };
      });

      var A = T.Date,
          Z = T.RegExp,
          _ = T.Function,
          M = T.Number,
          F = T.String,
          I = w || function (e) {
        return "[object Array]" == d.call(e);
      },
          B = function B(e) {
        return M(e) && e != Number(e);
      },
          L = function L(e, t, n) {
        var r = [];
        return null == e ? r : h && e.map === h ? e.map(t, n) : (S(e, function (e, i, o) {
          r.push(t.call(n, e, i, o));
        }), r);
      },
          N = L,
          D = "Reduce of empty array with no initial value",
          $ = function $() {},
          R = function R(e, t) {
        for (var _len4 = arguments.length, n = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
          n[_key4 - 2] = arguments[_key4];
        }

        if (j && e.bind === j) return j.apply(e, [t].concat(n));
        if (!_(e)) throw new TypeError();

        var r = function r() {
          for (var _len5 = arguments.length, i = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            i[_key5] = arguments[_key5];
          }

          if (!(this instanceof r)) return e.apply(t, n.concat(i));
          $.prototype = e.prototype;
          var o = new $();
          $.prototype = null;
          var s = e.apply(o, n.concat(i));
          return Object(s) === s ? s : o;
        };

        return r;
      },
          q = function q(e, t, n, r) {
        var i = arguments.length > 2;
        if (null == e && (e = []), f && e.reduce === f) return r && (t = R(t, r)), i ? e.reduce(t, n) : e.reduce(t);
        if (S(e, function (e, o, s) {
          i ? n = t.call(r, n, e, o, s) : (n = e, i = !0);
        }), !i) throw new TypeError(D);
        return n;
      },
          z = q,
          U = q,
          H = function H(e) {
        return e;
      },
          V = function V(e, t, n) {
        t || (t = H);
        var r = !1;
        return null == e ? r : v && e.some === v ? e.some(t, n) : (S(e, function (e, i, s) {
          if (r || (r = t.call(n, e, i, s))) return o;
        }), Boolean(r));
      },
          G = V,
          W = function W(e, t, n) {
        var r;
        return V(e, function (e, i, o) {
          if (t.call(n, e, i, o)) return r = e, !0;
        }), r;
      },
          K = W,
          Q = function Q(e, t, n) {
        var r = [];
        return null == e ? r : m && e.filter === m ? e.filter(t, n) : (S(e, function (e, i, o) {
          t.call(n, e, i, o) && r.push(e);
        }), r);
      },
          X = Q,
          J = function J(e, t, n) {
        t || (t = H);
        var r = !0;
        return null == e ? r : y && e.every === y ? e.every(t, n) : (S(e, function (e, i, s) {
          if (!(r = r && t.call(n, e, i, s))) return o;
        }), Boolean(r));
      },
          Y = J,
          ee = function ee(e) {
        return null == e ? 0 : e.length === Number(e.length) ? e.length : O(e).length;
      },
          te = function te(e, t) {
        var n;
        return function () {
          for (var _len6 = arguments.length, r = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            r[_key6] = arguments[_key6];
          }

          return --e > 0 && (n = t.apply(this, r)), e <= 1 && (t = null), n;
        };
      };

      T.Function = function (e) {
        return "function" == typeof e;
      };

      var ne = function ne(e) {
        return C(e) && !B(parseFloat(e));
      },
          re = function re(e) {
        return !0 === e || !1 === e || "[object Boolean]" == d.call(e);
      },
          ie = function ie(e) {
        return void 0 === e;
      },
          oe = function oe(e) {
        return function (t) {
          return t[e];
        };
      },
          se = function se(e) {
        return null == e ? H : _(e) ? e : oe(e);
      },
          ae = function ae(e) {
        return function (t, n, r) {
          var i = {};
          return n = se(n), S(t, function (o, s) {
            var a = n.call(r, o, s, t);
            e(i, a, o);
          }), i;
        };
      },
          le = ae(function (e, t, n) {
        P(e, t) ? e[t].push(n) : e[t] = [n];
      }),
          ce = ae(function (e, t, n) {
        e[t] = n;
      }),
          ue = function ue(e, t, n, r) {
        var i = (n = se(n)).call(r, t);
        var o = 0,
            s = e.length;

        for (; o < s;) {
          var _t22 = o + s >>> 1;

          n.call(r, e[_t22]) < i ? o = _t22 + 1 : s = _t22;
        }

        return o;
      },
          de = function de(e, t, n) {
        if (null == e) return -1;
        var r = 0;
        var i = e.length;

        if (n) {
          if ("number" != typeof n) return r = ue(e, t), e[r] === t ? r : -1;
          r = n < 0 ? Math.max(0, i + n) : n;
        }

        if (b && e.indexOf === b) return e.indexOf(t, n);

        for (; r < i; r++) {
          if (e[r] === t) return r;
        }

        return -1;
      },
          pe = function pe(e, t) {
        return null != e && (e.length !== Number(e.length) && (e = function (e) {
          var t = O(e),
              n = O.length,
              r = Array(n);

          for (var _i14 = 0; _i14 < n; _i14++) {
            r[_i14] = e[t[_i14]];
          }

          return r;
        }(e)), de(e, t) >= 0);
      },
          he = pe,
          fe = function fe(e) {
        return function (t) {
          if (t === e) return !0;

          for (var _n29 in e) {
            if (e[_n29] !== t[_n29]) return !1;
          }

          return !0;
        };
      },
          ge = function ge(e, t) {
        return Q(e, fe(t));
      },
          me = function me(e, t) {
        return W(e, fe(t));
      },
          ye = function ye(e) {
        for (var _len7 = arguments.length, t = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
          t[_key7 - 1] = arguments[_key7];
        }

        var n = u.apply(s, t);
        return Q(e, function (e) {
          return !pe(n, e);
        });
      },
          ve = function ve(e) {
        for (var _len8 = arguments.length, t = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
          t[_key8 - 1] = arguments[_key8];
        }

        return function () {
          for (var _len9 = arguments.length, n = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            n[_key9] = arguments[_key9];
          }

          var r = 0;
          var i = t.slice();

          for (var _e34 = 0, _t23 = i.length; _e34 < _t23; _e34++) {
            P(i[_e34], "partial") && (i[_e34] = n[r++]);
          }

          for (; r < arguments.length;) {
            i.push(n[r++]);
          }

          return e.apply(this, i);
        };
      },
          be = ve(te, 2),
          we = function we(e, t) {
        for (var _len10 = arguments.length, n = new Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
          n[_key10 - 2] = arguments[_key10];
        }

        return setTimeout(function () {
          return e.apply(null, n);
        }, t);
      },
          ke = ve(we, {
        partial: ve
      }, 1),
          je = r.z,
          Ce = function Ce(e, t, n) {
        var r,
            i,
            o,
            s = null,
            a = 0;
        n || (n = {});

        var l = function l() {
          a = !1 === n.leading ? 0 : je(), s = null, o = e.apply(r, i), r = i = null;
        };

        return function () {
          var u = je();
          a || !1 !== n.leading || (a = u);
          var d = t - (u - a);

          for (var _len11 = arguments.length, c = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
            c[_key11] = arguments[_key11];
          }

          return r = this, i = c, d <= 0 ? (clearTimeout(s), s = null, a = u, o = e.apply(r, i), r = i = null) : s || !1 === n.trailing || (s = setTimeout(l, d)), o;
        };
      },
          Pe = function Pe(e) {
        var t = {},
            n = O(e);

        for (var _r18 = 0, _i15 = n.length; _r18 < _i15; _r18++) {
          t[e[n[_r18]]] = n[_r18];
        }

        return t;
      },
          xe = function xe(e) {
        for (var _len12 = arguments.length, t = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
          t[_key12 - 1] = arguments[_key12];
        }

        return S(t, function (t) {
          if (t) for (var _n30 in t) {
            void 0 === e[_n30] && (e[_n30] = t[_n30]);
          }
        }), e;
      },
          Oe = Object.assign || function (e) {
        for (var _len13 = arguments.length, t = new Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
          t[_key13 - 1] = arguments[_key13];
        }

        return S(t, function (t) {
          if (t) for (var _n31 in t) {
            i(t, _n31) && (e[_n31] = t[_n31]);
          }
        }), e;
      },
          Se = function Se(e) {
        var _ref3;

        for (var _len14 = arguments.length, t = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
          t[_key14 - 1] = arguments[_key14];
        }

        var n = {};
        return t = (_ref3 = []).concat.apply(_ref3, _toConsumableArray(t)), S(t, function (t) {
          t in e && (n[t] = e[t]);
        }), n;
      },
          Ee = function Ee(e) {
        return function () {
          return e;
        };
      },
          Te = function Te(e) {
        return M(e) && !B(e);
      },
          Ae = {
        after: function after(e, t) {
          return function () {
            for (var _len15 = arguments.length, n = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
              n[_key15] = arguments[_key15];
            }

            if (--e < 1) return t.apply(this, n);
          };
        },
        all: J,
        any: V,
        before: te,
        bind: R,
        clone: function clone(e) {
          return x(e) ? I(e) ? e.slice() : Oe({}, e) : e;
        },
        collect: N,
        compact: function compact(e) {
          return Q(e, H);
        },
        constant: Ee,
        contains: pe,
        debounce: function debounce(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
          var n;
          return function () {
            var _this12 = this;

            for (var _len16 = arguments.length, r = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
              r[_key16] = arguments[_key16];
            }

            clearTimeout(n), n = setTimeout(function () {
              e.apply(_this12, r);
            }, t);
          };
        },
        defaults: xe,
        defer: ke,
        delay: we,
        detect: K,
        difference: ye,
        each: S,
        every: Y,
        extend: Oe,
        filter: Q,
        find: W,
        findWhere: me,
        foldl: z,
        forEach: E,
        groupBy: le,
        has: P,
        identity: H,
        include: he,
        indexBy: ce,
        indexOf: de,
        inject: U,
        invert: Pe,
        isArray: I,
        isBoolean: re,
        isDate: A,
        isFinite: ne,
        isFunction: _,
        isNaN: B,
        isNull: function isNull(e) {
          return null === e;
        },
        isNumber: M,
        isObject: x,
        isRegExp: Z,
        isString: F,
        isUndefined: ie,
        isValidNumber: Te,
        keys: O,
        last: function last(e, t, n) {
          if (null != e) return null == t || n ? e[e.length - 1] : c.call(e, Math.max(e.length - t, 0));
        },
        map: L,
        matches: fe,
        max: function max(e, t, n) {
          if (!t && I(e) && e[0] === Number(e[0]) && e.length < 65535) return Math.max.apply(Math, _toConsumableArray(e));
          var r = -1 / 0,
              i = -1 / 0;
          return S(e, function (e, o, s) {
            var a = t ? t.call(n, e, o, s) : e;
            a > i && (r = e, i = a);
          }), r;
        },
        memoize: function memoize(e, t) {
          var n = {};
          return t || (t = H), function () {
            for (var _len17 = arguments.length, r = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
              r[_key17] = arguments[_key17];
            }

            var i = t.apply(this, r);
            return P(n, i) ? n[i] : n[i] = e.apply(this, r);
          };
        },
        now: je,
        omit: function omit(e) {
          var n = {};

          for (var _len18 = arguments.length, t = new Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
            t[_key18 - 1] = arguments[_key18];
          }

          for (var _r19 in e) {
            pe(t, _r19) || (n[_r19] = e[_r19]);
          }

          return n;
        },
        once: be,
        partial: ve,
        pick: Se,
        pluck: function pluck(e, t) {
          return L(e, oe(t));
        },
        property: oe,
        propertyOf: function propertyOf(e) {
          return null == e ? function () {} : function (t) {
            return e[t];
          };
        },
        reduce: q,
        reject: function reject(e, t, n) {
          return Q(e, function (e, r, i) {
            return !t.call(n, e, r, i);
          }, n);
        },
        result: function result(e, t) {
          if (null == e) return;
          var n = e[t];
          return _(n) ? n.call(e) : n;
        },
        select: X,
        size: ee,
        some: G,
        sortedIndex: ue,
        throttle: Ce,
        where: ge,
        without: function without(e) {
          for (var _len19 = arguments.length, t = new Array(_len19 > 1 ? _len19 - 1 : 0), _key19 = 1; _key19 < _len19; _key19++) {
            t[_key19 - 1] = arguments[_key19];
          }

          return ye(e, t);
        }
      };
    },
    7034: function _(e, t, n) {
      "use strict";

      n.r(t), n.d(t, {
        exists: function exists() {
          return i;
        },
        isDeepKeyCompliant: function isDeepKeyCompliant() {
          return u;
        },
        isFileProtocol: function isFileProtocol() {
          return s;
        },
        isHTTPS: function isHTTPS() {
          return o;
        },
        isRtmp: function isRtmp() {
          return a;
        },
        isYouTube: function isYouTube() {
          return l;
        },
        typeOf: function typeOf() {
          return c;
        }
      });

      var r = window.location.protocol,
          i = function i(e) {
        switch (_typeof(e)) {
          case "string":
            return e.length > 0;

          case "object":
            return null !== e;

          case "undefined":
            return !1;

          default:
            return !0;
        }
      },
          o = function o() {
        return "https:" === r;
      },
          s = function s() {
        return "file:" === r;
      },
          a = function a(e, t) {
        return 0 === e.indexOf("rtmp:") || "rtmp" === t;
      },
          l = function l(e, t) {
        return "youtube" === t || /^(http|\/\/).*(youtube\.com|youtu\.be)\/.+/.test(e);
      },
          c = function c(e) {
        if (null === e) return "null";

        var t = _typeof(e);

        return "object" === t && Array.isArray(e) ? "array" : t;
      },
          u = function u(e, t, n) {
        var r = Object.keys(e);
        return Object.keys(t).length >= r.length && r.every(function (r) {
          var i = e[r],
              o = t[r];
          return i && "object" == _typeof(i) ? !(!o || "object" != _typeof(o)) && u(i, o, n) : n(r, e);
        });
      };
    },
    9025: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return r;
        }
      });
      var r = document.createElement("video");
    },
    6601: function _(e, t, n) {
      "use strict";

      n.d(t, {
        i: function i() {
          return r;
        }
      });
      var r = "8.26.7+commercial_8-26-7.520.hls.js@1.2.9.jwplayer@mono.jwplayer-ads-dai@mono.jwplayer-ads-freewheel@mono.jwplayer-ads-googima@mono.jwplayer-ads-header-bidding@github:jwplayer/jwplayer-ads-header-bidding#v7.0.1.jwplayer-ads-vast@mono.jwplayer-analytics@v3.41.0.jwplayer-analytics-kraken@v0.0.4.jwplayer-plugin-gapro@mono";
    },
    4225: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return o;
        }
      });
      var r = n(2799),
          i = n(974);

      function o(e, t) {
        var n = t.message,
            o = t.code,
            s = function (e, t, n, r) {
          return "<div id=\"".concat(e, "\" class=\"jw-error jw-reset\"><div class=\"jw-error-msg jw-info-overlay jw-reset\"><style>[id=\"").concat(e, "\"].jw-error{background:#000;overflow:hidden;position:relative}[id=\"").concat(e, "\"] .jw-error-msg{top:50%;left:50%;position:absolute;transform:translate(-50%,-50%)}[id=\"").concat(e, "\"] .jw-error-text{text-align:start;color:#FFF;font:14px/1.35 Arial,Helvetica,sans-serif}</style><div class=\"jw-icon jw-reset\"></div><div class=\"jw-info-container jw-reset\"><div class=\"jw-error-text jw-reset-text\" dir=\"auto\" data-nosnippet>").concat(t || "", "<span class=\"jw-break jw-reset\"></span>").concat(r ? "(".concat(n, ": ").concat(r, ")").replace(/\s+/g, "&nbsp;") : "", "</div></div></div></div>");
        }(e.get("id"), n, e.get("localization").errors.errorCode, o.toString()),
            a = e.get("width"),
            l = e.get("height"),
            c = (0, r.az)(s);

        return (0, i.oB)(c, {
          width: a.toString().indexOf("%") > 0 ? a : "".concat(a, "px"),
          height: l.toString().indexOf("%") > 0 ? l : "".concat(l, "px")
        }), c;
      }
    },
    9926: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return c;
        }
      });
      var r = n(1776),
          i = n(2799),
          o = n(974);
      var s = [];
      var a = -1;

      var l = function l() {
        (0, r.W)(a), a = (0, r.U)(function () {
          s.forEach(function (e) {
            e.view.updateBounds();
            var t = e.view.model.get("containerWidth");
            e.resized = e.width !== t, e.width = t;
          }), s.forEach(function (e) {
            e.contractElement.scrollLeft = 2 * e.width;
          }), s.forEach(function (e) {
            (0, o.oB)(e.expandChild, {
              width: e.width + 1
            }), e.resized && e.view.model.get("visibility") && e.view.updateStyles();
          }), s.forEach(function (e) {
            e.expandElement.scrollLeft = e.width + 1;
          }), s.forEach(function (e) {
            e.resized && e.view.checkResized();
          });
        });
      };

      var c = /*#__PURE__*/function () {
        function c(e, t, n) {
          _classCallCheck(this, c);

          var r = {
            display: "block",
            position: "absolute",
            top: 0,
            left: 0
          },
              a = {
            width: "100%",
            height: "100%"
          },
              _c2 = (0, i.az)('<div style="opacity:0;visibility:hidden;overflow:hidden;"><div><div style="height:1px;"></div></div><div class="jw-contract-trigger"></div></div>'),
              u = _c2.firstChild,
              d = u.firstChild,
              p = u.nextSibling;

          (0, o.oB)([u, p], Object.assign({
            overflow: "auto"
          }, r, a)), (0, o.oB)(_c2, Object.assign({}, r, a)), this.expandElement = u, this.expandChild = d, this.contractElement = p, this.hiddenElement = _c2, this.element = e, this.view = t, this.model = n, this.width = 0, this.resized = !1, e.firstChild ? e.insertBefore(_c2, e.firstChild) : e.appendChild(_c2), e.addEventListener("scroll", l, !0), s.push(this), l();
        }

        _createClass(c, [{
          key: "destroy",
          value: function destroy() {
            if (this.view) {
              var _e35 = s.indexOf(this);

              -1 !== _e35 && s.splice(_e35, 1), this.element.removeEventListener("scroll", l, !0), this.element.removeChild(this.hiddenElement), this.view = this.model = null;
            }
          }
        }]);

        return c;
      }();
    },
    4671: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return b;
        }
      });
      var r = n(6875),
          i = n(8348),
          o = n(2799);
      var s = [],
          a = [],
          l = [],
          c = {},
          u = "screen" in window && "orientation" in window.screen,
          d = i.OS.android && i.Browser.chrome;
      var p,
          h = !1;

      var f = function f(e, t) {
        for (var _n32 = t.length; _n32--;) {
          var _r20 = t[_n32];

          if (e.target === _r20.getContainer()) {
            _r20.setIntersection(e);

            break;
          }
        }
      },
          g = function g() {
        s.forEach(function (e) {
          var t = e.model;
          if (t.get("audioMode") || t.get("isFloating") || !t.get("controls") || t.get("visibility") < .75) return;
          var n = t.get("state"),
              r = (0, o.UM)();
          !r && "paused" === n && e.api.getFullscreen() ? e.api.setFullscreen(!1) : "playing" === n && e.api.setFullscreen(r);
        });
      },
          m = function m() {
        s.forEach(function (e) {
          e.model.set("activeTab", (0, r.Z)());
        });
      },
          y = function y(e, t) {
        var n = t.indexOf(e);
        -1 !== n && t.splice(n, 1);
      },
          v = function v(e) {
        l.forEach(function (t) {
          t(e);
        });
      };

      document.addEventListener("visibilitychange", m), document.addEventListener("webkitvisibilitychange", m), d && u && window.screen.orientation.addEventListener("change", g), window.addEventListener("beforeunload", function () {
        document.removeEventListener("visibilitychange", m), document.removeEventListener("webkitvisibilitychange", m), window.removeEventListener("scroll", v), d && u && window.screen.orientation.removeEventListener("change", g);
      });
      var b = {
        add: function add(e) {
          s.push(e);
        },
        remove: function remove(e) {
          y(e, s);
        },
        addScrollHandler: function addScrollHandler(e) {
          h || (h = !0, window.addEventListener("scroll", v)), l.push(e);
        },
        removeScrollHandler: function removeScrollHandler(e) {
          var t = l.indexOf(e);
          -1 !== t && l.splice(t, 1);
        },
        addWidget: function addWidget(e) {
          a.push(e);
        },
        removeWidget: function removeWidget(e) {
          y(e, a);
        },
        size: function size() {
          return s.length;
        },
        observe: function observe(e) {
          (function () {
            var e = window.IntersectionObserver;
            p || (p = new e(function (e) {
              if (null != e && e.length) for (var _t24 = e.length; _t24--;) {
                var _n33 = e[_t24];
                f(_n33, s), f(_n33, a);
              }
            }, {
              threshold: [0, .1, .2, .3, .4, .5, .6, .7, .8, .9, 1]
            }));
          })(), c[e.id] || (c[e.id] = !0, p.observe(e));
        },
        unobserve: function unobserve(e) {
          p && c[e.id] && (delete c[e.id], p.unobserve(e));
        }
      };
    },
    2445: function _(e, t, n) {
      "use strict";

      n.d(t, {
        ZP: function ZP() {
          return k;
        },
        qG: function qG() {
          return w;
        }
      });
      var r = n(5083),
          i = n(1569),
          o = n(6042),
          s = n(7034),
          a = n(576),
          l = n(6599),
          c = n(386);

      var u = "__CONTEXTUAL__",
          d = function d(e, t) {
        var n = e.querySelector(t);
        if (n) return n.getAttribute("content");
      };

      var p = n(4737),
          h = n.n(p),
          f = n(67);

      var g = function g(e) {
        return "string" == typeof e && /^\/\/(?:content\.jwplatform|cdn\.jwplayer)\.com\//.test(e);
      },
          m = function m(e) {
        return "https:".concat(e);
      },
          y = function y(e) {
        var t = (0, c.Z)(e.edition),
            n = e.related,
            r = !t("discovery") || n !== Object(n),
            i = !n || "none" !== n.displayMode,
            o = n || {};
        var s = void 0 === o.oncomplete ? "none" : o.oncomplete,
            a = o.autoplaytimer;
        !1 === s || e.repeat ? s = "hide" : "none" === s && (a = 0);
        var l = "autoplay" === s && a <= 0 || "none" === s;
        return Object.assign({}, n, {
          disableRelated: r,
          showButton: i,
          oncomplete: s,
          autoplaytimer: a,
          shouldAutoAdvance: l
        });
      },
          v = function v(e) {
        var t = "file:" === window.location.protocol ? "https:" : "",
            n = {
          bidding: "//ssl.p.jwpcdn.com/player/v/8.26.7/bidding.js",
          jwpsrv: "//ssl.p.jwpcdn.com/player/v/8.26.7/jwpsrv.js",
          dai: "//ssl.p.jwpcdn.com/player/v/8.26.7/dai.js",
          vast: "//ssl.p.jwpcdn.com/player/v/8.26.7/vast.js",
          googima: "//ssl.p.jwpcdn.com/player/v/8.26.7/googima.js",
          freewheel: "//ssl.p.jwpcdn.com/player/v/8.26.7/freewheel.js",
          gapro: "//ssl.p.jwpcdn.com/player/v/8.26.7/gapro.js"
        }[e];
        return n ? t + n : "";
      },
          b = function b(e, t, n) {
        if (t) {
          e[t.client || v(n)] = t, delete t.client;
        }
      },
          w = function w(e) {
        var t = Object.assign({}, e.plugins),
            n = (0, c.Z)(e.edition);

        if (n("ads")) {
          var _n34 = Object.assign({}, e.advertising),
              _r21 = _n34.client;

          if (_r21) {
            t[v(_r21) || _r21] = _n34, delete _n34.client;
          }

          _n34.bids && b(t, _n34.bids, "bidding");
        }

        if (n("jwpsrv")) {
          var _n35 = e.analytics;
          _n35 !== Object(_n35) && (_n35 = {}), b(t, _n35, "jwpsrv");
        }

        return b(t, e.ga, "gapro"), t;
      },
          k = function k(e, t) {
        var c = (0, r.ZP)(e, t);
        var p = c.key || a["default"].key,
            v = new l.ZP(p),
            b = v.edition();

        if ("free" === v.edition() && (c = Object.assign({
          skin: {
            active: "#ff0046",
            timeslider: {
              progress: "none"
            }
          },
          logo: {
            position: "control-bar",
            file: h()
          }
        }, r.ke, (0, o.ei)(c, ["analytics", "aspectratio", "base", "file", "height", "playlist", "sources", "timeSlider", "width"]))), c.key = p, c.edition = b, c.error = v.error(), c.generateSEOMetadata = c.generateSEOMetadata || !1, "unlimited" === b) {
          var _e36 = (0, i.getScriptPath)("jwplayer.js");

          if (!_e36) throw new Error("Error setting up player: Could not locate jwplayer.js script tag");
          n.p = _e36;
        }

        var k, j, C;

        if (c.related = y(c), c.ab && (c.ab = function (e) {
          var t = e.ab;
          return t.clone && (t = t.clone()), Object.keys(t.tests).forEach(function (n) {
            t.tests[n].forEach(function (t) {
              t.addConfig && t.addConfig(e, t.selection);
            });
          }), t;
        }(c)), c.plugins = w(c), k = c.playlist, (0, o.HD)(k) && k.indexOf(u) > -1 && (c.playlist = function (e, t) {
          var n;
          var r = null == e || null == e.querySelector || null == (n = e.querySelector("title")) ? void 0 : n.textContent,
              i = d(e, 'meta[property="og:title"]');
          var o = encodeURIComponent(i || r || "");
          var s = d(e, 'meta[property="og:description"]') || d(e, 'meta[name="description"]');
          return s && (o += "&page_description=".concat(encodeURIComponent(s))), t.replace(u, o);
        }(document, c.playlist), c.contextual = !0), (0, s.isFileProtocol)()) {
          var _c3 = c,
              _e37 = _c3.playlist,
              _t25 = _c3.related;
          g(_e37) && (c.playlist = m(_e37)), _t25 && g(_t25.file) && (_t25.file = m(_t25.file));
        }

        return c.__abSendDomainToFeeds && (C = c.playlist, /\.jwplatform.com|\.jwplayer.com/.test(C)) && (c.playlist = (j = c.playlist) + "".concat(-1 !== j.indexOf("?") ? "&" : "?", "page_domain=").concat(encodeURIComponent((0, f.X)()))), c;
      };
    },
    576: function _(e, t, n) {
      "use strict";

      n.d(t, {
        "default": function _default() {
          return Q;
        }
      });
      var r = n(1096),
          i = n.n(r);
      window.Promise || (window.Promise = i());
      var o = n(1569),
          s = n(6391),
          a = n(2963),
          l = n(670);
      var c = {
        availableProviders: a.B,
        registerProvider: l.Z
      };
      var u = n(1241);

      c.registerPlugin = function (e, t, n) {
        "jwpsrv" !== e && (0, u.f)(e, t, n);
      };

      var d = c;
      var p = n(6601),
          h = n(4742),
          f = n(8348),
          g = n(623),
          m = n(1643),
          y = n(7411),
          v = n(328),
          b = n(4429),
          w = n(6042);
      var k = 0;

      var j = function j(e, t) {
        var n = new g.ZP(t);
        return n.on(m.Rc, function (t) {
          e._qoe.tick("ready"), t.setupTime = e._qoe.between("setup", "ready");
        }), n.on("all", function (t, n) {
          e.trigger(t, n);
        }), n;
      },
          C = function C(e, t) {
        var n = e.plugins,
            r = Object.keys(n).map(function (e) {
          var t = n[e];
          return delete n[e], t;
        });
        t.get("setupConfig") && e.trigger("remove"), e.off(), t.playerDestroy(), r.forEach(function (e) {
          if (e.destroy) try {
            e.destroy();
          } catch (e) {}
        }), t.getContainer().removeAttribute("data-jwplayer-id");
      };

      function P(e) {
        var t = ++k,
            n = e.id || "player-".concat(t),
            r = new y.Z(),
            i = {};
        var o = j(this, e);
        r.tick("init"), e.setAttribute("data-jwplayer-id", n), Object.defineProperties(this, {
          id: {
            enumerable: !0,
            get: function get() {
              return n;
            }
          },
          uniqueId: {
            enumerable: !0,
            get: function get() {
              return t;
            }
          },
          plugins: {
            enumerable: !0,
            get: function get() {
              return i;
            }
          },
          _qoe: {
            enumerable: !0,
            get: function get() {
              return r;
            }
          },
          version: {
            enumerable: !0,
            get: function get() {
              return p.i;
            }
          },
          Events: {
            enumerable: !0,
            get: function get() {
              return v.ZP;
            }
          },
          utils: {
            enumerable: !0,
            get: function get() {
              return b.Z;
            }
          },
          _: {
            enumerable: !0,
            get: function get() {
              return w.ZP;
            }
          }
        }), Object.assign(this, {
          _events: {},
          setup: function setup(t) {
            return r.clear("ready"), r.tick("setup"), o && C(this, o), o = j(this, e), o.init(t, this), this.on(t.events, null, this);
          },
          remove: function remove() {
            return this.getPip() && this.setPip(!1), function (e) {
              for (var _t26 = s.Z.length; _t26--;) {
                if (s.Z[_t26].uniqueId === e.uniqueId) {
                  s.Z.splice(_t26, 1);
                  break;
                }
              }
            }(this), o && C(this, o), Object.keys(i).forEach(function (e) {
              delete i[e];
            }), this;
          },
          qoe: function qoe() {
            var e = o.getItemQoe();
            return {
              setupTime: this._qoe.between("setup", "ready"),
              firstFrame: e.getFirstFrame ? e.getFirstFrame() : null,
              player: this._qoe.dump(),
              item: e.dump()
            };
          },
          addCues: function addCues(e) {
            return Array.isArray(e) && o.addCues(e), this;
          },
          getAudioTracks: function getAudioTracks() {
            return o.getAudioTracks();
          },
          getBuffer: function getBuffer() {
            return o.get("buffer");
          },
          getCaptions: function getCaptions() {
            return o.get("captions");
          },
          getCaptionsList: function getCaptionsList() {
            return o.getCaptionsList();
          },
          getConfig: function getConfig() {
            return o.getConfig();
          },
          getContainer: function getContainer() {
            return o.getContainer();
          },
          getControls: function getControls() {
            return o.get("controls");
          },
          getCues: function getCues() {
            return o.getCues();
          },
          getCurrentAudioTrack: function getCurrentAudioTrack() {
            return o.getCurrentAudioTrack();
          },
          getCurrentCaptions: function getCurrentCaptions() {
            return o.getCurrentCaptions();
          },
          getCurrentQuality: function getCurrentQuality() {
            return o.getCurrentQuality();
          },
          getCurrentTime: function getCurrentTime() {
            return o.get("currentTime");
          },
          getDuration: function getDuration() {
            return o.get("duration");
          },
          getEnvironment: function getEnvironment() {
            return f;
          },
          getFullscreen: function getFullscreen() {
            return o.get("fullscreen");
          },
          getHeight: function getHeight() {
            return o.getHeight();
          },
          getItemMeta: function getItemMeta() {
            return o.get("itemMeta") || {};
          },
          getMute: function getMute() {
            return o.getMute();
          },
          getPercentViewable: function getPercentViewable() {
            return o.get("visibility");
          },
          getPip: function getPip() {
            return o.get("pip");
          },
          getPlaybackRate: function getPlaybackRate() {
            return o.get("playbackRate");
          },
          getPlaylist: function getPlaylist() {
            return o.get("playlist");
          },
          getPlaylistIndex: function getPlaylistIndex() {
            return o.get("item");
          },
          getPlaylistItem: function getPlaylistItem(e) {
            if (!b.Z.exists(e)) return o.get("playlistItem");
            var t = this.getPlaylist();
            return t ? t[e] : null;
          },
          getPosition: function getPosition() {
            return o.get("position");
          },
          getProvider: function getProvider() {
            return o.getProvider();
          },
          getQualityLevels: function getQualityLevels() {
            return o.getQualityLevels();
          },
          getSafeRegion: function getSafeRegion() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            return o.getSafeRegion(e);
          },
          getState: function getState() {
            return o.getState();
          },
          getStretching: function getStretching() {
            return o.get("stretching");
          },
          getViewable: function getViewable() {
            return o.get("viewable");
          },
          getVisualQuality: function getVisualQuality() {
            return o.getVisualQuality();
          },
          getVolume: function getVolume() {
            return o.get("volume");
          },
          getWidth: function getWidth() {
            return o.getWidth();
          },
          setCaptions: function setCaptions(e) {
            return o.setCaptions(e), this;
          },
          setConfig: function setConfig(e) {
            return o.setConfig(e), this;
          },
          setControls: function setControls(e) {
            return o.setControls(e), this;
          },
          setCurrentAudioTrack: function setCurrentAudioTrack(e) {
            o.setCurrentAudioTrack(e);
          },
          setCurrentCaptions: function setCurrentCaptions(e) {
            o.setCurrentCaptions(e);
          },
          setCurrentQuality: function setCurrentQuality(e) {
            o.setCurrentQuality(e);
          },
          setFullscreen: function setFullscreen(e) {
            return o.setFullscreen(e), this;
          },
          setAllowFullscreen: function setAllowFullscreen(e) {
            return o.setAllowFullscreen(e), this;
          },
          setMute: function setMute(e) {
            return o.setMute(e), this;
          },
          setPip: function setPip(e) {
            return o.setPip(e), this;
          },
          setPlaybackRate: function setPlaybackRate(e) {
            return o.setPlaybackRate(e), this;
          },
          setPlaylistItem: function setPlaylistItem(e, t) {
            return o.setPlaylistItem(e, t), this;
          },
          setCues: function setCues(e) {
            return Array.isArray(e) && o.setCues(e), this;
          },
          setVolume: function setVolume(e) {
            return o.setVolume(e), this;
          },
          load: function load(e, t) {
            return o.load(e, t), this;
          },
          play: function play(e) {
            return o.play(e), this;
          },
          pause: function pause(e) {
            return o.pause(e), this;
          },
          playToggle: function playToggle(e) {
            switch (this.getState()) {
              case m.r0:
              case m.Kb:
                return this.pause(e);

              default:
                return this.play(e);
            }
          },
          seek: function seek(e, t) {
            return o.seek(e, t), this;
          },
          playlistItem: function playlistItem(e, t) {
            return o.playlistItem(e, t), this;
          },
          playlistNext: function playlistNext(e) {
            return o.playlistNext(e), this;
          },
          playlistPrev: function playlistPrev(e) {
            return o.playlistPrev(e), this;
          },
          next: function next(e) {
            return o.next(e), this;
          },
          requestPip: function requestPip(e) {
            return o.requestPip(e), this;
          },
          castToggle: function castToggle() {
            return o.castToggle(), this;
          },
          stopCasting: function stopCasting() {
            return o.stopCasting(), this;
          },
          createInstream: function createInstream() {
            return o.createInstream();
          },
          stop: function stop() {
            return o.stop(), this;
          },
          resize: function resize(e, t) {
            return o.resize(e, t), this;
          },
          addButton: function addButton(e, t, n, r, i) {
            return o.addButton(e, t, n, r, i), this;
          },
          removeButton: function removeButton(e) {
            return o.removeButton(e), this;
          },
          getMediaElement: function getMediaElement() {
            return o.getMediaElement();
          },
          attachMedia: function attachMedia() {
            return o.attachMedia(), this;
          },
          detachMedia: function detachMedia() {
            return o.detachMedia(), this;
          },
          isBeforeComplete: function isBeforeComplete() {
            return o.isBeforeComplete();
          },
          isBeforePlay: function isBeforePlay() {
            return o.isBeforePlay();
          },
          setPlaylistItemCallback: function setPlaylistItemCallback(e, t) {
            o.setItemCallback(e, t);
          },
          removePlaylistItemCallback: function removePlaylistItemCallback() {
            o.setItemCallback(null);
          },
          getPlaylistItemPromise: function getPlaylistItemPromise(e) {
            return o.getItemPromise(e);
          },
          getFloating: function getFloating() {
            return Boolean(o.get("isFloating"));
          },
          setFloating: function setFloating(e) {
            o.setConfig({
              floating: {
                mode: e ? "always" : "never"
              }
            });
          },
          getChapters: function getChapters() {
            return o.getChapters();
          },
          getCurrentChapter: function getCurrentChapter() {
            return o.getCurrentChapter();
          },
          setChapter: function setChapter(e) {
            return o.setChapter(e);
          }
        });
      }

      Object.assign(P.prototype, {
        on: function on(e, t, n) {
          return v.on.call(this, e, t, n);
        },
        once: function once(e, t, n) {
          return v.IH.call(this, e, t, n);
        },
        off: function off(e, t, n) {
          return v.S1.call(this, e, t, n);
        },
        trigger: function trigger(e, t) {
          return (t = w.ZP.isObject(t) ? Object.assign({}, t) : {}).type = e, h.Z.debug ? v.X$.call(this, e, t) : v.wj.call(this, e, t);
        },
        getPlugin: function getPlugin(e) {
          return this.plugins[e];
        },
        addPlugin: function addPlugin(e, t) {
          this.plugins[e] = t, this.on("ready", t.addToPlayer), t.resize && this.on("resize", t.resizeHandler);
        },
        registerPlugin: function registerPlugin(e, t, n) {
          (0, u.f)(e, t, n);
        },
        getAdBlock: function getAdBlock() {
          return !1;
        },
        playAd: function playAd(e) {},
        pauseAd: function pauseAd(e) {},
        skipAd: function skipAd() {}
      }), n.p = (0, o.loadFrom)();

      var x = function x(e) {
        for (var _t27 = 0; _t27 < s.Z.length; _t27++) {
          if (s.Z[_t27].id === e) return s.Z[_t27];
        }

        return null;
      },
          O = function O(e) {
        var t, n;
        if (e ? "string" == typeof e ? (t = x(e), t || (n = document.getElementById(e))) : "number" == typeof e ? t = s.Z[e] : e.nodeType && (n = e, t = x(n.id || n.getAttribute("data-jwplayer-id"))) : t = s.Z[0], t) return t;

        if (n) {
          var _e38 = new P(n);

          return s.Z.push(_e38), _e38;
        }

        return {
          registerPlugin: u.f
        };
      },
          S = function S(e) {
        Object.defineProperties(e, {
          api: {
            get: function get() {
              return d;
            },
            set: function set() {}
          },
          version: {
            get: function get() {
              return p.i;
            },
            set: function set() {}
          },
          debug: {
            get: function get() {
              return h.Z.debug;
            },
            set: function set(e) {
              h.Z.debug = Boolean(e);
            }
          }
        });
      };

      S(O);
      var E = O;

      var T = n(5882),
          A = n(6599),
          Z = n(676),
          _ = n(5592),
          M = n(6769),
          F = n(9025);

      var I = w.ZP.extend,
          B = {};
      B._ = w.ZP, B.utils = Object.assign(b.Z, {
        key: A.ZP,
        extend: I,
        scriptloader: Z.ZP,
        rssparser: {
          parse: M.Z
        },
        tea: _.p,
        UI: T.ZP
      }), B.utils.css.style = B.utils.style, B.vid = F.Z;
      var L = B;
      var N = n(7543);

      var D = /^(?:on(?:ce)?|off|trigger)$/,
          $ = function $(e) {
        console.warn("The API method jwplayer().".concat(e, "() is disabled in the free edition of JW Player."));
      },
          R = function R(e, t, n) {
        try {
          var _r22 = function (e, t) {
            switch (e) {
              case "setup":
                return Boolean(t);

              case "getSafeRegion":
              case "pauseAd":
              case "setControls":
              case "setFullscreen":
              case "setMute":
                return Boolean(t) === t ? t : void 0;

              case "setPlaylistItem":
              case "getPlaylistItem":
                return (0 | t) === t ? t : void 0;

              case "setPlaybackRate":
              case "setVolume":
                return Number(t);

              case "setConfig":
                return Object.keys(Object(t)).join(",");

              case "on":
              case "once":
              case "off":
              case "trigger":
              case "getPlugin":
              case "addPlugin":
              case "registerPlugin":
                return "".concat(t);
            }

            return null;
          }(t, n);

          e.trackExternalAPIUsage(t, _r22);
        } catch (e) {
          h.Z.debug && console.warn(e);
        }
      },
          q = function q(e, t) {
        if (t.length) {
          var _n36 = e.getPlugin("jwpsrv");

          null != _n36 && _n36.trackExternalAPIUsage && (t.forEach(function (e) {
            R(_n36, e[0], e[1]);
          }), t.length = 0);
        }
      },
          z = function z(e, t, n, r, i) {
        return function () {
          for (var _len20 = arguments.length, o = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
            o[_key20] = arguments[_key20];
          }

          var s = o[0],
              a = t._trackCallQueue || (t._trackCallQueue = []),
              l = D.test(n),
              c = l && o[1] && o[1]._callback,
              u = i.edition || function (e, t, n) {
            var r = e.getConfig()[n];
            return t[n] = r, r;
          }(t, i, "edition");

          if ("free" === u) {
            if (["addButton", "addCues", "detachMedia", "load", "next", "pause", "play", "playlistItem", "playlistNext", "playlistPrev", "playToggle", "resize", "seek", "setCaptions", "setConfig", "setControls", "setCues", "setFullscreen", "setMute", "setPlaybackRate", "setPlaylistItem", "setVolume", "stop"].indexOf(n) > -1) return $(n), e;
            if (["createInstream", "setCurrentAudioTrack", "setCurrentCaptions", "setCurrentQuality"].indexOf(n) > -1) return $(n), null;
          }

          if (c || a.push([n, s]), l) return q(t, a), t[n].apply(e, o);

          (function (e, t) {
            var n = {
              reason: "play" !== e && "seek" !== e && "pause" !== e && (0, N.C)() ? "interaction" : "external"
            };

            switch (e) {
              case "play":
              case "pause":
              case "playToggle":
              case "playlistNext":
              case "playlistPrev":
              case "next":
                t[0] = n;
                break;

              case "seek":
              case "playlistItem":
                t[1] = n;
            }
          })(n, o);

          var d = t[n].apply(t, o);
          return "remove" === n ? t.off.call(e) : "setup" === n && (t.off.call(e), t.off(s.events, null, t), t.on.call(e, s.events, null, e), t.on("all", function (n, o) {
            if ("ready" === n) {
              var _n37 = Object.keys(t).filter(function (e) {
                return "_" !== e[0] && -1 === r.indexOf(e) && "function" == typeof t[e];
              }),
                  _o11 = r.concat(_n37);

              _n37.forEach(function (n) {
                e[n] = z(e, t, n, _o11, i);
              });
            }

            t.trigger.call(e, n, o), q(t, a);
          })), q(t, a), d === t ? e : d;
        };
      },
          U = ["getMediaElement"],
          H = function H(e, t, n, r) {
        var i = Object.keys(n);
        i.forEach(function (o) {
          var s = n[o];
          -1 === U.indexOf(o) && ("function" == typeof s && "Events" !== o ? e[o] = z(e, t, o, i, r) : "_events" === o ? e._events = {} : Object.defineProperty(e, o, {
            enumerable: !0,
            get: function get() {
              return n[o];
            }
          }));
        });
      },
          V = function V(e) {
        var t = {};
        H(this, e, e, t), H(this, e, P.prototype, t);
      },
          G = window;

      Object.assign(E, L);

      var W = function W(e) {
        var t = E(e);
        return t.uniqueId ? t._publicApi || (t._publicApi = new V(t)) : t;
      };

      Object.assign(W, L), S(W), "function" == typeof G.define && G.define.amd && G.define([], function () {
        return W;
      });
      var K = W;
      G.jwplayer && (K = G.jwplayer);
      var Q = K;
    },
    3487: function _(e, t, n) {
      "use strict";

      n.d(t, {
        MK: function MK() {
          return i;
        },
        Nq: function Nq() {
          return o;
        },
        bX: function bX() {
          return s;
        }
      });
      var r = n(7164);

      var i = r.MK,
          o = r.Nq,
          s = function s(e) {
        var t = (0, r.bX)(e);
        if (!e) return t;

        switch ((0, r.Nq)(e)) {
          case "jwpsrv":
            t = 305001;
            break;

          case "googima":
            t = 305002;
            break;

          case "vast":
            t = 305003;
            break;

          case "freewheel":
            t = 305004;
            break;

          case "dai":
            t = 305005;
            break;

          case "gapro":
            t = 305006;
            break;

          case "bidding":
            t = 305007;
        }

        return t;
      };
    },
    1918: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Gb: function Gb() {
          return u;
        },
        d3: function d3() {
          return d;
        },
        lD: function lD() {
          return c;
        },
        w0: function w0() {
          return l;
        }
      });
      var r = n(386);
      var i = [{
        configName: "clearkey",
        keyName: "org.w3.clearkey"
      }, {
        configName: "widevine",
        keyName: "com.widevine.alpha"
      }, {
        configName: "playready",
        keyName: "com.microsoft.playready"
      }],
          o = [],
          s = {};
      var a;

      var l = function l(e) {
        return e.some(function (e) {
          return Boolean(e.drm) || e.sources.some(function (e) {
            return Boolean(e.drm);
          });
        });
      },
          c = function c(e) {
        return a || ((Boolean(navigator.requestMediaKeySystemAccess) && Boolean(window.MediaKeySystemAccess.prototype.getConfiguration) || Boolean(window.MSMediaKeys)) && (0, r.Z)(e)("drm") ? (i.forEach(function (e) {
          var t = (n = e.keyName, r = [{
            initDataTypes: ["cenc"],
            videoCapabilities: [{
              contentType: 'video/mp4;codecs="avc1.4d401e"'
            }],
            audioCapabilities: [{
              contentType: 'audio/mp4;codecs="mp4a.40.2"'
            }]
          }], navigator.requestMediaKeySystemAccess ? navigator.requestMediaKeySystemAccess(n, r) : new Promise(function (e, t) {
            var r;

            try {
              r = new window.MSMediaKeys(n);
            } catch (e) {
              return void t(e);
            }

            e(r);
          })).then(function () {
            s[e.configName] = !0;
          })["catch"](function () {
            s[e.configName] = !1;
          });
          var n, r;
          o.push(t);
        }), a = Promise.all(o), a) : Promise.resolve());
      },
          u = function u(e) {
        return s[e];
      },
          d = function d(e) {
        if (a) return Object.keys(e).some(function (e) {
          return u(e);
        });
      };
    },
    2963: function _(e, t, n) {
      "use strict";

      n.d(t, {
        B: function B() {
          return u;
        }
      });
      var r = n(6593),
          i = n(8348),
          o = n(386),
          s = n(6042),
          a = n(1918),
          l = n(9025);

      var c = function c() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['video/mp4;codecs="avc1.4d400d,mp4a.40.2"'];
        var t = window.MediaSource;
        return !(!t || !t.isTypeSupported) && (0, s.$6)(e, function (e) {
          return t.isTypeSupported(e);
        });
      };

      {
        var _e39 = (0, s.sE)(r.B, (0, s.wB)({
          name: "html5"
        })),
            _t28 = _e39.supports;

        _e39.supports = function () {
          for (var _len21 = arguments.length, e = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
            e[_key21] = arguments[_key21];
          }

          var n = e[0],
              r = e[1],
              i = _t28.apply(this, e);

          if (i && n.drm && "hls" === n.type) {
            var _e40 = (0, o.Z)(r)("drm");

            if (_e40 && n.drm.fairplay) {
              var _e41 = window.WebKitMediaKeys;
              return null == _e41 || null == _e41.isTypeSupported ? void 0 : _e41.isTypeSupported("com.apple.fps.1_0", "video/mp4");
            }

            return _e40;
          }

          return i;
        }, r.B.push({
          name: "shaka",
          supports: function supports(e) {
            if (e.drm && !(0, a.d3)(e.drm)) return !1;
            if (!window.HTMLVideoElement || !window.MediaSource) return !1;
            return c(e.mediaTypes) && ("hls" === e.type || "dash" === e.type || "mpd" === e.type || (e.file || "").indexOf("mpd-time-csf") > -1);
          }
        }), r.B.unshift({
          name: "hlsjs",
          supports: function supports(e) {
            return function (e) {
              if (e.drm) return !1;
              var t = e.file.indexOf(".m3u8") > -1,
                  n = "hls" === e.type || "m3u8" === e.type;
              if (!t && !n) return !1;
              var r = Boolean(null == l.Z || null == l.Z.canPlayType ? void 0 : l.Z.canPlayType("application/vnd.apple.mpegURL")),
                  o = !r || i.OS.android,
                  s = i.Browser.safari && !r,
                  a = i.OS.android && !1 === e.hlsjsdefault,
                  u = i.Browser.safari && Boolean(e.safarihlsjs);
              return c(e.mediaTypes || ['video/mp4;codecs="avc1.4d400d,mp4a.40.2"']) && (o || u || s) && !a;
            }(e);
          }
        });
      }
      var u = r.B;
    },
    2303: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return d;
        }
      });
      var r = n(2963),
          i = n(12),
          o = n(670),
          s = n(2894);
      var a = {
        html5: function html5() {
          return n.e(250).then(function (e) {
            var t = n(9181)["default"];
            return (0, o.Z)(t), t;
          }.bind(null, n))["catch"]((0, s.Ep)(152));
        }
      };
      Object.assign(a, {
        shaka: function shaka() {
          return n.e(371).then(function (e) {
            var t = n(9738)["default"];
            return (0, o.Z)(t), t;
          }.bind(null, n))["catch"]((0, s.Ep)(154));
        },
        hlsjs: function hlsjs() {
          return n.e(98).then(function (e) {
            var t = n(9054)["default"];
            return (0, o.Z)(t), t;
          }.bind(null, n))["catch"]((0, s.Ep)(153));
        }
      });

      var l = a,
          c = function c(e) {
        this.config = e || {};
      };

      Object.assign(c.prototype, {
        load: function load(e) {
          var t = l[e],
              n = function n() {
            return Promise.reject(new Error("Failed to load media"));
          };

          return t ? t().then(function () {
            var t = i.U[e];
            return t || n();
          }) : n();
        },
        providerSupports: function providerSupports(e, t) {
          return e.supports(t);
        },
        choose: function choose(e) {
          if (e === Object(e)) {
            var _t29 = r.B.length;

            for (var _n38 = 0; _n38 < _t29; _n38++) {
              var _o12 = r.B[_n38];

              if (this.providerSupports(_o12, e)) {
                return {
                  priority: _t29 - _n38 - 1,
                  name: _o12.name,
                  type: e.type,
                  providerToCheck: _o12,
                  provider: i.U[_o12.name]
                };
              }
            }
          }

          return {};
        }
      });
      var u = c;

      u.prototype.providerSupports = function (e, t) {
        return e.supports(t, this.config.edition);
      };

      var d = u;
    },
    5140: function _(e, t, n) {
      "use strict";

      n.d(t, {
        t: function t() {
          return r;
        }
      });
      var r = window.atob;
      window.btoa;
    },
    386: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return h;
        }
      });
      var r = "free",
          i = "starter",
          o = "business",
          s = "premium",
          a = "enterprise",
          l = "developer",
          c = "platinum",
          u = "ads",
          d = "unlimited",
          p = "trial";

      function h(e) {
        var t = {
          setup: [r, i, o, s, a, l, u, d, p, c],
          drm: [a, l, u, d, p],
          ads: [u, d, p, c, a, l, o],
          jwpsrv: [r, i, o, s, a, l, u, p, c, "invalid"],
          discovery: [u, a, l, p, d]
        };
        return function (n) {
          return t[n] && t[n].indexOf(e) > -1;
        };
      }
    },
    7010: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return r;
        }
      });

      function r() {
        return e = window, t = document.location.search, e.location !== e.parent.location && /isAMP/.test(t);
        var e, t;
      }
    },
    560: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return i;
        }
      });

      var r = function r() {
        return r._iframe;
      };

      r.mock = function (e) {
        r._iframe = e;
      }, r.unmock = function () {
        r._iframe = r._original;
      }, r._iframe = window.top !== window.self, r._original = r._iframe;
      var i = r;
    },
    6599: function _(e, t, n) {
      "use strict";

      n.d(t, {
        ZP: function ZP() {
          return c;
        },
        u5: function u5() {
          return a;
        }
      });
      var r = n(5592),
          i = n(386),
          o = n(5140),
          s = n(4446);
      var a = 100013,
          l = "invalid";

      var c = function c(e) {
        _classCallCheck(this, c);

        this.keyData = function (e) {
          var t, n, s;

          try {
            var _a2 = (0, r.p)(e || "", (0, o.t)("NDh2aU1Cb0NHRG5hcDFRZQ==")).split("/");

            if (t = _a2[0], "pro" === t && (t = "premium"), (0, i.Z)(t)("setup") || (t = l), _a2.length > 2) {
              n = _a2[1];

              var _e42 = parseInt(_a2[2], 10);

              _e42 > 0 && (s = new Date(), s.setTime(_e42));
            }
          } catch (e) {
            t = l;
          }

          return {
            edition: t,
            token: n,
            expiration: s
          };
        }(e), this.edition = function () {
          return this.keyData.edition;
        }, this.token = function () {
          return this.keyData.token;
        }, this.expiration = function () {
          return this.keyData.expiration;
        }, this.duration = function () {
          return this.keyData.expiration ? this.keyData.expiration.getTime() - new Date().getTime() : 0;
        }, this.error = function () {
          var t;
          return void 0 === e ? t = 100011 : this.keyData.edition !== l && this.keyData.token ? this.duration() < 0 && (t = a) : t = 100012, t ? new s.rG(s.pJ, t) : null;
        };
      };
    },
    67: function _(e, t, n) {
      "use strict";

      n.d(t, {
        X: function X() {
          return i;
        }
      });
      var r = n(560);

      var i = function i() {
        var e = window.location.host;

        if ((0, r.Z)()) {
          e = (document.referrer ? function (e) {
            var t = document.createElement("a");
            return t.href = e, t;
          }(document.referrer) : {}).host;

          try {
            e = e || window.top.location.host;
          } catch (e) {}
        }

        return e;
      };
    },
    5592: function _(e, t, n) {
      "use strict";

      n.d(t, {
        p: function p() {
          return a;
        }
      });
      var r = n(5140);

      var i = function i(e) {
        return unescape(encodeURIComponent(e));
      },
          o = function o(e) {
        var t = new Array(Math.ceil(e.length / 4));

        for (var _n39 = 0; _n39 < t.length; _n39++) {
          t[_n39] = e.charCodeAt(4 * _n39) + (e.charCodeAt(4 * _n39 + 1) << 8) + (e.charCodeAt(4 * _n39 + 2) << 16) + (e.charCodeAt(4 * _n39 + 3) << 24);
        }

        return t;
      },
          s = function s(e) {
        var t = new Array(e.length);

        for (var _n40 = 0; _n40 < e.length; _n40++) {
          t[_n40] = String.fromCharCode(255 & e[_n40], e[_n40] >>> 8 & 255, e[_n40] >>> 16 & 255, e[_n40] >>> 24 & 255);
        }

        return t.join("");
      },
          a = function a(e, t) {
        if (e = String(e), t = String(t), 0 === e.length) return "";
        var n = o((0, r.t)(e)),
            a = o(i(t).slice(0, 16)),
            l = n.length,
            c = 2654435769;
        var u,
            d,
            p = n[l - 1],
            h = n[0],
            f = Math.floor(6 + 52 / l) * c;

        for (; f;) {
          d = f >>> 2 & 3;

          for (var _e43 = l - 1; _e43 >= 0; _e43--) {
            p = n[_e43 > 0 ? _e43 - 1 : l - 1], u = (p >>> 5 ^ h << 2) + (h >>> 3 ^ p << 4) ^ (f ^ h) + (a[3 & _e43 ^ d] ^ p), h = n[_e43] -= u;
          }

          f -= c;
        }

        return function (e) {
          try {
            return decodeURIComponent(escape(e));
          } catch (t) {
            return e;
          }
        }(s(n).replace(/\0+$/, ""));
      };
    },
    1096: function _(e) {
      e.exports = function () {
        "use strict";

        function e() {}

        function t(e) {
          if (!(this instanceof t)) throw new TypeError("Promises must be constructed via new");
          if ("function" != typeof e) throw new TypeError("not a function");
          this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], s(e, this);
        }

        function n(e, n) {
          for (; 3 === e._state;) {
            e = e._value;
          }

          0 !== e._state ? (e._handled = !0, t._immediateFn(function () {
            var t = 1 === e._state ? n.onFulfilled : n.onRejected;

            if (null !== t) {
              var o;

              try {
                o = t(e._value);
              } catch (e) {
                return void i(n.promise, e);
              }

              r(n.promise, o);
            } else (1 === e._state ? r : i)(n.promise, e._value);
          })) : e._deferreds.push(n);
        }

        function r(e, n) {
          try {
            if (n === e) throw new TypeError("A promise cannot be resolved with itself.");

            if (n && ("object" == _typeof(n) || "function" == typeof n)) {
              var r = n.then;
              if (n instanceof t) return e._state = 3, e._value = n, void o(e);
              if ("function" == typeof r) return void s(function (e, t) {
                return function () {
                  e.apply(t, arguments);
                };
              }(r, n), e);
            }

            e._state = 1, e._value = n, o(e);
          } catch (t) {
            i(e, t);
          }
        }

        function i(e, t) {
          e._state = 2, e._value = t, o(e);
        }

        function o(e) {
          2 === e._state && 0 === e._deferreds.length && t._immediateFn(function () {
            e._handled || t._unhandledRejectionFn(e._value);
          });

          for (var r = 0, i = e._deferreds.length; i > r; r++) {
            n(e, e._deferreds[r]);
          }

          e._deferreds = null;
        }

        function s(e, t) {
          var n = !1;

          try {
            e(function (e) {
              n || (n = !0, r(t, e));
            }, function (e) {
              n || (n = !0, i(t, e));
            });
          } catch (e) {
            if (n) return;
            n = !0, i(t, e);
          }
        }

        var a = setTimeout;
        return t.prototype["catch"] = function (e) {
          return this.then(null, e);
        }, t.prototype.then = function (t, r) {
          var i = new this.constructor(e);
          return n(this, new function (e, t, n) {
            this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.promise = n;
          }(t, r, i)), i;
        }, t.prototype["finally"] = function (e) {
          var t = this.constructor;
          return this.then(function (n) {
            return t.resolve(e()).then(function () {
              return n;
            });
          }, function (n) {
            return t.resolve(e()).then(function () {
              return t.reject(n);
            });
          });
        }, t.all = function (e) {
          return new t(function (t, n) {
            function r(e, s) {
              try {
                if (s && ("object" == _typeof(s) || "function" == typeof s)) {
                  var a = s.then;
                  if ("function" == typeof a) return void a.call(s, function (t) {
                    r(e, t);
                  }, n);
                }

                i[e] = s, 0 == --o && t(i);
              } catch (e) {
                n(e);
              }
            }

            if (!e || void 0 === e.length) throw new TypeError("Promise.all accepts an array");
            var i = Array.prototype.slice.call(e);
            if (0 === i.length) return t([]);

            for (var o = i.length, s = 0; i.length > s; s++) {
              r(s, i[s]);
            }
          });
        }, t.resolve = function (e) {
          return e && "object" == _typeof(e) && e.constructor === t ? e : new t(function (t) {
            t(e);
          });
        }, t.reject = function (e) {
          return new t(function (t, n) {
            n(e);
          });
        }, t.race = function (e) {
          return new t(function (t, n) {
            for (var r = 0, i = e.length; i > r; r++) {
              e[r].then(t, n);
            }
          });
        }, t._immediateFn = "function" == typeof setImmediate && function (e) {
          setImmediate(e);
        } || function (e) {
          a(e, 0);
        }, t._unhandledRejectionFn = function (e) {
          void 0 !== console && console && console.warn("Possible Unhandled Promise Rejection:", e);
        }, t;
      }();
    },
    9563: function _(e) {
      var t,
          n,
          r = {},
          i = {},
          o = (t = function t() {
        return document.head || document.getElementsByTagName("head")[0];
      }, function () {
        return void 0 === n && (n = t.apply(this, arguments)), n;
      });

      function s(e) {
        var t = document.createElement("style");
        return t.type = "text/css", t.setAttribute("data-jwplayer-id", e), function (e) {
          o().appendChild(e);
        }(t), t;
      }

      function a(e, t) {
        var n,
            r,
            o,
            a = i[e];
        a || (a = i[e] = {
          element: s(e),
          counter: 0
        });
        var l = a.counter++;
        return n = a.element, o = function o() {
          u(n, l, "");
        }, (r = function r(e) {
          u(n, l, e);
        })(t.css), function (e) {
          if (e) {
            if (e.css === t.css && e.media === t.media) return;
            r((t = e).css);
          } else o();
        };
      }

      e.exports = {
        style: function style(e, t) {
          !function (e, t) {
            for (var n = 0; n < t.length; n++) {
              var i = t[n],
                  o = (r[e] || {})[i.id];

              if (o) {
                for (var s = 0; s < o.parts.length; s++) {
                  o.parts[s](i.parts[s]);
                }

                for (; s < i.parts.length; s++) {
                  o.parts.push(a(e, i.parts[s]));
                }
              } else {
                var l = [];

                for (s = 0; s < i.parts.length; s++) {
                  l.push(a(e, i.parts[s]));
                }

                r[e] = r[e] || {}, r[e][i.id] = {
                  id: i.id,
                  parts: l
                };
              }
            }
          }(t, function (e) {
            for (var t = [], n = {}, r = 0; r < e.length; r++) {
              var i = e[r],
                  o = i[0],
                  s = {
                css: i[1],
                media: i[2]
              };
              n[o] ? n[o].parts.push(s) : t.push(n[o] = {
                id: o,
                parts: [s]
              });
            }

            return t;
          }(e));
        },
        clear: function clear(e, t) {
          var n = r[e];
          if (!n) return;

          if (t) {
            var i = n[t];
            if (i) for (var o = 0; o < i.parts.length; o += 1) {
              i.parts[o]();
            }
            return;
          }

          for (var s = Object.keys(n), a = 0; a < s.length; a += 1) {
            for (var l = n[s[a]], c = 0; c < l.parts.length; c += 1) {
              l.parts[c]();
            }
          }

          delete r[e];
        }
      };
      var l,
          c = (l = [], function (e, t) {
        return l[e] = t, l.filter(Boolean).join("\n");
      });

      function u(e, t, n) {
        if (e.styleSheet) e.styleSheet.cssText = c(t, n);else {
          var r = document.createTextNode(n),
              i = e.childNodes[t];
          i ? e.replaceChild(r, i) : e.appendChild(r);
        }
      }
    },
    4737: function _(e) {
      e.exports = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 29.3" class="jw-svg-icon jw-svg-icon-watermark" focusable="false"><path d="M37,16.68c0,2.4-.59,3.43-2.4,3.43a5.75,5.75,0,0,1-3.38-1.23v3.58a7.39,7.39,0,0,0,3.67,1c3.67,0,5.73-1.91,5.73-6.32V5.86H37Z"></path><polygon points="58.33 17.61 55.39 6.01 52.55 6.01 49.52 17.61 46.73 6.01 43.06 6.01 47.56 23.29 50.89 23.29 53.92 11.88 56.96 23.29 60.24 23.29 64.74 6.01 61.17 6.01 58.33 17.61"></polygon><path d="M73.84,6H67.47V23.29h2.2v-6.9h4.17c3.47,0,5.77-1.77,5.77-5.19S77.31,6,73.84,6Zm0,8.47H69.72V8h4.12c2.3,0,3.57,1.22,3.62,3.28C77.46,13.21,76.19,14.48,73.84,14.48Z"></path><path d="M99.2,6l-6,15.27H85V6H82.8V23.29H94.7l2-5.19h7.09l2,5.19H108L101.26,6ZM97.39,16.14l2.84-7.39L103,16.14Z"></path><polygon points="113.98 14.18 108.99 6.01 106.59 6.01 112.81 16.14 112.81 23.29 115.01 23.29 115.01 16.14 121.33 6.01 118.98 6.01 113.98 14.18"></polygon><polygon points="123.14 23.29 134.1 23.29 134.1 21.28 125.29 21.28 125.29 15.41 133.32 15.41 133.32 13.45 125.29 13.45 125.29 7.97 134.1 7.97 134.1 6.01 123.14 6.01 123.14 23.29"></polygon><path d="M144.86,15.85c2.74-.39,4.41-2,4.41-4.85,0-3.23-2.26-5-5.73-5h-6.32V23.29h2.22V16h3.08l4.94,7.29H150Zm-5.42-1.71V8h4.06c2.3,0,3.62,1.17,3.62,3.08s-1.32,3.09-3.62,3.09Z"></path><path d="M27.63.09a1,1,0,0,0-1.32.48c-.24.51-6.35,15.3-6.35,15.3-.2.46-.33.41-.33-.07,0,0,0-5.15,0-9.39,0-2.31-1.12-3.61-2.73-3.88A3.12,3.12,0,0,0,14.83,3a4.57,4.57,0,0,0-1.5,1.79c-.48.94-3.47,9.66-3.47,9.66-.16.46-.31.44-.31,0,0,0-.09-3.76-.18-4.64-.13-1.36-.44-3.59-2.2-3.7S4.77,8,4.36,9.24c-.29.84-1.65,5.35-1.65,5.35l-.2.46h0c-.06.24-.17.24-.24,0l-.11-.42Q2,14,1.74,13.31a1.71,1.71,0,0,0-.33-.66.83.83,0,0,0-.88-.22.82.82,0,0,0-.53.69,4.22,4.22,0,0,0,.07.79,29,29,0,0,0,1,4.6,1.31,1.31,0,0,0,1.8.66,3.43,3.43,0,0,0,1.24-1.81c.33-.81,2-5.48,2-5.48.18-.46.31-.44.29,0,0,0-.09,4.57-.09,6.64a13.11,13.11,0,0,0,.28,2.93,2.41,2.41,0,0,0,.82,1.27,2,2,0,0,0,1.41.4,2,2,0,0,0,.7-.24,3.15,3.15,0,0,0,.79-.71,12.52,12.52,0,0,0,1.26-2.11c.81-1.6,2.92-6.58,2.92-6.58.2-.46.33-.41.33.07,0,0-.26,8.36-.26,11.55a6.39,6.39,0,0,0,.44,2.33,2.8,2.8,0,0,0,1.45,1.61A2.57,2.57,0,0,0,18.79,29a3.76,3.76,0,0,0,1.28-1.32,15.12,15.12,0,0,0,1.07-2.31c.64-1.65,1.17-3.33,1.7-5s5-17.65,5.28-19a1.79,1.79,0,0,0,0-.46A1,1,0,0,0,27.63.09Z"></path></svg>';
    }
  },
      r = {};

  function i(e) {
    var t = r[e];
    if (void 0 !== t) return t.exports;
    var o = r[e] = {
      id: e,
      loaded: !1,
      exports: {}
    };
    return n[e].call(o.exports, o, o.exports, i), o.loaded = !0, o.exports;
  }

  i.m = n, i.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return i.d(t, {
      a: t
    }), t;
  }, i.d = function (e, t) {
    for (var n in t) {
      i.o(t, n) && !i.o(e, n) && Object.defineProperty(e, n, {
        enumerable: !0,
        get: t[n]
      });
    }
  }, i.f = {}, i.e = function (e) {
    return Promise.all(Object.keys(i.f).reduce(function (t, n) {
      return i.f[n](e, t), t;
    }, []));
  }, i.u = function (e) {
    return {
      63: "polyfills.webvtt",
      74: "jwplayer.controls.tizen",
      98: "provider.hlsjs",
      168: "jwplayer.amp",
      207: "jwplayer.core.controls.html5",
      250: "provider.html5",
      347: "vttparser",
      365: "related",
      371: "provider.shaka",
      493: "jwplayer.core.controls.polyfills",
      520: "provider.airplay",
      581: "jwplayer.core.controls",
      605: "jwplayer.core.controls.polyfills.html5",
      681: "jwplayer.core",
      716: "jwplayer.controls",
      926: "jwplayer.stats",
      943: "polyfills.intersection-observer",
      977: "provider.cast"
    }[e] + ".js";
  }, i.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, e = {}, t = "jwplayer:", i.l = function (n, r, o, s) {
    if (e[n]) e[n].push(r);else {
      var a, l;
      if (void 0 !== o) for (var c = document.getElementsByTagName("script"), u = 0; u < c.length; u++) {
        var d = c[u];

        if (d.getAttribute("src") == n || d.getAttribute("data-webpack") == t + o) {
          a = d;
          break;
        }
      }
      a || (l = !0, (a = document.createElement("script")).charset = "utf-8", a.timeout = 55, i.nc && a.setAttribute("nonce", i.nc), a.setAttribute("data-webpack", t + o), a.src = n), e[n] = [r];

      var p = function p(t, r) {
        a.onerror = a.onload = null, clearTimeout(h);
        var i = e[n];
        if (delete e[n], a.parentNode && a.parentNode.removeChild(a), i && i.forEach(function (e) {
          return e(r);
        }), t) return t(r);
      },
          h = setTimeout(p.bind(null, void 0, {
        type: "timeout",
        target: a
      }), 55e3);

      a.onerror = p.bind(null, a.onerror), a.onload = p.bind(null, a.onload), l && document.head.appendChild(a);
    }
  }, i.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, i.nmd = function (e) {
    return e.paths = [], e.children || (e.children = []), e;
  }, i.p = "", function () {
    var e = {
      313: 0
    };

    i.f.j = function (t, n) {
      var r = i.o(e, t) ? e[t] : void 0;
      if (0 !== r) if (r) n.push(r[2]);else {
        var o = new Promise(function (n, i) {
          return r = e[t] = [n, i];
        });
        n.push(r[2] = o);
        var s = i.p + i.u(t),
            a = new Error();
        i.l(s, function (n) {
          if (i.o(e, t) && (0 !== (r = e[t]) && (e[t] = void 0), r)) {
            var o = n && ("load" === n.type ? "missing" : n.type),
                s = n && n.target && n.target.src;
            a.message = "Loading chunk " + t + " failed.\n(" + o + ": " + s + ")", a.name = "ChunkLoadError", a.type = o, a.request = s, r[1](a);
          }
        }, "chunk-" + t, t);
      }
    };

    var t = function t(_t30, n) {
      var r,
          o,
          _n41 = _slicedToArray(n, 3),
          s = _n41[0],
          a = _n41[1],
          l = _n41[2],
          c = 0;

      if (s.some(function (t) {
        return 0 !== e[t];
      })) {
        for (r in a) {
          i.o(a, r) && (i.m[r] = a[r]);
        }

        if (l) l(i);
      }

      for (_t30 && _t30(n); c < s.length; c++) {
        o = s[c], i.o(e, o) && e[o] && e[o][0](), e[o] = 0;
      }
    },
        n = self.webpackChunkjwplayer = self.webpackChunkjwplayer || [];

    n.forEach(t.bind(null, 0)), n.push = t.bind(null, n.push.bind(n));
  }();
  var o = i(576);
  window.jwplayer = o["default"];
})();